var Gs = Object.defineProperty;
var Vs = (t, s, n) => s in t ? Gs(t, s, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[s] = n;
var N = (t, s, n) => (Vs(t, typeof s != "symbol" ? s + "" : s, n), n);
import { j as e } from "./react-944c88e2.js";
import { useQuery as Gt, QueryClient as ys, QueryClientProvider as Ys } from "@tanstack/react-query";
import * as Ae from "react";
import mt, { useContext as Ne, createContext as Fe, useState as R, useCallback as ke, useMemo as ct, useEffect as le, lazy as q, Suspense as me, useRef as Ss } from "react";
import { BrowserRouter as Qs, useNavigate as Js } from "react-router-dom";
import { Box as y, Stack as St, useEditableControls as Zs, ButtonGroup as Xs, IconButton as ft, useToast as en, Tooltip as Ct, Skeleton as Vt, Editable as tn, EditablePreview as sn, useColorModeValue as bs, HStack as He, Input as bt, EditableInput as nn, Flex as L, Text as I, Button as ie, Center as ge, Spinner as $t, Show as ws, VStack as Ke, Link as ot, Spacer as Lt, Circle as gt, Image as dt, keyframes as rn, InputGroup as Yt, InputRightElement as js, Heading as vs, FormControl as Re, FormErrorMessage as ze, RadioGroup as an, Radio as on, UnorderedList as is, ListItem as Ge, chakra as ln } from "@chakra-ui/react";
import { CheckIcon as cn, CloseIcon as Is, ChevronRightIcon as os, Icon as dn, ArrowBackIcon as un, ArrowForwardIcon as Ts } from "@chakra-ui/icons";
import { F as Je, B as xe, H as hn, T as Le, e as pn, l as ls, I as xn, m as gn, k as mn } from "./@chakra-ui-f377b543.js";
import { a as As, p as fn, k as yn, m as et, u as wt, j as Sn, g as Mt, l as bn, n as cs, h as wn } from "./useAccount-8a1c7225.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import { b as jn, f as nt, i as vn, g as In, c as Tn } from "./@firebase-868b0e52.js";
import { g as Cs, c as An, a as yt, u as Cn } from "./usehooks-ts-53aa4768.js";
import { g as jt, a as Z, l as Ze, m as Xe, d as Mn, i as kn, f as En } from "./domains-162ab8d8.js";
import { a as Ms, u as Nn } from "./features-4c20b5b5.js";
import { a as Q } from "./axios-d6123f02.js";
import { getCountryByCarrier as Ee, getDefaultLanguageByCarrier as Dn } from "./myasurion-shared.carrier.es.js";
import "./firebase-d0134a8f.js";
import { c as vt, C as Un } from "./crypto-js-1bed509f.js";
import { D as ut } from "./typescript-collections-b97a1d6d.js";
import "./node-forge-b3503c74.js";
import "./providers-e896aa48.js";
import { g as Pn } from "./contentful-ed636ee7.js";
import { h as lt } from "./moment-a2f61e40.js";
import { b as ks } from "./browser-detect-b0c87b70.js";
import { g as Rn, c as zn, e as Fn, h as _n, b as Kt, i as On, j as $n } from "./@aws-amplify-21547700.js";
import { v as Ln } from "./uuid-5adc31c9.js";
import { D as Kn } from "./aws-amplify-2a9a372d.js";
import { motion as Wn } from "framer-motion";
import { b as Hn } from "./process-481e9afe.js";
import "./myasurion-shared.ereviewSubmission.es.js";
import "./cleave.js-cf58c059.js";
import "./colornames-7577e860.js";
import { P as qn, C as Bn, L as Gn, a as Vn } from "./LockIcon-3715d1f2.js";
import { j as Yn } from "./react-responsive-carousel-5d5a6886.js";
import { n as Qt, l as ds, a as Qn, f as Oe, b as Jn, m as Zn, o as Xn, d as er, u as tr } from "./lodash-bd0366b5.js";
import { c as sr, a as Ie } from "./xstate-03560826.js";
import { u as nr } from "./@xstate-e6d7a3e3.js";
import "@emotion/react";
import "./file-saver-1aff1f79.js";
import "@react-oauth/google";
import { u as rr, F as ar, a as ir, b as kt } from "./formik-a668a7f5.js";
import { Button as Wt } from "./myasurion-shared.widgets.es.js";
import { c as Et, a as or, b as Es } from "./yup-c645f9e0.js";
import { AvatarInitials as lr } from "./myasurion-shared.profile.es.js";
import { f as cr } from "./date-fns-9d457cca.js";
const dr = (t) => {
  var i, l;
  const s = Ne(Ms);
  if (s === void 0)
    throw new Error("useFeatureIsOn must be used within a Feature Provider");
  const n = jt(), { features: a } = s, r = (l = (i = a == null ? void 0 : a.featureList) == null ? void 0 : i[n ?? "device_protection"]) == null ? void 0 : l.findIndex(
    (c) => (c == null ? void 0 : c.key) === t
  );
  return r ? r > -1 : !1;
}, Jt = Fe({
  isOpen: !1,
  setIsOpen: () => {
  },
  isNotifsOpen: !1,
  setIsNotifsOpen: () => {
  },
  config: void 0
}), Ns = ({
  children: t,
  config: s
}) => {
  const [n, a] = R(!1), [r, i] = R(!1), l = ke(a, []), c = ke(i, []), o = ct(() => ({
    isOpen: n,
    setIsOpen: l,
    isNotifsOpen: r,
    setIsNotifsOpen: c,
    config: s
  }), [n, r, l, c, s]);
  return /* @__PURE__ */ e.jsx(Jt.Provider, { value: o, children: t });
}, ur = mt.memo(Ns), hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HeaderContext: Jt,
  HeaderProvider: Ns,
  default: ur
}, Symbol.toStringTag, { value: "Module" })), Ds = () => {
  const t = Ne(Jt);
  if (t === void 0)
    throw new Error("useHeader must be used within a HeaderProvider");
  const { isOpen: s, setIsOpen: n, isNotifsOpen: a, setIsNotifsOpen: r, config: i } = t;
  return {
    headerIsOpen: s,
    updateHeaderIsOpen: n,
    notificationsIsOpen: a,
    updateNoficationsIsOpen: r,
    config: i
  };
}, pr = (t, s) => {
  var l, c, o;
  const n = Ne(Ms);
  if (n === void 0)
    throw new Error("useDisabledFeature must be used within a Feature Provider");
  const a = jt(), { features: r } = n, i = (c = (l = r == null ? void 0 : r.featureList) == null ? void 0 : l[a ?? "device_protection"]) == null ? void 0 : c.find(
    (h) => (h == null ? void 0 : h.key) === t
  );
  return (o = i == null ? void 0 : i.disabledFeatures) == null ? void 0 : o.includes(s);
}, Zt = Fe({
  refetch: async () => {
  },
  notifications: [],
  setNotifications: () => {
  },
  updateClients: () => {
  },
  isNotificationsLoading: !1,
  promptCount: 0
}), Us = Z(), xr = Ee(Us), gr = (t) => {
  const s = As();
  return {
    token: s.token,
    "x-api-key": t,
    "x-asurion-client": Us,
    "x-asurion-cc": xr.code,
    authorization: s.authorization,
    id: s.userId
  };
}, Ps = async (t, s, n, a, r) => {
  const i = gr(r == null ? void 0 : r.apiKey);
  return (await Q.get(
    `${r == null ? void 0 : r.apiBaseUrl}/online/notifications?cid=${t}&aid=${s}&agreementId=${n}`,
    {
      headers: {
        ...i,
        data: a
      }
    }
  )).data.body;
}, mr = ({
  children: t,
  apiKey: s,
  apiBaseUrl: n
}) => {
  const [a, r] = R([]), [i, l] = R(""), [c, o] = R(""), [h, x] = R(""), [f, b] = R(""), [C, v] = R(0), [M] = Cs("data", ""), {
    data: g,
    isLoading: j,
    refetch: S
  } = Gt({
    queryKey: ["notificationsData", i, c, h],
    queryFn: () => i === "" || c === "" || h === "" || f === "" ? [] : Ps(
      i,
      c,
      h,
      f,
      { apiKey: s, apiBaseUrl: n }
    ).then((d) => d).catch(() => [])
  }), k = ke(
    (d) => {
      d != null && d.cid && l(d == null ? void 0 : d.cid), d != null && d.aid && o(d == null ? void 0 : d.aid), d != null && d.agreementId && x(d == null ? void 0 : d.agreementId);
    },
    []
  ), w = async (d, D, U) => {
    if (i === "" || c === "" || h === "") {
      k({ cid: d, aid: D, agreementId: U });
      return;
    } else {
      S();
      return;
    }
  };
  return le(() => {
    M && M !== "" && b(M);
  }, [M]), le(() => {
    if (g) {
      r(g);
      let d = 0;
      Array.isArray(g) && g.length > 0 && (d = g == null ? void 0 : g.reduce((D, U) => (U == null ? void 0 : U.IsResolved) === "N" ? D + 1 : D, 0)), v(d);
    }
  }, [g]), /* @__PURE__ */ e.jsx(
    Zt.Provider,
    {
      value: {
        refetch: w,
        promptCount: C,
        notifications: a,
        setNotifications: r,
        updateClients: k,
        isNotificationsLoading: j
      },
      children: t
    }
  );
}, fr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NotificationsContext: Zt,
  NotificationsProvider: mr,
  getNotifications: Ps
}, Symbol.toStringTag, { value: "Module" })), yr = () => {
  const t = Ne(Zt);
  if (t === void 0)
    throw new Error("useNotifications must be used within a Notifications Provider");
  const {
    notifications: s,
    setNotifications: n,
    isNotificationsLoading: a,
    updateClients: r,
    refetch: i,
    promptCount: l
  } = t;
  return {
    notifications: s,
    updateNotifications: n,
    isNotificationsLoading: a,
    updateClients: r,
    fetchNotifications: i,
    promptCount: l
  };
}, Rs = (t, s) => {
  const n = ke(() => {
    if (typeof window > "u")
      return s;
    try {
      const c = window.sessionStorage.getItem(t);
      return c ? fn(c) : s;
    } catch (c) {
      return console.warn(`Error reading sessionStorage key “${t}”:`, c), s;
    }
  }, [s, t]), [a, r] = R(n), i = An((c) => {
    typeof window > "u" && console.warn(
      `Tried setting sessionStorage key “${t}” even though environment is not a client`
    );
    try {
      const o = c instanceof Function ? c(a) : c;
      window.sessionStorage.setItem(t, JSON.stringify(o)), r(o), window.dispatchEvent(new Event("session-storage"));
    } catch (o) {
      console.warn(`Error setting sessionStorage key “${t}”:`, o);
    }
  });
  le(() => {
    r(n());
  }, []);
  const l = ke(
    (c) => {
      c != null && c.key && c.key !== t || r(n());
    },
    [t, n]
  );
  return yt("storage", l), yt("session-storage", l), [a, i];
}, Sr = Qt;
function zs(t, s) {
  const n = br(s, () => {
  }), a = [], r = Object.keys(s), i = Object.values(s);
  return Ae.Children.forEach(t, (l) => {
    if (!Ae.isValidElement(l)) {
      a.push(l);
      return;
    }
    const c = i.findIndex((h) => l.type === h);
    if (c === -1) {
      a.push(l);
      return;
    }
    const o = r[c];
    if (n[o]) {
      Sr(
        !0,
        `Found duplicate "${String(o)}" slot. Only the first will be rendered.`
      );
      return;
    }
    n[o] = l;
  }), [n, a];
}
function br(t, s) {
  return Object.keys(t).reduce((n, a) => (n[a] = s(t[a]), n), {});
}
const wr = () => {
  const { data: t } = ce(), { theme: s } = t, { colors: n } = s, { bannerGradient: a } = n, r = {
    background: a
  };
  return (
    // <Box h="full" id={'myasurion-portal-suspense'}>
    //     <Stack
    //         h="100vh"
    //         w="full"
    //         justifyContent="center"
    //         alignItems="center"
    //         px={4}
    //         textAlign={'center'}
    //     >
    //         <Header
    //             top={0}
    //             signOutProps={{ styleProps: { margin: '0 auto' } }}
    //             zIndex={'999999'}
    //             account={{ profileId: '', userId: '' }}
    //         />
    /* @__PURE__ */ e.jsxs("div", { className: "waveLoader", children: [
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r }),
      /* @__PURE__ */ e.jsx("div", { className: "wave", style: r })
    ] })
  );
}, jr = () => /* @__PURE__ */ e.jsx(y, { h: "full", id: "myasurion-portal-suspense", children: /* @__PURE__ */ e.jsxs(
  St,
  {
    h: "100vh",
    w: "full",
    justifyContent: "center",
    alignItems: "center",
    px: 4,
    textAlign: "center",
    children: [
      /* @__PURE__ */ e.jsx(
        Na,
        {
          top: 0,
          signOutProps: { styleProps: { margin: "0 auto" } },
          zIndex: "999999",
          account: { profileId: "", userId: "" }
        }
      ),
      /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(wr, {}) })
    ]
  }
) }), vr = q(() => import("./index-e2b7a19f.js").then((t) => ({ default: t.CognitoAuthProvider }))), Ir = q(() => Promise.resolve().then(() => hr).then((t) => ({ default: t.HeaderProvider }))), Tr = q(() => Promise.resolve().then(() => fr).then((t) => ({ default: t.NotificationsProvider }))), Ar = q(() => Promise.resolve().then(() => ja).then((t) => ({ default: t.ChatProvider }))), Cr = q(() => import("./features-4c20b5b5.js").then((t) => t.b).then((t) => ({ default: t.default }))), Mr = q(() => import("./FullStoryProvider-ef840ec4.js").then((t) => ({ default: t.default }))), kr = q(() => Promise.resolve().then(() => Hr).then((t) => ({ default: t.TextScriptProvider }))), Er = q(() => import("./OnBoardingProvider-500965dc.js")), Nr = q(() => import("./ConfigProvider-41e9adbf.js").then((t) => ({ default: t.default }))), Dr = new ys({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
yn();
const Ur = ({
  env: t,
  children: s,
  config: n,
  onBoardingSteps: a,
  onBoardingProps: r,
  srcStrings: i
}) => {
  const l = ct(() => t == null ? void 0 : t.baseUrl, [t]), c = ct(() => Dr, []);
  return /* @__PURE__ */ e.jsx(Ys, { client: c, children: /* @__PURE__ */ e.jsx(Qs, { basename: l, children: /* @__PURE__ */ e.jsx(Nr, { env: t, children: /* @__PURE__ */ e.jsx(
    me,
    {
      fallback: (
        // carrier === 'starhub' || carrier === 'celcom' ? (
        //     <WaveLoader />
        // ) : (
        /* @__PURE__ */ e.jsx(jr, {})
      ),
      children: /* @__PURE__ */ e.jsx(Cr, { config: n, children: /* @__PURE__ */ e.jsx(Ir, { config: n, children: /* @__PURE__ */ e.jsx(
        Tr,
        {
          apiKey: t == null ? void 0 : t.apiKey,
          apiBaseUrl: t == null ? void 0 : t.apiBaseUrl,
          children: /* @__PURE__ */ e.jsx(Mr, { children: /* @__PURE__ */ e.jsx(
            kr,
            {
              moduleId: (t == null ? void 0 : t.moduleId) || "myAsurionShared",
              isEnabled: (t == null ? void 0 : t.enableTranslations) ?? !1,
              apiEnv: {
                hmacKey: t.hmacKey,
                apiUrl: t.apiBaseUrl
              },
              srcStrings: i,
              children: /* @__PURE__ */ e.jsx(
                Ar,
                {
                  config: n,
                  baseApiConfig: {
                    baseEndpoint: t.apiBaseUrl,
                    apiKey: t == null ? void 0 : t.apiKey,
                    hmacKey: t == null ? void 0 : t.hmacKey
                  },
                  children: /* @__PURE__ */ e.jsx(vr, { config: n, children: /* @__PURE__ */ e.jsx(
                    Er,
                    {
                      steps: a ?? [],
                      onBoardingProps: r,
                      children: s
                    }
                  ) })
                }
              )
            }
          ) })
        }
      ) }) })
    }
  ) }) }) });
}, co = mt.memo(Ur), uo = "configStart", ho = "configData", po = 36e5, Pr = [
  { code: "EN", locale: "en-US", name: "English" },
  { code: "CN", locale: "zh-Hant-TW", name: "Chinese" },
  { code: "TH", locale: "th-TH", name: "Thai" },
  { code: "KO", locale: "ko-KR", name: "Korean" },
  { code: "MY", locale: "ms-MY", name: "Bahasa" }
], Fs = {
  local: "true",
  partner: "myasurion",
  program: "myasurion",
  features: {},
  urls: {
    profile: "profile"
  },
  languagesAvailable: [{ code: "EN", locale: "en-US", name: "English" }],
  languages: [
    {
      code: "EN",
      name: "English"
    },
    {
      code: "CN",
      name: "Chinese"
    },
    {
      code: "TH",
      name: "Thai"
    },
    {
      code: "KO",
      name: "Korean"
    },
    {
      code: "MY",
      name: "Bahasa"
    }
  ],
  mainMenu: [
    {
      name: "Tech care preferences",
      code: "techcare",
      url: "profile/techcare"
    },
    {
      name: "Notifications",
      code: "notifications",
      url: "profile/notifications"
    },
    {
      name: "Share feedback",
      code: "feedback",
      url: "profile/feedback"
    }
  ],
  theme: {
    logo: "/images/carriers/asurion/asurion-logo.svg",
    header: {
      logo: "/images/carriers/asurion/asurion.svg",
      bg: "white"
    },
    notification: {
      discount: "/images/carriers/asurion/discount.svg",
      exclusives: "/images/carriers/asurion/exclusives.svg",
      newstuff: "/images/carriers/asurion/new-stuff.svg",
      order: "/images/carriers/asurion/order.svg"
    },
    colors: {
      primary: "#8223D2",
      onPrimary: "#8223D2",
      accent: "#8223D2",
      bannerGradient: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
    },
    components: {
      profileBanner: {
        bg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
      },
      serviceRequestBtn: {
        w: "full",
        minW: "287px",
        p: "12px 20px",
        colorScheme: "primary",
        variant: "solid"
      },
      chat: {
        headerBg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5",
        headerColor: "white",
        btnTxtColor: "#09411D",
        chatIcon: "/images/carriers/asurion/expert-default-mid.png",
        sendIcon: "/images/carriers/asurion/chat-send.svg",
        agentIcon: "/images/carriers/asurion/agent-chat-icon.svg",
        thankYouIcon: "/images/carriers/asurion/chat-thankyou.svg"
      }
    }
  }
}, Rr = Fe({
  data: Fs,
  isLoading: !1,
  refetchConfig: async () => ({}),
  updateConfig: () => {
  },
  saveConfig: () => {
  },
  conf: { hmacKey: "", url: "", baseApi: "" },
  isInit: !1
});
Fe({
  config: Fs
});
const tt = /* @__PURE__ */ new Map();
tt.set("myAsurionPortal", "/portal");
tt.set("myAsurionSRSwap", "/swap");
tt.set("myAsurionAuth", "/login");
tt.set("myAsurionProfile", "/profile");
tt.set("myAsurionArticle", "/articles");
const zr = (t) => tt.get(t), ce = () => {
  const t = Ne(Rr);
  if (t === void 0)
    throw new Error("useConfig must be used within a ConfigProvider");
  const s = jt();
  function n(a) {
    var i;
    let r;
    try {
      r = Object.fromEntries(
        (i = Object.entries(a)) == null ? void 0 : i.map(([l, c]) => {
          const o = s === "repair" ? zr(t.module ?? "myAsurionPortal") : "";
          return typeof c == "object" && c !== null ? Array.isArray(c) ? [
            l,
            c.map((h) => (typeof h == "string" && h.startsWith("/images/") && o + h, h))
          ] : [l, n(c)] : typeof c == "string" && c.startsWith("/images/") ? [l, o + c] : [l, c];
        })
      );
    } catch {
      r = a;
    }
    return r;
  }
  return {
    ...t,
    data: n(t.data)
  };
};
var us;
((t) => {
  let s = null;
  class n {
    constructor(r) {
      N(this, "_config");
      N(this, "_app");
      N(this, "_remoteConfig");
      N(this, "_isActivated", !1);
      this._config = r, this._app = this._initialize(r), this._remoteConfig = jn(this._app), this._remoteConfig.settings.minimumFetchIntervalMillis = 3e3, this._remoteConfig.defaultConfig = {}, nt(this._remoteConfig);
    }
    async fetchAndActivate(r) {
      await nt(r), this._isActivated = !0;
    }
    _initialize(r) {
      return vn(r ?? this._config);
    }
    getValue(r) {
      return this._isActivated === !1 && nt(this._remoteConfig), In(this._remoteConfig, r);
    }
    async fetchValue(r) {
      return await nt(this._remoteConfig), this.getValue(r);
    }
    async fetchAll() {
      return await nt(this._remoteConfig), Tn(this._remoteConfig);
    }
  }
  t.MARemoteConfig = n, t.initializeRemoteConfig = (a) => {
    s || (s = new n(a));
  }, t.getConfigValue = (a) => {
    if (s)
      return s.getValue(a);
  }, t.fetchValue = (a) => {
    if (s)
      return s.fetchValue(a);
  }, t.fetchAll = () => {
    if (s)
      return s.fetchAll();
  };
})(us || (us = {}));
const Fr = "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGhlaWdodD0iMWVtIiB3aWR0aD0iMWVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yNTcuNyA3NTJjMiAwIDQtLjIgNi0uNUw0MzEuOSA3MjJjMi0uNCAzLjktMS4zIDUuMy0yLjhsNDIzLjktNDIzLjlhOS45NiA5Ljk2IDAgMCAwIDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAgMCA5LjQgMjkuOGM2LjYgNi40IDE0LjkgOS45IDIzLjggOS45em02Ny40LTE3NC40TDY4Ny44IDIxNWw3My4zIDczLjMtMzYyLjcgMzYyLjYtODguOSAxNS43IDE1LjYtODl6TTg4MCA4MzZIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzNmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtMzZjMC0xNy43LTE0LjMtMzItMzItMzJ6Ij48L3BhdGg+PC9zdmc+", _r = ({ handleSave: t, handleCancel: s }) => {
  const { isEditing: n, getSubmitButtonProps: a, getCancelButtonProps: r } = Zs();
  return n ? /* @__PURE__ */ e.jsxs(
    Xs,
    {
      justifyContent: "end",
      size: "xs",
      w: "max-content",
      spacing: "0.5",
      mt: 0,
      flex: "1",
      borderRadius: "5px",
      variant: "teal",
      py: "2",
      children: [
        /* @__PURE__ */ e.jsx(
          ft,
          {
            "aria-label": "Check icon",
            icon: /* @__PURE__ */ e.jsx(cn, {}),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...a({ onClick: t })
          }
        ),
        /* @__PURE__ */ e.jsx(
          ft,
          {
            "aria-label": "Close icon",
            icon: /* @__PURE__ */ e.jsx(Is, { boxSize: 2 }),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...r({ onClick: s })
          }
        )
      ]
    }
  ) : null;
}, Xt = ({ method: t = "GET", httpPath: s = "/", token: n }, a) => vt.HmacSHA512(`${t}_${s}_${n}`, a).toString();
function xo(t, s) {
  const n = Z(), a = Ee(n);
  return Q.create({
    baseURL: s ?? `${{}.VITE_MYASURION_API_BASE_URL}${{}.VITE_MYASURION_API_BASE_PATH}` ?? {}.VITE_API_BASE_URL,
    headers: {
      "x-asurion-client": n,
      "x-asurion-cc": a.code
    },
    ...t
  });
}
new ys({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
var K;
((t) => {
  class s {
    /**
     * Provide group/path id and module id. Name may be the same as the group/path id.
     * @param {string} id: Group/section id
     * @param {string} moduleId: Module Id
     * @param {string} name: Group/section name. Equivalent to group/section id
     * @param {StringManager} provider?: Internal StringManager dependency
     */
    constructor(u, T, m, E) {
      /**
       * Group/Section Id
       */
      N(this, "id");
      /**
       * Module Id
       */
      N(this, "moduleId");
      /**
       * Group/section name. Equivalent to group/section id
       */
      N(this, "name");
      /**
       * Internal StringManager
       */
      N(this, "_provider");
      /**
       * Contains the map of strings for the specific group. Accepts string/path id with corresponding String
       */
      N(this, "stringMap", new ut());
      this.id = u, this.moduleId = T, this._provider = E, this.name = m;
    }
    /**
     * Gets string from a given string/path id
     * @param {string} id: String/path id
     * @returns {String | undefined} String | undefined
     */
    getString(u) {
      return this.stringMap.getValue(u);
    }
    get provider() {
      return this._provider;
    }
    /**
     * Adds a String to the string map
     * @param {Localization.String} theString Adds the String to the string map.
     */
    addString(u) {
      this.stringMap.setValue(u.id, u);
    }
    replaceString(u) {
      this.stringMap.remove(u.id), this.stringMap.setValue(u.id, u);
    }
    get strings() {
      const u = [];
      return this.stringMap.forEach((T, m) => {
        u.push({ key: T, value: m });
      }), u;
    }
  }
  t.Group = s;
  class n {
    /**
     * Provide the string/path id and internal id
     * @param {string} id String/path id
     * @param {string|null} internalId?: Unique internal id
     * @param {Group | null} parent?: Parent Group/Section of the String
     */
    constructor(u, T, m) {
      /**
       * Unique internal id for the string
       */
      N(this, "_internalId");
      /**
       * The text content of the given String
       */
      N(this, "_content");
      /**
       * String/path id
       */
      N(this, "id");
      /**
       * The parent Group/Section of the String
       *
       */
      N(this, "parent");
      /**
       * The usage for the string. Can be either static or dynamic
       */
      N(this, "usage");
      N(this, "inView");
      /**
       * The description for the string
       */
      N(this, "description");
      /**
       * Internal update callbacks array
       */
      N(this, "_callbacks", []);
      this.id = u, this.parent = m, this._internalId = T;
    }
    /**
     * Provides the group/section id of the string
     * @returns {string|undefined} Group/Section Id of the String
     */
    get sectionId() {
      var u;
      return (u = this.parent) == null ? void 0 : u.id;
    }
    get internalId() {
      return this._internalId;
    }
    set content(u) {
      this._content = u;
    }
    get content() {
      return this._content;
    }
    /**
     * Adds an update callback function to internal callbacks array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(u) {
      this._callbacks.push(u);
    }
  }
  t.String = n;
  class a {
    constructor(u, T, m, E, O, z, F, Y) {
      N(this, "_initialDefaultLoadedText");
      N(this, "_script");
      N(this, "_id");
      N(this, "_sectionId");
      N(this, "_moduleId");
      N(this, "_languageCode");
      N(this, "_partnerId");
      N(this, "_status");
      N(this, "_dynamicValues");
      this._initialDefaultLoadedText = u, this._script = T, this._id = m, this._sectionId = E, this._moduleId = O, this._languageCode = z, this._partnerId = F, this._status = "initial", this._dynamicValues = Y;
    }
    replaceTextPlaceHolders(u, T) {
      return u.replace(
        /\{(\d+)\}/g,
        (m, E) => typeof T[E - 1] < "u" ? T[E - 1] : `{${E}}`
      );
    }
    get value() {
      return {
        defaultLoadedText: this._initialDefaultLoadedText,
        text: this.replaceTextPlaceHolders(this.script, this._dynamicValues ?? []),
        id: this._id,
        sectionId: this._sectionId,
        moduleId: this._moduleId,
        languageCode: this._languageCode,
        partnerId: this._partnerId
      };
    }
    set status(u) {
      this._status = u;
    }
    get status() {
      return this._status;
    }
    set script(u) {
      this._script = u;
    }
    get script() {
      return this._script;
    }
  }
  t.UserScript = a;
  class r {
    /**
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @param {IDataLoader} loader: IDataLoader
     * @param {IDataPersister} persister: IDataPersister
     * @param {IDataCreator} creator: IDataCreator
     */
    constructor(u, T, m, E, O, z) {
      /**
       * Internal partner id
       */
      N(this, "_partnerId");
      /**
       * Internal module id
       */
      N(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      N(this, "_languageCode");
      N(this, "loader");
      N(this, "persister");
      N(this, "manipulator");
      /**
       * Internal listeners array of update callback functions
       */
      N(this, "listeners", []);
      /**
       * Contains the map of groups/sections for the specific module.
       *
       * Accepts group/section id with corresponding Group array
       */
      N(this, "_groupMap");
      N(this, "_id");
      N(this, "_initFetch");
      N(this, "_completeFetch");
      N(this, "_srcStrings");
      this.loader = E, this.manipulator = z, this.persister = O, this._groupMap = new ut(), this._partnerId = u, this._moduleId = T, this._languageCode = m, this._id = (+/* @__PURE__ */ new Date()).toString(), this._initFetch = !1, this._completeFetch = !1;
    }
    /**
     * Adds an update callback function to internal listeners array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(u) {
      this.listeners.push(u);
    }
    async updateString(u) {
      return await this.persister.persistString(u);
    }
    async updateSection(u) {
      return await this.persister.persistStrings(u);
    }
    /**
     * Loads all sections.
     *
     * Creates a new group/section map. Loads sections from the data loader/store.
     * Checks the internal group map and assigns the sections to the created new section map.
     * Returns the new map with updates sections.
     *
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code
     * @returns {Dictionary<string, Group[]>} Dictionary<string, Group[]> - Group/Section Map
     */
    async loadAllSections(u, T, m, E) {
      let O, z = new ut();
      try {
        const F = await this.loader.loadSections(
          u,
          T,
          m,
          E
        );
        let Y;
        for (const ae of F)
          Y = ae.id, this._groupMap.containsKey(Y) || this._groupMap.setValue(Y, []), O = this._groupMap.getValue(Y), O && O.findIndex((je) => je.id === Y) === -1 && O.push(ae);
        z = this._groupMap;
      } catch (F) {
        console.log(F);
      }
      return z;
    }
    /**
     * Gets Group/Section from given id
     * @param {any} sectionId: Section/Group Id
     * @returns {Promise<Group | null>} Promise<Group | null>
     */
    async getGroup(u, T) {
      let m = [], E = null;
      const O = u;
      if (this._initFetch || (this._initFetch = !0, this._groupMap = await this.loadAllSections(
        this._partnerId,
        this._moduleId,
        this._languageCode,
        T
      ), this._completeFetch = !0), this._initFetch && this._completeFetch) {
        if (m = this._groupMap.getValue(O), m === void 0)
          return E;
        for (const z of m)
          if (z.id === u) {
            E = z;
            break;
          }
        return E;
      } else
        return new Promise((z, F) => {
          try {
            const Y = setInterval(() => {
              if (m = this._groupMap.getValue(O), m && m !== void 0) {
                for (const ae of m)
                  if (ae.id === u) {
                    E = ae;
                    break;
                  }
                z(E), clearInterval(Y);
              }
            }, 1500);
          } catch {
            F(null);
          }
        });
    }
    async createString(u, T, m, E, O, z, F) {
      this.manipulator.createString(
        u,
        T,
        m,
        E,
        O,
        z.profileId,
        F
      );
    }
    async updateStringEntry(u, T, m, E, O) {
      const { isUpdated: z, body: F } = await this.manipulator.updateString(
        u,
        T,
        m,
        E,
        O.profileId
      );
      return z && F && this._groupMap.forEach((Y, ae) => {
        const je = ae.map((De) => (De.strings.forEach(({ key: qe, value: Ce }) => {
          const ue = F.text.find(
            (_e) => _e.internalId === Ce.internalId
          );
          if (qe && ue) {
            const _e = new n(
              ue.path,
              ue.internalId
            );
            _e.content = ue.text, _e.usage = ue.usage, _e.description = ue.description, De.replaceString(_e);
          }
        }), De));
        this._groupMap.setValue(Y, je);
      }), { isUpdated: z, body: F };
    }
  }
  t.StringManager = r;
  class i {
    constructor(u, T, m) {
      /**
       * Internal partner id
       */
      N(this, "_partnerId");
      /**
       * Internal module id
       */
      N(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      N(this, "_languageCode");
      N(this, "_scripts");
      N(this, "subscribers");
      this._scripts = [], this._partnerId = u, this._moduleId = T, this._languageCode = m, this.subscribers = [];
    }
    getScript(u, T) {
      return this._scripts.find(
        (m) => m.value.id === u && m.value.languageCode === T
      );
    }
    createScript(u, T, m, E, O, z, F) {
      const Y = new a(
        u,
        u,
        T,
        m,
        E,
        O,
        z,
        F
      );
      return this._scripts.findIndex(
        (ae) => ae.value.id === T && ae.value.languageCode === O
      ) === -1 && this._scripts.push(Y), Y;
    }
    updateScript(u, T, m, E, O) {
      const z = this._scripts.findIndex(
        (F) => F.value.id === T && F.value.sectionId === m && F.value.languageCode === O
      );
      z > -1 && (this._scripts[z].value.text = u, this._scripts[z].script = u, this._scripts[z].status = E, this.subscribers.forEach((F) => {
        F(this._scripts);
      }));
    }
    get scripts() {
      return this._scripts;
    }
    subscribe(u) {
      return this.subscribers.push(u), () => {
        this.subscribers = this.subscribers.filter((T) => T !== u);
      };
    }
  }
  t.ScriptManager = i;
  class l {
    constructor() {
      N(this, "_stringsMap");
      this._stringsMap = new ut();
    }
    addStringManager(u, T) {
      this._stringsMap.containsKey(u) || this._stringsMap.setValue(u, T);
    }
  }
  t.LanguageManager = l;
  class c {
    /**
     * Provide module Id to the parser
     * @param {any} moduleId: Module Id
     */
    constructor(u) {
      /**
       * Internal module id
       */
      N(this, "_moduleId");
      this._moduleId = u;
    }
    /**
     * Parses section from provided data
     * @param {any} data:any
     * @returns {Group[]} Group[]
     */
    parseSections(u) {
      const T = [];
      let m;
      const E = JSON.parse(JSON.stringify(u));
      for (const O of E) {
        m = new s(O.id, this._moduleId, O.id);
        for (const z of O.text) {
          const F = new n(
            z.path,
            z.internalId,
            m
          );
          F.content = z.text, F.usage = z.usage, F.description = z.description, m.addString(F);
        }
        T.push(m);
      }
      return T;
    }
  }
  class o {
    /**
     * @param {any} baseUrl: Base URL of the Strings API. Should include the base path. e.g. {url}/api/v1
     * @param {any} hmacKey: HMAC Key used to generate headers
     */
    constructor(u, T, m, E, O, z, F) {
      /**
       * Internal base url property
       */
      N(this, "_baseUrl");
      /**
       * Internal hmac key property
       */
      N(this, "_hmacKey");
      /**
       * Internal authorization property
       *
       * Used in string modification headers
       */
      N(this, "_authorization");
      /**
       * Internal token property
       *
       * Used in string modification headers
       */
      N(this, "_token");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      N(this, "_profileId");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      N(this, "_moduleId");
      N(this, "_initializedCallback");
      N(this, "_config", null);
      N(this, "_isDevToolsEnabled");
      this._baseUrl = u, this._hmacKey = T, this._authorization = m, this._token = E, this._profileId = O, this._moduleId = z, this._isDevToolsEnabled = F;
    }
    async initialize() {
      return !0;
    }
    get loader() {
      return this;
    }
    get persister() {
      return this;
    }
    /**
     * Generates GET Headers for getStrings API
     * @param {string} targetUrl: Target URL /api getStrings path
     * @param {string} hmacKey: HMAC Key
     */
    generateGetHeaders(u, T, m = "GET") {
      const E = Z(), O = Ee(E), z = +/* @__PURE__ */ new Date(), F = vt.SHA256(z.toString()).toString();
      return {
        Authorization: Xt(
          {
            httpPath: u,
            method: m,
            token: F || ""
          },
          T
        ),
        token: F,
        t: z,
        "x-asurion-client": E,
        "x-asurion-cc": O.code
      };
    }
    /**
     * Loads Sections from getStrings (GET) API. Implemented from IDataLoader
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @returns {Group[]} Group[] - Sections/Groups
     */
    async loadSections(u, T, m, E) {
      const O = `${this._baseUrl}/content/strings?moduleId=${T}&language=${m}&partnerId=${u}&preview=true`, z = this.generateGetHeaders(
        "/api/v1/content/strings",
        this._hmacKey
      ), F = {
        method: "GET",
        url: O,
        headers: z
      }, Y = new c(T);
      if (E && Array.isArray(E == null ? void 0 : E[m]))
        return Y.parseSections(E == null ? void 0 : E[m]);
      {
        const ae = await Q(F);
        return Y.parseSections(ae.data.body);
      }
    }
    async createString(u, T, m, E, O, z) {
      E = (m == null ? void 0 : m.toLowerCase()) === "global" ? "global" : E;
      const F = +/* @__PURE__ */ new Date(), Y = Z(), je = Ze() ? Xe() : Z(), De = Ee(Y), Ce = {
        method: "POST",
        url: `${this._baseUrl}/content/strings?moduleId=${E}`,
        headers: {
          authorization: O.authorization,
          token: O.token,
          t: F,
          id: z,
          "x-asurion-client": Y,
          "x-asurion-cc": De.code
        },
        data: JSON.stringify({
          moduleId: E,
          sectionId: m,
          pathId: `${je}-${T}`,
          partnerId: je,
          value: u,
          usage: "static",
          autoPublish: "true"
        })
      };
      if (E === "myAsurionAuth") {
        const ue = this.generateGetHeaders(
          "/api/v1/content/strings",
          this._hmacKey,
          "POST"
        );
        Ce.headers = ue;
      }
      return await Q(Ce), !0;
    }
    async updateString(u, T, m, E, O) {
      var Ce;
      const z = +/* @__PURE__ */ new Date(), F = Z(), ae = Ze() ? Xe() : Z(), je = Ee(F), qe = {
        method: "PUT",
        url: `${this._baseUrl}/content/strings`,
        headers: {
          authorization: E.authorization,
          token: E.token,
          t: z,
          id: O,
          "x-asurion-client": F,
          "x-asurion-cc": je.code
        },
        data: JSON.stringify({
          entryId: T,
          value: u,
          language: m,
          partnerId: ae
        })
      };
      try {
        const ue = await Q(qe);
        if (ue.data && ((Ce = ue.data) != null && Ce.body))
          return {
            isUpdated: !0,
            body: ue.data.body
          };
        throw "String update failed";
      } catch {
        return {
          isUpdated: !0,
          body: void 0
        };
      }
    }
    get config() {
      return this._config = {
        baseUrl: this._baseUrl,
        hmacKey: this._hmacKey,
        authorization: this._authorization,
        token: this._token,
        profileId: this._profileId,
        moduleId: this._moduleId
      }, this._config;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistString(u) {
      throw new Error("Method not implemented.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistStrings(u) {
      throw new Error("Method not implemented.");
    }
    setInitCallback(u) {
      if (this._initializedCallback = u, this._moduleId === "myAsurionAuth") {
        if (this.config !== null && this.config.moduleId !== "")
          try {
            this._initializedCallback(this.config);
          } catch {
          }
      } else if (this.config !== null && this.config.moduleId !== "" && this.config.authorization !== "")
        try {
          this._initializedCallback(this.config);
        } catch {
        }
    }
    setConfig(u) {
      if (this._config = u, this._authorization === "" && (this._authorization = (u == null ? void 0 : u.authorization) || ""), this._baseUrl === "" && (this._baseUrl = (u == null ? void 0 : u.baseUrl) || ""), this._hmacKey === "" && (this._hmacKey = (u == null ? void 0 : u.hmacKey) || ""), this._moduleId === "" && (this._moduleId = (u == null ? void 0 : u.moduleId) || ""), this._profileId === "" && (this._profileId = (u == null ? void 0 : u.profileId) || ""), this._token === "" && (this._token = (u == null ? void 0 : u.token) || ""), this._isDevToolsEnabled = (u == null ? void 0 : u.isDevToolsEnabled) ?? !1, this._initializedCallback !== null)
        try {
          this._initializedCallback(this._config);
        } catch {
        }
    }
  }
  t.MyAsurionLocalizationStore = o;
  let h = null, x = null, f = null, b = null, C = null, v = null, M = null, g = null, j = null, S = null, k = null, w = null, d = null, D = null, U = null, _ = null, P = null, A = null;
  function W(p, u, T, m) {
    return h === null && (h = new r(
      p,
      u,
      T,
      m,
      m,
      m
    )), h;
  }
  t.getStringManager = W;
  function se(p, u, T, m) {
    return x === null && (x = new r(
      p,
      u,
      "zh-Hant-TW",
      m,
      m,
      m
    )), x;
  }
  t.getZhStringManager = se;
  function de(p, u, T, m) {
    return f === null && (f = new r(
      p,
      u,
      "th-TH",
      m,
      m,
      m
    )), f;
  }
  t.getThStringManager = de;
  function $(p, u, T, m) {
    return b === null && (b = new r(
      p,
      u,
      "ko-KR",
      m,
      m,
      m
    )), b;
  }
  t.getKoStringManager = $;
  function ee(p, u, T, m) {
    return C === null && (C = new r(
      p,
      u,
      "ms-MY",
      m,
      m,
      m
    )), C;
  }
  t.getMyStringManager = ee;
  function ye(p, u, T, m) {
    return v === null && (v = new r(
      p,
      u,
      T,
      m,
      m,
      m
    )), v;
  }
  t.getGlobalStringManager = ye;
  function J(p, u, T, m) {
    return M === null && (M = new r(
      p,
      u,
      "zh-Hant-TW",
      m,
      m,
      m
    )), M;
  }
  t.getZhGlobalStringManager = J;
  function H(p, u, T, m) {
    return g === null && (g = new r(
      p,
      u,
      "th-TH",
      m,
      m,
      m
    )), g;
  }
  t.getThGlobalStringManager = H;
  function Se(p, u, T, m) {
    return j === null && (j = new r(
      p,
      u,
      "ko-KR",
      m,
      m,
      m
    )), j;
  }
  t.getKoGlobalStringManager = Se;
  function be(p, u, T, m) {
    return S === null && (S = new r(
      p,
      u,
      "ms-MY",
      m,
      m,
      m
    )), S;
  }
  t.getMyGlobalStringManager = be;
  function ve(p, u, T) {
    return u === "global" ? (w === null && (w = new i(p, u, T)), w) : (k === null && (k = new i(p, u, T)), k);
  }
  t.getScriptManager = ve;
  function G(p, u, T, m, E) {
    return A === null && (A = new l(), A.addStringManager("en-US", p), A.addStringManager("zh-Hant-TW", u), A.addStringManager("th-TH", T), A.addStringManager("ko-KR", m), A.addStringManager("ms-MY", E)), A;
  }
  t.getLanguageManager = G;
  function ne(p, u, T, m, E) {
    return d === null && (d = new o(
      p.apiUrl,
      p.hmacKey,
      u.authorization,
      u.token,
      T,
      m,
      E
    )), d;
  }
  t.getDataStore = ne;
  function V(p, u, T, m, E) {
    return D === null && (D = new o(
      p.apiUrl,
      p.hmacKey,
      u.authorization,
      u.token,
      T,
      m,
      E
    )), D;
  }
  t.getZhDataStore = V;
  function he(p, u, T, m, E) {
    return U === null && (U = new o(
      p.apiUrl,
      p.hmacKey,
      u.authorization,
      u.token,
      T,
      m,
      E
    )), U;
  }
  t.getThDataStore = he;
  function oe(p, u, T, m, E) {
    return _ === null && (_ = new o(
      p.apiUrl,
      p.hmacKey,
      u.authorization,
      u.token,
      T,
      m,
      E
    )), _;
  }
  t.getKoDataStore = oe;
  function re(p, u, T, m, E) {
    return P === null && (P = new o(
      p.apiUrl,
      p.hmacKey,
      u.authorization,
      u.token,
      T,
      m,
      E
    )), P;
  }
  t.getMyDataStore = re;
  function pe(p) {
    return p === "zh-Hant-TW" ? x : p === "th-TH" ? f : p === "ko-KR" ? b : p === "ms-MY" ? C : h;
  }
  t.getStringManagerInstance = pe;
  function st(p) {
    d = ne(
      p.apiEnv,
      p.authToken,
      p.profileId,
      p.moduleId,
      p.isDevToolsEnabled
    ), d.setConfig({
      baseUrl: p.apiEnv.apiUrl,
      hmacKey: p.apiEnv.hmacKey,
      authorization: p.authToken.authorization,
      token: p.authToken.token,
      profileId: p.profileId,
      moduleId: p.moduleId,
      partnerId: p.partnerId,
      isDevToolsEnabled: p.isDevToolsEnabled
    }), D = V(
      p.apiEnv,
      p.authToken,
      p.profileId,
      p.moduleId,
      p.isDevToolsEnabled
    ), D.setConfig({
      baseUrl: p.apiEnv.apiUrl,
      hmacKey: p.apiEnv.hmacKey,
      authorization: p.authToken.authorization,
      token: p.authToken.token,
      profileId: p.profileId,
      moduleId: p.moduleId,
      partnerId: p.partnerId,
      isDevToolsEnabled: p.isDevToolsEnabled
    }), U = he(
      p.apiEnv,
      p.authToken,
      p.profileId,
      p.moduleId,
      p.isDevToolsEnabled
    ), U.setConfig({
      baseUrl: p.apiEnv.apiUrl,
      hmacKey: p.apiEnv.hmacKey,
      authorization: p.authToken.authorization,
      token: p.authToken.token,
      profileId: p.profileId,
      moduleId: p.moduleId,
      partnerId: p.partnerId,
      isDevToolsEnabled: p.isDevToolsEnabled
    }), _ = oe(
      p.apiEnv,
      p.authToken,
      p.profileId,
      p.moduleId,
      p.isDevToolsEnabled
    ), _.setConfig({
      baseUrl: p.apiEnv.apiUrl,
      hmacKey: p.apiEnv.hmacKey,
      authorization: p.authToken.authorization,
      token: p.authToken.token,
      profileId: p.profileId,
      moduleId: p.moduleId,
      partnerId: p.partnerId,
      isDevToolsEnabled: p.isDevToolsEnabled
    }), P = re(
      p.apiEnv,
      p.authToken,
      p.profileId,
      p.moduleId,
      p.isDevToolsEnabled
    ), P.setConfig({
      baseUrl: p.apiEnv.apiUrl,
      hmacKey: p.apiEnv.hmacKey,
      authorization: p.authToken.authorization,
      token: p.authToken.token,
      profileId: p.profileId,
      moduleId: p.moduleId,
      partnerId: p.partnerId,
      isDevToolsEnabled: p.isDevToolsEnabled
    }), h = W(
      p.partnerId,
      p.moduleId,
      "en-US",
      d
    ), x = se(
      p.partnerId,
      p.moduleId,
      "zh-Hant-TW",
      D
    ), f = de(
      p.partnerId,
      p.moduleId,
      "th-TH",
      U
    ), b = $(
      p.partnerId,
      p.moduleId,
      "ko-KR",
      U
    ), C = ee(
      p.partnerId,
      p.moduleId,
      "ms-MY",
      P
    ), G(
      h,
      x,
      f,
      b,
      C
    );
  }
  t.initializeLocalization = st;
})(K || (K = {}));
const Ht = (t = null) => {
  if (t && t !== null) {
    const [s, n] = t.split("/");
    return [s, n];
  } else
    return [null, null];
}, It = async (t, s, n, a, r, i, l, c, o, h, x, f) => {
  const [b, C] = Ht(s);
  let v = "";
  if (b !== null && C !== null && x && x.length > 0)
    for (let M = 0; M < x.length; M++) {
      const g = await Or(
        t,
        s,
        b,
        n,
        // groupId?.toLowerCase() === 'global' ? 'global' : module,
        x[M],
        r,
        i,
        { ...l, profileId: i.id ?? l.profileId },
        c,
        o,
        h,
        f
      );
      x[M] === a && (v = g);
    }
  return we(v, h ?? []);
}, Or = async (t, s, n, a, r, i, l, c, o, h, x, f) => {
  var j;
  let b, C, v;
  r === "zh-Hant-TW" ? v = K.getZhStringManager(
    o,
    a,
    r,
    K.getDataStore(
      i,
      l,
      c.profileId,
      a,
      h
    )
  ) : r === "th-TH" ? v = K.getThStringManager(
    o,
    a,
    r,
    K.getDataStore(
      i,
      l,
      c.profileId,
      a,
      h
    )
  ) : r === "ko-KR" ? v = K.getKoStringManager(
    o,
    a,
    r,
    K.getDataStore(
      i,
      l,
      c.profileId,
      a,
      h
    )
  ) : r === "ms-MY" ? v = K.getMyStringManager(
    o,
    a,
    r,
    K.getDataStore(
      i,
      l,
      c.profileId,
      a,
      h
    )
  ) : v = K.getStringManager(
    o,
    a,
    r,
    K.getDataStore(
      i,
      l,
      c.profileId,
      a,
      h
    )
  );
  const M = K.getScriptManager(
    o,
    (n == null ? void 0 : n.toLowerCase()) === "global" ? "global" : a,
    r
  );
  C = M.getScript(s, r), C || (C = M.createScript(
    t,
    s,
    n,
    (n == null ? void 0 : n.toLowerCase()) === "global" ? "global" : a,
    r,
    o,
    x
  ));
  const g = await v.getGroup(n, f);
  return g === null ? b = null : b = g.getString(`${o}-${s}`), (b === null || !b) && (r === "en-US" && (!f || ((j = f[r]) == null ? void 0 : j.length) < 1) && await v.createString(
    t,
    s,
    n,
    a,
    l,
    c,
    o
  ), b = new K.String(s, null, g), b.content = t || "", b.onUpdateListener = $r, g && g.addString(b)), (b == null ? void 0 : b.content) || t;
}, $r = (t, s) => {
  let n;
  switch (t) {
    case "string.updated":
      n = s[0];
      break;
    default:
      n = "(loading)";
      break;
  }
  return n;
}, Lr = (t) => {
  let s;
  switch (t) {
    case "initial":
      s = "#eaf3ff";
      break;
    case "modified":
      s = "#FEEBC8";
      break;
    case "changed":
      s = "#ceecff";
      break;
    case "failed":
      s = "#FFB6C1";
      break;
    default:
      s = bs("gray.100", "gray.600");
      break;
  }
  return s;
}, we = (t, s) => !s || s.length === 0 ? t : t == null ? void 0 : t.replace(
  /\{(\d+)\}/g,
  (n, a) => typeof s[a - 1] < "u" ? s[a - 1] : `{${a}}`
), X = ({
  text: t,
  translationKey: s,
  dynamicValues: n = [],
  isFull: a = !1,
  module: r
}) => {
  var ve;
  const [i, l] = R(we(t, n)), [c, o] = R(""), [h, x] = R("initial"), [f, b] = R(t), [C, v] = R(!1), M = en(), { data: g } = ce(), { languagesAvailable: j } = g, [S] = et({
    authorization: "",
    token: "",
    id: ""
  }), [k] = wt({
    profileId: "",
    userId: ""
  }), {
    isEnabled: w,
    language: d,
    module: D,
    apiEnv: U,
    isEditingMode: _,
    isDevToolsOpen: P,
    isDevToolsEnabled: A,
    // isTranslationsLoading,
    // updateIsTranslationsLoading,
    isKeyShown: W,
    srcStrings: se
  } = Tt(), $ = Ze() ? Xe() : Z(), { isFeatureOn: ee } = Nn("showSkeleton"), ye = (G) => {
    G.key == "Enter" && J();
  }, J = async () => {
    const [G, ne] = Ht(s);
    try {
      if (G === null && ne === null)
        throw "No section id or string id provided";
      let V;
      d === "zh-Hant-TW" ? V = K.getZhStringManager(
        $,
        r ?? D,
        d,
        K.getDataStore(
          U,
          S,
          S.id ?? k.profileId,
          r ?? D,
          A
        )
      ) : d === "th-TH" ? V = K.getThStringManager(
        $,
        r ?? D,
        d,
        K.getDataStore(
          U,
          S,
          S.id ?? k.profileId,
          r ?? D,
          A
        )
      ) : d === "ko-KR" ? V = K.getKoStringManager(
        $,
        r ?? D,
        d,
        K.getDataStore(
          U,
          S,
          S.id ?? k.profileId,
          r ?? D,
          A
        )
      ) : d === "ms-MY" ? V = K.getMyStringManager(
        $,
        r ?? D,
        d,
        K.getDataStore(
          U,
          S,
          S.id ?? k.profileId,
          r ?? D,
          A
        )
      ) : V = K.getStringManager(
        $,
        r ?? D,
        d,
        K.getDataStore(
          U,
          S,
          S.id ?? k.profileId,
          r ?? D,
          A
        )
      );
      const he = K.getScriptManager(
        $,
        r ?? D,
        d
      );
      if (V === null)
        throw "No manager instance";
      const oe = await V.getGroup(G), re = oe == null ? void 0 : oe.getString(`${$}-${s}`);
      if (re == null || !re.internalId)
        throw "No string instance";
      if (x("modified"), i !== c) {
        const { isUpdated: pe } = await V.updateStringEntry(
          i,
          re.internalId,
          d,
          S,
          { profileId: S.id }
        );
        if (pe)
          x("changed"), he.updateScript(
            i,
            s,
            G,
            "changed",
            d
          ), b(i), M({
            title: "Text saved successfully!",
            description: `${i} is successfully requested for change to locale ${d}`,
            status: "success",
            duration: 1500,
            isClosable: !0
          });
        else
          throw he.updateScript(
            i,
            s,
            G,
            "failed",
            d
          ), "Failed update";
      } else
        x("initial");
    } catch (V) {
      x("failed"), M({
        title: "Error in saving entry",
        description: "Something went wrong" + V,
        status: "error",
        duration: 2e3,
        isClosable: !0
      });
    }
  }, H = () => {
    x("initial"), l(we(c, n));
  }, Se = ct(
    () => {
      var G;
      return (G = K.getScriptManager($, r ?? D, d).getScript(
        s,
        d
      )) == null ? void 0 : G.script;
    },
    [
      (ve = K.getScriptManager($, r ?? D, d).getScript(
        s,
        d
      )) == null ? void 0 : ve.script
    ]
  );
  if (le(() => {
    w && (l(we(t, n)), v(!1), (async () => {
      var pe, st;
      const ne = await It(
        t,
        s,
        r ?? D,
        d,
        U,
        S,
        k,
        $,
        A,
        n,
        j.map((p) => p == null ? void 0 : p.locale),
        se || void 0
      ), V = K.getScriptManager(
        $,
        r ?? D,
        d
      ), [he, oe] = Ht(s);
      oe !== null && he !== null && V.updateScript(
        ne,
        s,
        he,
        "initial",
        d
      );
      const re = we(ne, n);
      l(re), o(we(ne, n)), V.getScript(s, d) && (l(
        we(
          ((pe = V.getScript(s, d)) == null ? void 0 : pe.script) ?? we(ne, n),
          n
        )
      ), o(
        we(
          ((st = V.getScript(s, d)) == null ? void 0 : st.script) ?? we(ne, n),
          n
        )
      )), v(!0);
    })());
  }, [
    d,
    w,
    A,
    s,
    JSON.stringify(n),
    JSON.stringify(j)
  ]), le(() => {
    var ne;
    const G = ((ne = K.getScriptManager($, r ?? D, d).getScript(
      s,
      d
    )) == null ? void 0 : ne.script) ?? i;
    l(we(G, n)), b(G);
  }, [Se, f, P, d, JSON.stringify(n)]), !w)
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: t });
  if (w && !_)
    return /* @__PURE__ */ e.jsx(
      Ct,
      {
        "aria-description": s,
        label: s,
        isDisabled: !A,
        children: ee ? /* @__PURE__ */ e.jsx(
          Vt,
          {
            isLoaded: C,
            width: "max-content",
            height: "max-content",
            display: "inline",
            children: /* @__PURE__ */ e.jsx("span", { "aria-description": s, children: W ? s : i })
          }
        ) : /* @__PURE__ */ e.jsx("span", { "aria-description": s, children: W ? s : i })
      }
    );
  const be = (G) => {
    l(G);
  };
  return /* @__PURE__ */ e.jsxs(
    tn,
    {
      defaultValue: t,
      value: i,
      onChange: be,
      isPreviewFocusable: !0,
      selectAllOnFocus: !1,
      id: "editable",
      display: "flex",
      flexFlow: "row nowrap",
      "aria-description": `editable-${s}`,
      children: [
        /* @__PURE__ */ e.jsx(
          Ct,
          {
            label: `Translation Key: ${s}. Click to edit`,
            shouldWrapChildren: !0,
            children: /* @__PURE__ */ e.jsx(
              sn,
              {
                px: 1,
                py: 2,
                position: "relative",
                paddingRight: "25px",
                cursor: "text",
                minHeight: "32px",
                background: Lr(h),
                _hover: {
                  background: bs("gray.200", "gray.700"),
                  color: "black"
                },
                _after: {
                  content: '""',
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  width: "13px",
                  height: "13px",
                  backgroundImage: `url("${Fr}")`,
                  backgroundSize: "cover"
                },
                w: "full"
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Ct, { label: "Input here your proposed translation changes", children: /* @__PURE__ */ e.jsxs(
          He,
          {
            justifyContent: "center",
            alignItems: "center",
            height: "max-content",
            w: a ? "full" : "unset",
            children: [
              /* @__PURE__ */ e.jsx(
                bt,
                {
                  py: 1,
                  px: 1,
                  as: nn,
                  value: i,
                  onKeyDown: ye,
                  w: a ? "full" : "unset"
                }
              ),
              /* @__PURE__ */ e.jsx(_r, { handleSave: J, handleCancel: H })
            ]
          }
        ) })
      ]
    }
  );
}, Qe = (t, s, n = "en-US", a = []) => (async () => {
  const i = K.getDataStore(
    { hmacKey: "", apiUrl: "" },
    { authorization: "", token: "" },
    "",
    "",
    !1
  ), c = Ze() ? Xe() : Z();
  return new Promise((h) => {
    i.setInitCallback(async (x) => {
      await ((A) => new Promise((W) => setTimeout(W, A)))(100);
      const {
        authorization: b,
        baseUrl: C,
        hmacKey: v,
        moduleId: M,
        profileId: g,
        token: j,
        isDevToolsEnabled: S
      } = x, k = sessionStorage.getItem("al"), w = localStorage.getItem(`srcStrings-${M}`);
      let d;
      try {
        d = JSON.parse((w == null ? void 0 : w[n]) ?? "[]") ?? void 0;
      } catch {
        d = void 0;
      }
      const D = localStorage == null ? void 0 : localStorage.getItem("configData");
      let U;
      if (D) {
        const A = JSON == null ? void 0 : JSON.parse(D);
        U = A == null ? void 0 : A.languagesAvailable;
      }
      const _ = typeof k == "string" && (JSON.parse(k) === "en-US" || JSON.parse(k) === "zh-Hant-TW" || JSON.parse(k) === "th-TH" || JSON.parse(k) === "ko-KR" || JSON.parse(k) === "ms-MY") ? JSON.parse(k) ?? n : n, P = await It(
        s,
        t,
        M,
        _,
        { hmacKey: v, baseUrl: C },
        { authorization: b, token: j },
        { profileId: g },
        c,
        // { hmacKey, baseUrl },
        // { authorization, token },
        // { profileId }
        S,
        a,
        U == null ? void 0 : U.map((A) => A == null ? void 0 : A.locale),
        d
      );
      h(we(P, a));
    });
  });
})(), go = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextScript: X,
  TextString: X,
  default: X,
  getTextScript: Qe,
  initializeString: It
}, Symbol.toStringTag, { value: "Module" })), Kr = () => {
  const t = window.location.search, n = new URLSearchParams(t).get("lang");
  if (["en-US", "zh-Hant-TW", "th-TH", "ko-KR", "ms-MY"].includes(n))
    return n;
}, es = Fe({
  language: "en-US",
  updateActiveLanguage: () => {
  },
  module: "myAsurionShared",
  isEnabled: !1,
  updateIsEnabled: () => {
  },
  apiEnv: { hmacKey: "", apiUrl: "" },
  isEditingMode: !1,
  updateIsEditingMode: () => {
  },
  isDevToolsOpen: !1,
  updateIsDevToolsOpen: () => {
  },
  isDevToolsEnabled: !1,
  updateIsDevToolsEnabled: () => {
  },
  isTranslationsLoading: !1,
  updateIsTranslationsLoading: () => {
  },
  isKeyShown: !1,
  setIsKeyShown: () => {
  },
  srcStrings: []
}), Wr = ({
  children: t,
  moduleId: s,
  isEnabled: n = !1,
  apiEnv: a,
  srcStrings: r
}) => {
  const [i, l] = R(n), [c, o] = R(!1), [h, x] = R(!1), [f, b] = R(!1), [C, v] = R(!1), [M, g] = R(!1);
  if (!n)
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: t });
  const [{ authorization: j, token: S, id: k }] = et({
    authorization: "",
    token: "",
    id: ""
  }), w = Z(), d = Ze();
  let D, U;
  D = Kr(), U = D || Dn(w);
  const [_, P] = Rs(
    "al",
    U ?? "en-US"
    // NOTE: set defaultLanguage as activeLanguage if value is configured
  ), [A, W] = Cn(`srcStrings-${s}`, void 0), [se, de] = R(_ ?? U ?? "en-US");
  return le(() => {
    P(se);
  }, [se]), le(() => {
    U && !_ && de(U);
  }, [U, _]), le(() => {
    k && K.initializeLocalization({
      partnerId: d ? Xe() : w,
      moduleId: s,
      apiEnv: a,
      authToken: { authorization: j, token: S },
      profileId: k,
      isDevToolsEnabled: f
    });
  }, [j, S, k, f]), le(() => {
    A || W(r);
  }, [r]), /* @__PURE__ */ e.jsx(
    es.Provider,
    {
      value: {
        language: se,
        updateActiveLanguage: de,
        module: s,
        isEnabled: i,
        updateIsEnabled: l,
        apiEnv: a,
        isEditingMode: c,
        updateIsEditingMode: o,
        isDevToolsOpen: h,
        updateIsDevToolsOpen: x,
        isDevToolsEnabled: f,
        updateIsDevToolsEnabled: b,
        isTranslationsLoading: C,
        updateIsTranslationsLoading: v,
        isKeyShown: M,
        setIsKeyShown: g,
        srcStrings: r
      },
      children: /* @__PURE__ */ e.jsx(Je, { flexFlow: "row nowrap", children: /* @__PURE__ */ e.jsx(xe, { as: "div", id: "translation-ctx", w: "full", flex: "1", children: t }) })
    }
  );
}, Hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextScriptContext: es,
  TextScriptProvider: Wr
}, Symbol.toStringTag, { value: "Module" })), qr = (t, s) => !s || s.length === 0 ? t : t == null ? void 0 : t.replace(
  /\{(\d+)\}/g,
  (n, a) => typeof s[a - 1] < "u" ? s[a - 1] : `{${a}}`
), Tt = () => {
  const t = Ne(es);
  if (t === void 0)
    throw new Error("useTextScript must be used within a TextScriptProvider");
  const { data: s } = ce(), { languagesAvailable: n } = s, {
    language: a,
    updateActiveLanguage: r,
    module: i,
    isEnabled: l,
    updateIsEnabled: c,
    apiEnv: o,
    isEditingMode: h,
    updateIsEditingMode: x,
    isDevToolsOpen: f,
    updateIsDevToolsOpen: b,
    isDevToolsEnabled: C,
    updateIsDevToolsEnabled: v,
    isTranslationsLoading: M,
    updateIsTranslationsLoading: g,
    isKeyShown: j,
    setIsKeyShown: S,
    srcStrings: k
  } = t;
  return {
    language: a,
    updateActiveLanguage: r,
    module: i,
    isEnabled: l,
    updateIsEnabled: c,
    apiEnv: o,
    isEditingMode: h,
    updateIsEditingMode: x,
    isDevToolsOpen: f,
    updateIsDevToolsOpen: b,
    isDevToolsEnabled: C,
    updateIsDevToolsEnabled: v,
    isTranslationsLoading: M,
    updateIsTranslationsLoading: g,
    getTextScript: (d, D, U = "en-US", _ = []) => (async () => {
      const A = K.getDataStore(
        { hmacKey: "", apiUrl: "" },
        { authorization: "", token: "" },
        "",
        "",
        !1
      ), se = Ze() ? Xe() : Z();
      return new Promise(($) => {
        A.setInitCallback(async (ee) => {
          const ye = U, {
            authorization: J,
            baseUrl: H,
            hmacKey: Se,
            moduleId: be,
            profileId: ve,
            token: G,
            isDevToolsEnabled: ne
          } = ee, he = await It(
            D,
            d,
            be,
            ye,
            { hmacKey: Se, baseUrl: H },
            { authorization: J, token: G },
            { profileId: ve },
            se,
            // { hmacKey, baseUrl },
            // { authorization, token },
            // { profileId }
            ne,
            _,
            n == null ? void 0 : n.map((oe) => oe == null ? void 0 : oe.locale),
            k || void 0
          );
          $(qr(he, _));
        });
      });
    })(),
    isKeyShown: j,
    setIsKeyShown: S,
    srcStrings: k
  };
}, Br = Fe({
  entries: [],
  updateEntry: async () => {
  },
  updateLocaleLanguage: () => {
  },
  localeLanguage: "en-US",
  getTextEntry: () => ({ textEntry: "", entryId: "" }),
  localModule: void 0,
  setLocalModule: () => {
  },
  isTranslationsActive: !1,
  setIsTranslationsActive: () => {
  },
  translationAPI: { api: null, authorization: "", token: "" }
}), Nt = () => {
  const t = Ne(Br);
  if (t === void 0)
    throw new Error("useLocalization must be used within a TranslationProvider");
  const {
    entries: s,
    localeLanguage: n,
    updateLocaleLanguage: a,
    getTextEntry: r,
    updateEntry: i,
    setLocalModule: l,
    isTranslationsActive: c,
    setIsTranslationsActive: o,
    translationAPI: h
  } = t;
  return {
    entries: s,
    localeLanguage: n,
    updateLocaleLanguage: a,
    getTextEntry: r,
    updateEntry: i,
    setLocalModule: l,
    isTranslationsActive: c,
    setIsTranslationsActive: o,
    translationAPI: h
  };
}, Gr = () => {
  const t = Ss(!1);
  return [() => {
    if (typeof document > "u")
      return;
    const a = document.documentElement, { body: r } = document;
    if (!r || !r.style || t.current)
      return;
    const i = window.innerWidth - a.clientWidth, l = parseInt(window.getComputedStyle(r).getPropertyValue("padding-right")) || 0;
    a.style.position = "relative", r.style.position = "relative", a.style.overflow = "hidden", r.style.overflow = "hidden", r.style.paddingRight = `${l + i}px`, t.current = !0;
  }, () => {
    if (typeof document > "u")
      return;
    const a = document.documentElement, { body: r } = document;
    !r || !r.style || !t.current || (a.style.position = "", a.style.overflow = "", r.style.position = "", r.style.overflow = "", r.style.paddingRight = "", t.current = !1);
  }];
}, Vr = (t = "", s = "", n = "", a = "", r) => {
  const [i, l] = R(null), [c, o] = R(!0);
  return le(() => {
    async function h() {
      try {
        if (t) {
          const x = await Pn(
            t,
            s,
            n,
            a,
            r
          );
          x && l(x);
        } else {
          l(null);
          return;
        }
      } catch (x) {
        console.error("Error fetching Contentful image:", x);
      } finally {
        o(!1);
      }
    }
    h();
  }, [t, s, n, a]), { imageUrl: i, isLoading: c };
}, Yr = (t, s, n) => {
  const a = /* @__PURE__ */ new Date();
  a.setTime(a.getTime() + n * 60 * 60 * 1e3);
  const r = "expires=" + a.toUTCString();
  document.cookie = `${t}=${s};${r};path=/`;
}, Qr = (t) => {
  const s = t + "=", n = document.cookie.split(";");
  for (let a = 0; a < n.length; a++) {
    let r = n[a];
    for (; r.charAt(0) === " "; )
      r = r.substring(1, r.length);
    if (r.indexOf(s) === 0)
      return r.substring(s.length, r.length);
  }
  return null;
}, Jr = (t) => {
  document.cookie = `${t}=; Max-Age=-99999999;`;
}, Zr = `
    subscription onCreateConversation($requestId: ID!) {
        onCreateConversation(requestId: $requestId) {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }
`, Xr = `
    subscription onUpdateChatRequest($requestId: ID!) {
        onUpdateChatRequest(requestId: $requestId) {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, ea = `
    subscription onCreateMessage($conversationId: ID!) {
        onCreateMessage(conversationId: $conversationId) {
            messageId
            visitorId
            conversationId
            messageType
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, ta = `
    subscription onAgentTyping($conversationId: ID!) {
        onAgentTyping(conversationId: $conversationId) {
            conversationId
            agentTyping
        }
    }
`, sa = `
    mutation createMessage($input: CreateMessageInput!) {
        createMessage(input: $input) {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
            sourceMsgId
            translated
            sourceLang
            targetLang
        }
    }
`, na = `
    mutation updateEncryptedChatRequest($input: UpdateChatRequestInput!) {
        updateEncryptedChatRequest(input: $input) {
            requestId
            requestStatus
            speedToAnswer
            wrapUpCode
            endTimestamp
            expertName
            userEmail
            isTransferred
            transferredRequestId
            averageResponseTime
            engagementDuration
            violationCount
            chatAcceptTimeStamp
            expertId
            averageUserResponseTime
        }
    }
`, ra = `
    mutation createChatAudit($input: CreateChatAudit!) {
        createChatAudit(input: $input) {
            visitorId
            createdAt
            auditLog
            chatAuditId
            expertName
            requestId
        }
    }
`, aa = `
  query getMessages {
    getMessages(visitorId: "{visitorId}", conversationId: "{conversationId}") {
    messageId
    visitorId
    conversationId
    messageType
    messageStatus
    interactionType
    sender
    source
    content
    isSent
    recipient
    isActive
    createdAt
    sourceMsgId
    translated
    sourceLang
    targetLang
    agentResponseTime
    userResponseTime
    }
  }
`, mo = `
    subscription onCreateConversation {
        onCreateConversation(requestId: "{1}") {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }`, fo = `
    subscription onUpdateChatRequest {
        onUpdateChatRequest(requestId: "{1}") {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, yo = `
    subscription onCreateMessage {
        onCreateMessage(conversationId: "{1}") {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, So = `
    subscription onAgentTyping {
        onAgentTyping(conversationId: "{1}") {
            conversationId
            agentTyping
        }
    }
`, ia = ({
  domain: t = "",
  httpMethod: s = "GET",
  path: n = "/",
  timestamp: a = Date.now(),
  apiClientKey: r = "",
  payload: i = ""
}) => {
  const c = `${t}${s}${n}${a}${((o) => Array.from(o).reverse().join(""))(r)}${i ? JSON.stringify(i) : ""}`;
  return Un.HmacSHA256(c, r).toString();
}, fe = {
  execute: async (t, s, n, a, r, i = !0) => {
    const l = {}, c = `${s}${n}`;
    if (i) {
      const o = Date.now(), h = r != null && r.data ? JSON.stringify(r.data) : "";
      l.headers = {
        "x-client-key": a.chat.apiKey,
        "x-asurion-product": a.chat.productName,
        "x-nvu-authorization": ia({
          domain: window.location.origin,
          httpMethod: t,
          timestamp: o,
          path: n,
          apiClientKey: a.chat.apiKey,
          payload: h
        }),
        "x-nvu-client": a.chat.clientName,
        "x-nvu-program": a.chat.program,
        "x-nvu-channel": "chat",
        "x-request-ts": o
      };
    }
    switch (t.toUpperCase()) {
      case "GET":
        return await Q.get(c, l);
      case "POST":
        return await Q.post(c, r == null ? void 0 : r.data, l);
      case "PUT":
        return await Q.put(c, r == null ? void 0 : r.data, l);
      case "DELETE":
        return await Q.delete(c, l);
      default:
        return await Q.get(c, l);
    }
  }
}, oa = {
  getApi: async (t, s) => {
    const n = Z(), a = Ee(n);
    return Q.create({
      baseURL: s ?? `${{}.VITE_MYASURION_API_BASE_URL}${{}.VITE_MYASURION_API_BASE_PATH}` ?? {}.VITE_API_BASE_URL,
      headers: {
        "x-asurion-client": n,
        "x-asurion-cc": a.code
      },
      ...t
    });
  }
}, bo = async (t) => {
  var s;
  try {
    const n = (s = t.chat) != null && s.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, a = "/api/v1/nvu/worker/stats", { data: r } = await fe.execute("GET", n, a, t);
    return r;
  } catch (n) {
    console.error("Failed to get available workers", n);
  }
}, wo = async ({
  requestId: t,
  transferRequestId: s,
  chatConfig: n,
  action: a
}) => {
  var r;
  try {
    const i = (r = n.chat) != null && r.isSRBuild ? `${n.chat.baseEndpoint}` : `${n.chat.baseEndpoint}/${n.chat.environment}`, l = "/api/v1/nvu/chat/session", { data: c } = await fe.execute("PUT", i, l, n, {
      data: {
        transferRequestId: s,
        requestId: t,
        action: a
      }
    });
    return c;
  } catch (i) {
    return console.error("Failed to transfer chat session", i), { status: "failed", requestId: "", taskSid: "" };
  }
}, jo = async ({
  requestId: t,
  chatConfig: s,
  action: n
}) => {
  var a;
  try {
    const r = (a = s.chat) != null && a.isSRBuild ? `${s.chat.baseEndpoint}` : `${s.chat.baseEndpoint}/${s.chat.environment}`, i = "/api/v1/nvu/chat/session", { data: l } = await fe.execute("PUT", r, i, s, {
      data: {
        requestId: t,
        action: n
      }
    });
    return l;
  } catch (r) {
    return console.error("Failed to transfer chat session", r), { status: "failed", requestId: "", taskSid: "" };
  }
}, vo = async ({
  requestId: t,
  chatConfig: s
}) => {
  var n;
  try {
    const a = (n = s.chat) != null && n.isSRBuild ? `${s.chat.baseEndpoint}` : `${s.chat.baseEndpoint}/${s.chat.environment}`, i = `/api/v1/nvu/chat/session/stats${t ? `/${t}` : ""}`, { data: l } = await fe.execute("GET", a, i, s);
    return l;
  } catch (a) {
    console.error("Failed to retrieve chat stats", a);
    return;
  }
}, Io = async (t) => {
  var s;
  try {
    const n = (s = t.chat) != null && s.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, a = "/api/v1/nvu/chat/schedule", { data: r } = await fe.execute("GET", n, a, t);
    return r;
  } catch (n) {
    return console.error("Failed to get chat schedule", n), { isServiceable: !1 };
  }
}, To = async (t, s, n) => {
  var a;
  try {
    const r = (a = t.chat) != null && a.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, i = "/api/v1/nvu/chat/task", l = {
      data: {
        request_id: (n == null ? void 0 : n.requestId) ?? t.userInfo.requestId,
        mdn: (n == null ? void 0 : n.mdn) ?? t.userInfo.mdn,
        visitorId: (n == null ? void 0 : n.visitorId) ?? t.userInfo.visitorId,
        userName: "User",
        source: "Web",
        carrier: t.chat.clientName,
        programName: t.chat.program,
        chatReason: "Technical Support",
        selectedLanguage: s === "zh-Hant-TW" ? "zh-TW" : s,
        browserAgent: JSON.stringify(ks()),
        // ipAddress: ipAddress,
        // for retailer specific like sinya..
        ...t.chat.retailerName && { retailerName: t.chat.retailerName }
      }
    }, { data: c } = await fe.execute("POST", r, i, t, l);
    return c;
  } catch (r) {
    console.error("Failed to create task", r);
  }
}, Ao = async (t, s, n, a, r) => {
  var i;
  try {
    const l = (i = t.chat) != null && i.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, c = "/api/v1/nvu/chat/session", o = {
      data: {
        request_id: (r == null ? void 0 : r.requestId) ?? t.userInfo.requestId,
        mdn: (r == null ? void 0 : r.mdn) ?? t.userInfo.mdn,
        visitorId: (r == null ? void 0 : r.visitorId) ?? t.userInfo.visitorId,
        userName: "User",
        source: "Web",
        carrier: t.chat.clientName,
        programName: t.chat.program,
        chatReason: n ?? "Technical Support",
        ...a && { requestType: a },
        selectedLanguage: s === "zh-Hant-TW" ? "zh-TW" : s,
        browserAgent: JSON.stringify(ks()),
        // ipAddress: ipAddress,
        initiatedFrom: "Chatbot",
        ...Mn() && { storeCode: kn() }
        // specific for PCHOME, SINYA & Yahoo
      }
    }, { data: h } = await fe.execute("POST", l, c, t, o);
    return h;
  } catch (l) {
    console.error("Failed to initialize chat session", l);
  }
}, Co = async (t, s) => {
  var n;
  try {
    const a = `/api/v1/nvu/chat/session/task/${s}`, r = (n = t.chat) != null && n.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, i = {
      data: {}
    }, { data: l } = await fe.execute("POST", r, a, t, i);
    return l;
  } catch (a) {
    console.error("Failed to create task", a);
  }
}, Mo = async (t, s, n) => {
  var a;
  try {
    const r = (a = n.chat) != null && a.isSRBuild ? `${n.chat.baseEndpoint}` : `${n.chat.baseEndpoint}/${n.chat.environment}`, i = `/api/v1/nvu/chat/task/${t}`, l = {
      data: {
        visitorId: n.userInfo.visitorId,
        action: s
        // region: 'sea'
      }
    }, { data: c } = await fe.execute("PUT", r, i, n, l);
    return c;
  } catch (r) {
    console.error(`Failed to ${s} task`, r);
  }
}, ko = async (t, s, n) => {
  var a, r;
  try {
    const i = ((a = s.chatBot) == null ? void 0 : a.path) ?? "/chatbot/api/v3/message", l = {
      data: {
        carrier: s.chat.clientName.toLowerCase(),
        conversation_id: "12345678",
        message: t,
        content: "true",
        ...n || {}
      }
    }, { data: c } = await fe.execute(
      "POST",
      `${(r = s.chatBot) == null ? void 0 : r.baseUrl}`,
      i,
      s,
      l,
      !1
    );
    return c;
  } catch (i) {
    console.error("Failed to get chatbot response", i);
  }
}, la = async (t, s) => {
  try {
    const n = +/* @__PURE__ */ new Date(), r = await (await oa.getApi({}, s == null ? void 0 : s.baseEndpoint)).get("/cognito/user", {
      method: "GET",
      headers: {
        authorization: t.authorization,
        token: t.token,
        t: n,
        id: t.id,
        "x-api-key": s == null ? void 0 : s.apiKey
      }
    }), { data: i } = r;
    return i.body;
  } catch (n) {
    console.error("Failed to get chatbot response", n);
  }
}, Eo = async (t, s) => {
  try {
    const n = `${t == null ? void 0 : t.baseEndpoint}/auth/send-inquiry`, a = Z(), r = Ee(a), i = +/* @__PURE__ */ new Date(), l = vt.SHA256(i.toString()).toString(), o = {
      Authorization: Xt(
        {
          method: "POST",
          httpPath: "/api/v1/auth/send-inquiry",
          token: l || ""
        },
        (t == null ? void 0 : t.hmacKey) ?? {}.VITE_MYASURION_API_AUTH_HMAC_KEY
      ),
      token: l,
      t: i,
      "x-asurion-client": a,
      "x-asurion-cc": r.code
    };
    await Q({
      method: "POST",
      url: n,
      headers: o,
      data: s
    });
  } catch (n) {
    console.error("Failed to create callback workqueue", n);
  }
}, Pe = Rn({ authMode: "userPool" }), No = {
  subscribeToNewConversation: (t) => Pe.graphql({
    query: Zr,
    variables: { requestId: t }
  }),
  subscribeToEndChat: (t) => Pe.graphql({
    query: Xr,
    variables: { requestId: t }
  }),
  subscribeToNewMessages: (t) => Pe.graphql({
    query: ea,
    variables: { conversationId: t }
  }),
  subscribeToAgentTyping: (t) => Pe.graphql({
    query: ta,
    variables: { conversationId: t }
  }),
  createChatMessage: (t) => Pe.graphql({
    query: sa,
    variables: { input: t }
  }),
  createChatAudit: (t) => Pe.graphql({
    query: ra,
    variables: { input: t }
  }),
  getChatMessages: (t, s) => {
    const n = aa.replace("{visitorId}", t).replace(
      "{conversationId}",
      s
    );
    return Pe.graphql({
      query: n,
      variables: { visitorId: t, conversationId: s }
    });
  },
  updateChatRequest: (t) => Pe.graphql({
    query: na,
    variables: { input: t }
  })
}, Do = async (t, s, n) => {
  try {
    const a = `${t == null ? void 0 : t.baseEndpoint}/online/serviceFee`, r = Z(), i = Ee(r), l = {
      agreementId: s,
      data: n
    }, c = As(), o = {
      token: c.token,
      "x-api-key": t == null ? void 0 : t.apiKey,
      "x-asurion-client": r,
      "x-asurion-cc": i.code,
      authorization: c.authorization,
      id: c.userId
    }, h = {
      method: "POST",
      url: a,
      headers: o,
      data: l
    }, { data: x } = await Q(h);
    if (x.statusCode === 400)
      throw new Error();
    return x.body;
  } catch (a) {
    return console.error("Failed to fetch online service fees", a), [];
  }
}, Uo = async (t, s) => {
  var n;
  try {
    if (!t.chatBot)
      return [];
    const a = `${(n = t.chatBot) == null ? void 0 : n.genInqEndpoint}`, r = `/general-inquiry/chats/${s}`, i = {
      "x-partner": t.chat.clientName,
      "x-program": t.chat.program
    }, l = {
      method: "GET",
      url: a + r,
      headers: i
    }, { data: c } = await Q(l);
    if (c.statusCode === 400)
      throw new Error();
    return c;
  } catch (a) {
    return console.error("Failed to fetch authentication token", a), [];
  }
}, Po = async (t, s, n, a, r) => {
  var h;
  const i = `${(h = t.chatBot) == null ? void 0 : h.genInqEndpoint}`, l = `/general-inquiry/chats/${n}/${a}`, c = {
    "x-partner": t.chat.clientName,
    "x-program": t.chat.program,
    "x-api-authtoken": s
  }, o = {
    method: "POST",
    url: i + l,
    headers: c,
    data: r,
    timeout: 25e3
  };
  try {
    const { data: x } = await Q(o);
    if (x.statusCode === 400)
      throw new Error();
    return x;
  } catch (x) {
    console.error("Failed to fetch message inquiry, retrying once", x);
    try {
      const { data: f } = await Q(o);
      if (f.statusCode === 400)
        throw new Error();
      return f;
    } catch (f) {
      return console.error("Failed to fetch message inquiry", f), [];
    }
  }
}, Ro = async (t, s, n, a, r) => {
  var i;
  try {
    const l = `${(i = t.chatBot) == null ? void 0 : i.genInqEndpoint}`, c = `/general-inquiry/chats/${n}/${a}/feedback`, o = {
      "x-partner": t.chat.clientName,
      "x-program": t.chat.program,
      "x-api-authtoken": s
    }, h = {
      method: "POST",
      url: l + c,
      headers: o,
      data: r
    }, { data: x } = await Q(h);
    if (x.statusCode === 400)
      throw new Error();
    return x;
  } catch (l) {
    return console.error("Failed to submit message feedback", l), [];
  }
}, zo = async (t) => {
  var s, n, a, r, i, l, c;
  try {
    const o = ((s = t == null ? void 0 : t.chatSurvey) == null ? void 0 : s.baseEndpoint) ?? "", h = ((n = t == null ? void 0 : t.chatSurvey) == null ? void 0 : n.surveyEndpoint) ?? "", x = {
      GetSurveyQuestions: {
        SurveyType: (a = t == null ? void 0 : t.chatSurvey) == null ? void 0 : a.surveyType,
        ClientId: (r = t == null ? void 0 : t.chatSurvey) == null ? void 0 : r.surveyClientId,
        TriggerPoint: ((i = t == null ? void 0 : t.chatSurvey) == null ? void 0 : i.surveyTriggerPoint) ?? "SR_Creation",
        Language: "en-US",
        ServiceRequestId: "",
        SessionId: ""
      }
    }, f = {
      data: x
    };
    if (!o) {
      const v = {
        "x-api-key": (l = t == null ? void 0 : t.chatSurvey) == null ? void 0 : l.surveyApiKey
      }, M = {
        method: "POST",
        url: (c = t == null ? void 0 : t.chatSurvey) == null ? void 0 : c.surveyEndpoint,
        headers: v,
        data: x
      }, { data: g } = await Q(M);
      return (g == null ? void 0 : g.GetSurveyQuestionsResponse) !== void 0 ? (g == null ? void 0 : g.GetSurveyQuestionsResponse).SurveyQuestions : g == null ? void 0 : g.SurveyQuestions;
    }
    const { data: b } = await fe.execute(
      "POST",
      o,
      h,
      t,
      f
    );
    return (b == null ? void 0 : b.GetSurveyQuestionsResponse) !== void 0 ? (b == null ? void 0 : b.GetSurveyQuestionsResponse).SurveyQuestions : b == null ? void 0 : b.SurveyQuestions;
  } catch (o) {
    return console.error("Failed to fetch chat NPS survey", o), [];
  }
}, Fo = async (t, s) => {
  var n, a, r;
  try {
    const i = ((n = t == null ? void 0 : t.chatSurvey) == null ? void 0 : n.baseEndpoint) ?? "", l = ((a = t == null ? void 0 : t.chatSurvey) == null ? void 0 : a.surveySubmitEndpoint) ?? "", c = {
      data: {
        ...s
      }
    };
    if (typeof l == "string" && !i) {
      const o = {
        "x-api-key": (r = t == null ? void 0 : t.chatSurvey) == null ? void 0 : r.surveyApiKey
      };
      await Q({
        method: "POST",
        url: l,
        headers: o,
        data: s
      });
    } else
      typeof l == "string" && i ? await fe.execute(
        "POST",
        i,
        l,
        t,
        c
      ) : l instanceof Array && l.forEach(async (o) => {
        var h;
        try {
          if (o.endpoint)
            await fe.execute(
              "POST",
              o.endpoint,
              o.path,
              t,
              c
            );
          else {
            const x = {
              "x-api-key": (h = t == null ? void 0 : t.chatSurvey) == null ? void 0 : h.surveyApiKey
            }, f = {
              method: "POST",
              url: o.path,
              headers: x,
              data: s
            };
            await Q(f);
          }
        } catch (x) {
          console.error("Failed to submit chat NPS survey", { ...o }, x);
        }
      });
  } catch (i) {
    console.error("Failed to submit chat NPS survey", i);
    return;
  }
}, _o = async ({
  chatConfig: t,
  requestBody: s
}) => {
  var i;
  const r = {
    method: "POST",
    url: `${(i = t.chatBot) == null ? void 0 : i.techSupportEndpoint}` + "/chat/tech-support",
    data: s,
    timeout: 25e3
  };
  try {
    const {
      data: l
    } = await Q(r);
    if (l.statusCode === 400)
      throw new Error();
    return l;
  } catch (l) {
    console.error("Failed to fetch message inquiry, retrying once", l);
    try {
      const {
        data: c
      } = await Q(r);
      if (c.statusCode === 400)
        throw new Error();
      return c;
    } catch (c) {
      return console.error("Failed to fetch message inquiry", c), null;
    }
  }
}, Oo = (t, s = 1e3) => setTimeout(() => t(), s), $o = (t) => typeof t > "u" || t === "null" ? !0 : typeof t == "function" ? !1 : Array.isArray(t) ? t.length === 0 : typeof t == "string" && t.trim().length === 0 ? !0 : !t || Object.keys(t).length === 0, Lo = (t, s, n) => {
  const a = new Intl.DateTimeFormat("en-US", {
    timeStyle: "long",
    hour12: !1,
    timeZone: n
  }).format(/* @__PURE__ */ new Date()), r = "HH:mm:ss", i = lt(+t, r), l = lt(+s, r);
  return lt(a, r).isBetween(i, l);
}, Ko = (t, s) => {
  const n = "hA", a = lt(t, "hh:mm:ss").format(n), r = lt(s, "hh:mm:ss").format(n);
  return `${a} - ${r}`;
}, rt = () => Ln().toString().replace(/-/g, "").toUpperCase(), ca = () => {
  const { chatConfig: t, baseApiConfig: s } = ss(), [n] = et({
    authorization: "",
    token: "",
    id: ""
  });
  return {
    configure: async () => {
      if (!t)
        return;
      const l = {
        API: {
          GraphQL: {
            endpoint: (t == null ? void 0 : t.appSyncGraphQL.endpoint) || "",
            region: (t == null ? void 0 : t.appSyncGraphQL.region) || "",
            defaultAuthMode: (t == null ? void 0 : t.appSyncGraphQL.authType) || "userPool"
          }
        },
        Auth: {
          Cognito: {
            userPoolId: (t == null ? void 0 : t.amplifyConfig.cognitoUserPoolId) || "",
            userPoolClientId: (t == null ? void 0 : t.amplifyConfig.cognitoUserPoolWebClientId) || "",
            region: (t == null ? void 0 : t.amplifyConfig.cognitoRegion) || ""
          }
        }
      };
      Kn.configure(l), zn.setKeyValueStorage(Fn);
      const c = Z(), o = Ee(c);
      try {
        const h = Qr("cognitoUserSession");
        if (!h)
          throw new Error("no stored appsync data");
        if (!!!(await _n()).username)
          throw new Error("not signed in");
        return JSON.parse(h);
      } catch {
        const { username: x, token: f, appsyncData: b } = await la(n, s);
        await Kt(), await On({
          username: x,
          password: f,
          options: {
            clientMetadata: {
              "x-asurion-client": c,
              "x-asurion-cc": o.code,
              authorization: n.authorization,
              token: n.token,
              id: n.id,
              "x-api-key": (s == null ? void 0 : s.apiKey) ?? ""
            }
          }
        });
        const C = JSON.stringify(b);
        return Yr("cognitoUserSession", C, 3), b;
      }
    },
    logout: async () => await Kt(),
    isAuthenticated: async () => {
      try {
        return await $n(), !0;
      } catch {
        return !1;
      }
    }
  };
}, hs = [
  "Oops! Something went wrong. Let's give it another shot, shall we?",
  "We hit a bump in the digital highway. Ready to try that login again?",
  "Looks like our spaceship hit a meteor. Hit that login button and we'll soar again!"
], da = ({}) => {
  const [, t] = wt({ profileId: "", userId: "" }), [, s] = et({}), [n, a] = R(
    Math.floor(Math.random() * hs.length)
  ), r = (i = "") => {
    console.log("doLogout", i), localStorage.clear();
    const l = sessionStorage.getItem("p");
    sessionStorage.clear(), sessionStorage.setItem("p", l ?? ""), t({ profileId: "", userId: "" }), s({});
  };
  return /* @__PURE__ */ e.jsxs(L, { flexDirection: "column", textAlign: "center", className: "chatbot-node", alignItems: "center", justifyContent: "center", h: "full", children: [
    /* @__PURE__ */ e.jsx(I, { mb: "30px", px: "20px", children: /* @__PURE__ */ e.jsx(
      X,
      {
        text: hs[n],
        translationKey: `ReloginMessages/${n}`
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      ie,
      {
        colorScheme: "primary",
        my: 2,
        onClick: () => {
          r("Relogin");
        },
        children: /* @__PURE__ */ e.jsx(
          X,
          {
            text: "Try logging in again",
            translationKey: "ReloginMessages/TryLoggingInAgain"
          }
        )
      }
    )
  ] });
}, ua = q(() => import("./DefaultChat-c34cad0d.js")), ha = q(() => import("./CelcomChat-9c9194fc.js")), pa = q(() => import("./MaxisChat-fdb4fe16.js")), xa = q(() => import("./CHTHomeChat-e6fb22de.js")), ga = q(() => import("./StarhubChat-189abc04.js")), ma = q(() => import("./SynnexChat-152e62b3.js")), fa = q(() => import("./THDigitalChat-5103586b.js")), ya = q(
  () => import("./twopenmarketslwChat-9d77db95.js")
), Sa = q(
  () => import("./Ty3cChat-4d1f71a3.js")
), ps = q(() => import("./JbhifiChat-e85bf9db.js")), ba = q(() => import("./M1Chat-3d043fd3.js")), Wo = ({
  onClose: t,
  onMinimize: s,
  styleProps: n,
  isLoggedIn: a,
  quickQuestion: r,
  isChatOpen: i,
  isChatMinimized: l,
  setHasChatsPending: c,
  customLoader: o = /* @__PURE__ */ e.jsx($t, {})
}) => {
  const { chatConfig: h } = ss(), { configure: x } = ca(), [f, b] = R(!1), [C, v] = R(!1), M = Z(), g = ["starhub"].includes(M), [j, S] = wt({
    profileId: "",
    userId: "",
    requestId: "",
    visitorId: ""
  }), [k] = et({
    authorization: "",
    token: "",
    id: ""
  }), w = async () => {
    Jr("cognitoUserSession"), await Kt(), t();
  }, { isLoading: d } = Gt({
    queryKey: ["chat"],
    queryFn: x,
    cacheTime: 0,
    enabled: !!h && !!k.token,
    onSuccess: (P) => {
      S({
        ...j,
        requestId: P ? P.requestId : "",
        visitorId: P ? P.visitorId : ""
      });
    },
    onError: () => {
      v(!0), S({
        ...j,
        requestId: "",
        visitorId: ""
      });
    },
    onSettled: () => {
      b(!0);
    }
  }), D = (P) => P != null && P.firstName || P != null && P.enrolledMdn ? {
    name: P.firstName ?? "User",
    mdn: P.enrolledMdn ?? "000000000",
    visitorId: P.visitorId ?? rt(),
    requestId: P.requestId ?? rt()
  } : {
    name: "Visitor",
    mdn: rt(),
    // create generic number for chatbot
    visitorId: rt(),
    // same with mdn..
    requestId: rt()
  }, U = () => {
    if (h && f)
      return { userInfo: D(j), ...h };
  }, _ = ct(() => {
    var P;
    if (f) {
      const A = U();
      if (A) {
        const W = ((P = A.chat.chatClient) == null ? void 0 : P.toUpperCase()) || A.chat.clientName.toUpperCase();
        return {
          STARHUB: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ga,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r,
              isChatOpen: i,
              customLoader: o
            }
          ) }),
          STARHUB4: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ps,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              isChatOpen: i,
              quickQuestion: r,
              customLoader: o,
              isChatMinimized: l,
              setHasChatsPending: c
            }
          ) }),
          CELCOM: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { children: o }), children: /* @__PURE__ */ e.jsx(
            ha,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r,
              isChatOpen: i,
              customLoader: o
            }
          ) }),
          THDIGITAL: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            fa,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a
            }
          ) }),
          SYNNEX: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ma,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r,
              isChatOpen: i
            }
          ) }),
          MAXIS: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            pa,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a
            }
          ) }),
          CHT_HOME: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            xa,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r,
              isChatOpen: i
            }
          ) }),
          JBHIFI: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ps,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              isChatOpen: i,
              quickQuestion: r,
              customLoader: o,
              isChatMinimized: l,
              setHasChatsPending: c
            }
          ) }),
          TWOPENMARKET_SLW: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ya,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r
            }
          ) }),
          M1: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
            ba,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              isChatOpen: i,
              quickQuestion: r,
              customLoader: o,
              isChatMinimized: l,
              setHasChatsPending: c
            }
          ) }),
          TY3C: /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { children: o }), children: /* @__PURE__ */ e.jsx(
            Sa,
            {
              config: A,
              onClose: w,
              onMinimize: s,
              isLoggedIn: a,
              quickQuestion: r,
              isChatOpen: i,
              customLoader: o
            }
          ) })
        }[W] ?? /* @__PURE__ */ e.jsx(me, { fallback: /* @__PURE__ */ e.jsx(ge, { h: "full", children: o }), children: /* @__PURE__ */ e.jsx(
          ua,
          {
            config: A,
            onClose: w,
            isLoggedIn: a
          }
        ) });
      }
    }
  }, [d, f, i, l]);
  return C ? /* @__PURE__ */ e.jsx(da, {}) : /* @__PURE__ */ e.jsx(Je, { flexFlow: "column nowrap", align: "center", w: "full", h: "full", ...n, children: d ? /* @__PURE__ */ e.jsx(ge, { h: "full", children: g ? o : /* @__PURE__ */ e.jsx($t, {}) }) : _ });
}, ts = Fe({
  chatConfig: {
    appSyncGraphQL: {
      endpoint: "",
      region: "",
      authType: ""
    },
    amplifyConfig: {
      cognitoIdentityPoolId: "",
      cognitoRegion: "",
      cognitoUserPoolId: "",
      cognitoUserPoolWebClientId: ""
    },
    chat: {
      baseEndpoint: "",
      apiKey: "",
      environment: "",
      clientName: "",
      program: "",
      productName: ""
    },
    contentful: {
      space: "",
      token: "",
      env: ""
    }
  },
  firebaseConfig: null,
  baseApiConfig: {
    baseEndpoint: "",
    apiKey: "",
    hmacKey: ""
  }
}), wa = ({ config: t, baseApiConfig: s, children: n, MOCK_CHAT_CONFIG: a }) => {
  const r = (t == null ? void 0 : t.chatConfigCarrier) || En() || Z(), { data: i, refetch: l } = Gt({
    queryKey: ["chatConfigData"],
    queryFn: () => {
      var c;
      return Sn(t, `chat_config_${r}_${(c = t == null ? void 0 : t.env) == null ? void 0 : c.toLowerCase()}`).then((o) => o ? JSON.parse(o) : null).catch((o) => (console.error("Failed to fetch config ", o), null));
    },
    enabled: !1
  });
  return le(() => {
    t && l();
  }, [t]), /* @__PURE__ */ e.jsx(
    ts.Provider,
    {
      value: {
        chatConfig: a || i,
        firebaseConfig: t,
        baseApiConfig: s
      },
      children: n
    }
  );
}, ja = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatContext: ts,
  ChatProvider: wa
}, Symbol.toStringTag, { value: "Module" })), ss = () => {
  const t = Ne(ts);
  if (t === void 0)
    throw new Error("useChatConfig must be used within a ChatProvider");
  return {
    chatConfig: t.chatConfig,
    firebaseConfig: t.firebaseConfig,
    baseApiConfig: t.baseApiConfig
  };
}, ht = (t) => Pr.find(
  (s) => s.locale === t || s.name === t || s.code === t
) ?? {
  code: "EN",
  locale: "en-US",
  name: "English"
}, va = (t, s) => {
  try {
    return decodeURIComponent(escape(t));
  } catch {
    return s;
  }
}, Ia = ({
  onSelect: t = (a) => {
    console.log("Selected language", a);
  },
  boxProps: s,
  linkProps: n
}) => {
  const { data: a } = ce(), { languages: r, languagesAvailable: i, theme: l } = a, { components: c } = l, { languageSelector: o } = c, [h, x] = R({
    ...(i || r)[0]
  }), {
    updateActiveLanguage: f,
    language: b,
    isTranslationsLoading: C
  } = Tt(), v = o && o.link && o.link.color || "black", [M] = Rs("al", "");
  return le(() => {
    x(ht(M) ?? ht(b));
  }, []), le(() => {
    x(ht(b));
  }, [b]), !i && !r || (i == null ? void 0 : i.length) < 2 ? null : /* @__PURE__ */ e.jsx(
    hn,
    {
      alignItems: "center",
      maxW: "180px",
      id: "myasurion-language-selector",
      gap: 0,
      spacing: 0,
      ...s,
      children: (i || r) && (i || r).map((g, j) => /* @__PURE__ */ e.jsx(
        xe,
        {
          maxW: "40px",
          borderRight: j < (i || r).length - 1 ? "1px solid #fff" : "none",
          children: /* @__PURE__ */ e.jsx(Vt, { isLoaded: !C, children: /* @__PURE__ */ e.jsx(
            ie,
            {
              fontSize: "md",
              fontWeight: 400,
              color: v,
              variant: "link",
              w: "25px",
              h: "20px",
              textAlign: "center",
              textDecoration: h.code === g.code ? "underline" : "none",
              _hover: {
                color: v,
                textDecoration: "underline"
              },
              _selected: {
                color: v
              },
              onClick: () => {
                x({ ...g, index: j }), t({ ...g, index: j }), f(
                  ht(g.code).locale ?? "en-US"
                );
              },
              ...n,
              children: g != null && g.displayCode ? va(g.displayCode, g.code) : g.code
            }
          ) })
        },
        `lang-${g.code}-${j}`
      ))
    }
  );
}, ns = ({ children: t }) => /* @__PURE__ */ e.jsx(ws, { above: "md", children: t }), qt = ({ children: t }) => /* @__PURE__ */ e.jsx(ws, { below: "md", children: t }), xs = ({ onToggle: t }) => {
  const { data: s } = ce(), { theme: n } = s, { components: a } = n, { languageSelector: r } = a, { headerIsOpen: i } = Ds(), l = r && r.link && r.link.color || "#000";
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
    ie,
    {
      id: "myasurion-menubutton",
      as: ft,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: i ? /* @__PURE__ */ e.jsx(Is, { fill: l ?? "#000", color: l ?? "#000" }) : /* @__PURE__ */ e.jsx(qn, { fill: l ?? "#000" }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => t()
    }
  ) });
}, Ta = (t) => {
  const { data: s } = ce(), { theme: n } = s, { colors: a } = n, { primary: r } = a;
  return /* @__PURE__ */ e.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...t, children: [
    /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: r || "#8223D2",
        d: "M7 22h11c1.103 0 2-.897 2-2V4c0-1.102-.897-2-2-2H7c-1.103 0-2 .898-2 2v3h2V4h11v16H7v-3H5v3c0 1.103.897 2 2 2Z"
      }
    ),
    /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: r || "#8223D2",
        d: "m10.293 8.708 1.414-1.416 4.707 4.699-4.706 4.715-1.416-1.412L12.582 13H4v-2h8.59l-2.297-2.292Z"
      }
    )
  ] });
}, Aa = ({
  label: t,
  iconSrc: s,
  onSignOut: n,
  ...a
}) => {
  const [, r] = wt({}), [, i] = et({}), { data: l } = ce(), { theme: c } = l, { colors: o } = c, { accent: h } = o;
  return /* @__PURE__ */ e.jsxs(
    ie,
    {
      id: "myasurion-signout-link",
      w: "full",
      minW: "287px",
      p: "12px 20px",
      colorScheme: "primary",
      color: h,
      textDecoration: "underline",
      variant: "link",
      onClick: () => {
        localStorage.clear();
        const x = sessionStorage.getItem("p"), f = sessionStorage.getItem("al");
        sessionStorage.clear(), sessionStorage.setItem("p", x ?? ""), sessionStorage.setItem("al", f ?? ""), r({}), i({}), n && n();
      },
      ...a,
      children: [
        /* @__PURE__ */ e.jsx(ns, { children: /* @__PURE__ */ e.jsx(y, { mr: "8px", children: /* @__PURE__ */ e.jsx(Ta, {}) }) }),
        t || /* @__PURE__ */ e.jsx(X, { text: "Sign out", translationKey: "Global/Signout" })
      ]
    }
  );
}, Ca = ({
  firstname: t,
  lastname: s,
  accountType: n = "main account",
  signOutProps: a,
  serviceRequestButtonProps: r,
  skipUrlClick: i,
  ...l
}) => {
  const { data: c } = ce(), { urls: o, mainMenu: h } = c, { theme: x } = c, { serviceRequestBtn: f } = (x == null ? void 0 : x.components) || {}, b = Z(), C = Js(), v = (g) => {
    i && g && C(`/${g}`);
  }, M = (g) => g.split("/").pop();
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      id: "myasurion-menu-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      ...l,
      children: [
        /* @__PURE__ */ e.jsxs(
          Ke,
          {
            gap: 0,
            spacing: 0,
            w: "full",
            alignItems: "baseline",
            id: "myasurion-menu-display-stack",
            children: [
              /* @__PURE__ */ e.jsx(y, { w: "full", px: "16px", py: "24px", borderBottom: "1px solid #F0F0F5", children: /* @__PURE__ */ e.jsxs(He, { gap: 6, children: [
                /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(
                  lr,
                  {
                    firstname: t,
                    lastname: s,
                    carrier: b
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsxs(Ke, { alignItems: "baseline", children: [
                  /* @__PURE__ */ e.jsx(
                    I,
                    {
                      fontSize: "xs",
                      fontWeight: 900,
                      lineHeight: "136%",
                      textTransform: "uppercase",
                      children: /* @__PURE__ */ e.jsx(
                        X,
                        {
                          text: n,
                          translationKey: `MenuDisplay/${n}`
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    ot,
                    {
                      textTransform: "capitalize",
                      fontSize: "2xl",
                      lineHeight: "132%",
                      href: i ? "#" : `${Mt((o == null ? void 0 : o.profile) || "")}`,
                      onClick: (g) => {
                        i && (g.preventDefault(), v(o == null ? void 0 : o.profile));
                      },
                      _hover: { textDecoration: "none", cursor: "pointer" },
                      children: b === "cht_home" ? `${s} ${t}` : `${t} ${s}`
                    }
                  )
                ] }) }),
                /* @__PURE__ */ e.jsx(Lt, {}),
                /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(
                  ot,
                  {
                    href: `${Mt((o == null ? void 0 : o.profile) || "")}`,
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ e.jsx(os, { w: "24px", h: "24px", color: "#000" })
                  }
                ) })
              ] }) }),
              h && h.map((g, j) => {
                const S = Mt(g.url);
                return /* @__PURE__ */ e.jsx(y, { w: "full", px: "16px", py: "24px", children: /* @__PURE__ */ e.jsx(He, { children: /* @__PURE__ */ e.jsx(
                  ot,
                  {
                    fontSize: "2xl",
                    fontWeight: 300,
                    lineHeight: "132%",
                    href: i ? "#" : S,
                    onClick: (k) => {
                      i && (k.preventDefault(), v(M(S)));
                    },
                    w: "100%",
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ e.jsxs(St, { direction: "row", gap: 0, children: [
                      /* @__PURE__ */ e.jsx(y, { children: g.name }),
                      /* @__PURE__ */ e.jsx(Lt, {}),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(
                        os,
                        {
                          w: "24px",
                          h: "24px",
                          color: "#000"
                        }
                      ) })
                    ] })
                  }
                ) }) }, `menu-${g.code}-${j}`);
              })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(
          y,
          {
            id: "header-signout-section",
            position: "fixed",
            bottom: 0,
            w: "full",
            bg: "#FFFFFF",
            boxShadow: " 0px -4px 8px 0px rgba(0, 0, 0, 0.04)",
            children: /* @__PURE__ */ e.jsxs(Ke, { alignItems: "baseline", w: "full", gap: 6, p: "24px 16px", children: [
              r && r.enabled && /* @__PURE__ */ e.jsx(
                ie,
                {
                  ...f,
                  ...r == null ? void 0 : r.styleProps,
                  onClick: () => {
                    r != null && r.onClick && r.onClick();
                  },
                  children: (r == null ? void 0 : r.label) || "File a service request"
                }
              ),
              /* @__PURE__ */ e.jsx(
                Aa,
                {
                  label: (a == null ? void 0 : a.label) && a.label,
                  onSignOut: () => {
                    a != null && a.onSignOut && a.onSignOut();
                  },
                  margin: "0 auto",
                  ...a == null ? void 0 : a.styleProps
                }
              )
            ] })
          }
        )
      ]
    }
  );
}, Ma = (t) => {
  var s, n;
  return /* @__PURE__ */ e.jsxs(y, { position: "relative", p: "4px", children: [
    /* @__PURE__ */ e.jsxs(
      dn,
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        ...t,
        children: [
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0 12.279V15H18V12.279L17.316 12.052C15.931 11.589 15 10.298 15 8.838V6C15 2.691 12.309 0 9 0C5.691 0 3 2.691 3 6V8.838C3 10.298 2.069 11.589 0.684 12.052L0 12.279ZM14.966 13H3.035C4.255 11.998 5 10.486 5 8.838V6C5 3.794 6.794 2 9 2C11.206 2 13 3.794 13 6V8.838C13 10.486 13.745 11.998 14.966 13Z",
              fill: ((s = t == null ? void 0 : t.fill) == null ? void 0 : s.toString()) ?? "black"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              d: "M8.9997 18C7.5237 18 6.24769 17.19 5.55469 16H12.4447C11.7517 17.19 10.4757 18 8.9997 18Z",
              fill: ((n = t == null ? void 0 : t.fill) == null ? void 0 : n.toString()) ?? "black"
            }
          )
        ]
      }
    ),
    (t == null ? void 0 : t.promptcount) > 0 && /* @__PURE__ */ e.jsx(
      gt,
      {
        position: "absolute",
        top: "0",
        right: "0",
        minBlockSize: "14px",
        minInlineSize: "14px",
        minW: "14px",
        minH: "14px",
        padding: t.promptcount > 100 ? "4px" : "unset",
        verticalAlign: "middle",
        background: "#DB1B1B",
        children: /* @__PURE__ */ e.jsx(
          I,
          {
            fontWeight: 700,
            size: t.promptcount > 100 ? "7px" : "8px",
            lineHeight: "normal",
            fontSize: t.promptcount > 100 ? "7px" : "8px",
            textAlign: "center",
            color: "white",
            children: t.promptcount
          }
        )
      }
    )
  ] });
}, ka = ({
  onToggle: t,
  isLoading: s,
  promptCount: n
}) => {
  const { data: a } = ce(), { theme: r } = a, { components: i } = r, { languageSelector: l } = i, c = l && l.link && l.link.color || "#fff";
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
    ie,
    {
      id: "myasurion-menubutton",
      as: ft,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: /* @__PURE__ */ e.jsx(Vt, { isLoaded: !s, p: s ? "2px" : "0", children: /* @__PURE__ */ e.jsx(
        Ma,
        {
          fill: c ?? "#fff",
          promptcount: n ?? 0
        }
      ) }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => t(),
      h: "min-content"
    }
  ) });
}, Ea = ({
  notificationsCount: t,
  notifications: s,
  ...n
}) => {
  var c;
  const { data: a } = ce(), { theme: r } = a, { colors: i } = r, { language: l } = Tt();
  return /* @__PURE__ */ e.jsx(
    y,
    {
      id: "myasurion-notifications-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      color: "black",
      overflowY: "auto",
      ...n,
      children: /* @__PURE__ */ e.jsxs(
        Ke,
        {
          gap: 0,
          spacing: 0,
          w: "full",
          alignItems: "baseline",
          id: "myasurion-notifications-display-stack",
          maxW: { base: "initial", lg: "768px", xl: "992px", "2xl": "1280px" },
          mx: "auto",
          pt: { md: 8 },
          children: [
            /* @__PURE__ */ e.jsx(y, { w: "full", px: "16px", py: "16px", children: /* @__PURE__ */ e.jsxs(He, { gap: 6, children: [
              /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsxs(Ke, { alignItems: "baseline", gap: 1, children: [
                /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontSize: "2xl",
                    fontWeight: 400,
                    lineHeight: "132%",
                    fontStyle: "normal",
                    children: /* @__PURE__ */ e.jsx(
                      X,
                      {
                        translationKey: "Global/Notifications",
                        text: "notifications"
                      }
                    )
                  }
                ),
                s && Array.isArray(s) && /* @__PURE__ */ e.jsxs(
                  I,
                  {
                    fontSize: "md",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "124%",
                    color: "#6E767D",
                    children: [
                      l === "th-TH" ? "ล่าสุดวันที่" : "Last",
                      " ",
                      new Date(
                        (c = s[0]) == null ? void 0 : c.NotificationDate
                      ).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                      })
                    ]
                  }
                )
              ] }) }),
              /* @__PURE__ */ e.jsx(Lt, {})
            ] }) }),
            s && Array.isArray(s) && (s == null ? void 0 : s.map((o, h) => /* @__PURE__ */ e.jsx(y, { w: "full", px: "16px", children: /* @__PURE__ */ e.jsxs(
              L,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                borderBottom: "1px solid #D5D6DA",
                gap: "8px",
                children: [
                  /* @__PURE__ */ e.jsx(
                    I,
                    {
                      fontSize: "18px",
                      fontWeight: 700,
                      lineHeight: "132%",
                      color: (o == null ? void 0 : o.IsResolved) === "N" ? i.primary : "black",
                      children: l === "th-TH" ? (o == null ? void 0 : o.ServiceRequestEventDescTl) ?? (o == null ? void 0 : o.ServiceRequestEventDesc) : o == null ? void 0 : o.ServiceRequestEventDesc
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    I,
                    {
                      fontSize: "md",
                      fontWeight: (o == null ? void 0 : o.IsResolved) === "N" ? 700 : 400,
                      lineHeight: "124%",
                      fontStyle: "normal",
                      children: l === "th-TH" ? o == null ? void 0 : o.NotificationBodyTL : o == null ? void 0 : o.NotificationBody
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    I,
                    {
                      fontSize: "sm",
                      fontStyle: "normal",
                      lineHeight: "136%",
                      fontWeight: 400,
                      color: "#6E767D",
                      children: cr(new Date(o == null ? void 0 : o.EventDate), "d MMMM yyyy h:mm aaa")
                    }
                  )
                ]
              }
            ) }, `notifs-${o == null ? void 0 : o.AgreementId}-${h}`))),
            (!s || !Array.isArray(s) || (s == null ? void 0 : s.length) === 0) && /* @__PURE__ */ e.jsx(y, { w: "full", px: "16px", children: /* @__PURE__ */ e.jsx(
              L,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                gap: "8px",
                children: /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontSize: "18px",
                    fontWeight: 700,
                    lineHeight: "132%",
                    color: i.primary,
                    children: "No Pending Notifications"
                  }
                )
              }
            ) })
          ]
        }
      )
    }
  );
}, Na = ({
  account: t,
  children: s,
  headerMenu: n,
  authenticated: a,
  showBack: r,
  showBackText: i,
  onToggleMenu: l,
  onToggleNotifications: c,
  onClickBack: o,
  languageSelectorProps: h,
  signOutProps: x,
  serviceRequestButtonProps: f,
  onClickLanding: b,
  skipUrlClick: C,
  ...v
}) => {
  var V, he, oe;
  const [M, g] = Gr(), [j, S] = R(void 0), { data: k } = ce(), { theme: w } = k, { header: d, favicon: D } = w, { updateHeaderIsOpen: U, headerIsOpen: _, updateNoficationsIsOpen: P, notificationsIsOpen: A } = Ds(), W = dr("notifications"), { notifications: se, isNotificationsLoading: de, promptCount: $ } = yr(), { chatConfig: ee, firebaseConfig: ye } = ss(), J = {
    spaceIdRef: ee == null ? void 0 : ee.contentful.space,
    accessTokenRef: ee == null ? void 0 : ee.contentful.token,
    environmentRef: ee == null ? void 0 : ee.contentful.env,
    firebaseConfig: ye
  }, { imageUrl: H, isLoading: Se } = Vr(
    d.logoSlug,
    J == null ? void 0 : J.spaceIdRef,
    J == null ? void 0 : J.accessTokenRef,
    J == null ? void 0 : J.environmentRef,
    J == null ? void 0 : J.firebaseConfig
  ), be = ke(
    (re) => {
      U(re !== void 0 ? re : (pe) => (l && l(!pe), !pe)), P(!1), window.scrollTo(0, 0);
    },
    [_]
  ), ve = ke(
    (re) => {
      P(re !== void 0 ? re : (pe) => (c && c(!pe), !pe)), U(!1), window.scrollTo(0, 0);
    },
    [A]
  ), G = ke(() => {
    P(!1), window.location.href = "/profile";
  }, []), ne = ke((re) => {
    h != null && h.onSelect && (h == null || h.onSelect(re));
  }, []);
  return D && ((V = document.getElementById("favicon")) == null || V.setAttribute("href", D)), le(() => {
    Se || S(H ?? void 0);
  }, [Se, H]), le(() => {
    _ || A ? M() : g();
  }, [_, A]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      xe,
      {
        id: "myasurion-header",
        pos: "fixed",
        h: "56px",
        top: 0,
        left: 0,
        w: "full",
        p: "10px 16px",
        bg: d.bg || "white",
        zIndex: 999999,
        boxShadow: "0px 4px 8px 0px #00000014, 0px 1px 0px 0px #00000029 inset",
        ...v,
        children: r ? /* @__PURE__ */ e.jsx(xe, { alignItems: "end", w: "full", p: "8px 16px 4px 16px", children: /* @__PURE__ */ e.jsx(
          ie,
          {
            variant: "link",
            colorScheme: "black",
            onClick: () => {
              o && o();
            },
            leftIcon: /* @__PURE__ */ e.jsx(un, {}),
            children: /* @__PURE__ */ e.jsx(I, { children: i || "Back" })
          }
        ) }) : /* @__PURE__ */ e.jsxs(xe, { alignItems: "end", w: "full", children: [
          s && s,
          !s && /* @__PURE__ */ e.jsxs(He, { h: "36px", justifyContent: "space-between", children: [
            /* @__PURE__ */ e.jsx(xe, { children: /* @__PURE__ */ e.jsx(
              ot,
              {
                href: ((he = Z()) == null ? void 0 : he.toLowerCase()) === "starhub" || ((oe = Z()) == null ? void 0 : oe.toLowerCase()) === "celcom" ? "#" : bn(),
                onClick: () => b && b(),
                _hover: { textDecoration: "none", cursor: "pointer" },
                children: Se ? /* @__PURE__ */ e.jsx($t, {}) : /* @__PURE__ */ e.jsx(
                  dt,
                  {
                    src: j ?? d.logo,
                    alt: "header logo",
                    maxH: d.maxHeight ?? "36px"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsxs(He, { gap: 4, children: [
              /* @__PURE__ */ e.jsx(
                Ia,
                {
                  boxProps: h == null ? void 0 : h.boxProps,
                  linkProps: h == null ? void 0 : h.linkProps,
                  onSelect: ne
                }
              ),
              a && n ? n : /* @__PURE__ */ e.jsx(e.Fragment, {}),
              a && W && /* @__PURE__ */ e.jsx(
                ka,
                {
                  onToggle: ve,
                  isLoading: de,
                  promptCount: $
                }
              ),
              a && !n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(qt, { children: /* @__PURE__ */ e.jsx(xs, { onToggle: be }) }),
                /* @__PURE__ */ e.jsx(ns, { children: /* @__PURE__ */ e.jsx(xs, { onToggle: G }) })
              ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {})
            ] })
          ] })
        ] })
      }
    ),
    _ && /* @__PURE__ */ e.jsx(
      Ca,
      {
        pt: "50px",
        firstname: (t == null ? void 0 : t.firstName) || "",
        lastname: (t == null ? void 0 : t.lastName) || "",
        signOutProps: {
          label: (x == null ? void 0 : x.label) && x.label,
          onSignOut: () => {
            be(!1), x != null && x.onSignOut && (x == null || x.onSignOut());
          }
        },
        serviceRequestButtonProps: {
          enabled: f && f.enabled || !1,
          label: (f == null ? void 0 : f.label) && f.label,
          onClick: () => {
            be(!1), f != null && f.onClick && (f == null || f.onClick());
          }
        },
        skipUrlClick: C
      }
    ),
    W && A && /* @__PURE__ */ e.jsx(
      Ea,
      {
        pt: "50px",
        notifications: se,
        isLoading: de
      }
    )
  ] });
}, Da = "/images/carriers/asurion/expert-group.png", Te = {
  title: "Need help?",
  heading: "Hey 👋 I’m Anna, your Tech specialist.",
  subheading: "Our team is here to help!",
  searchTitle: "You might be searching for this...",
  keywords: ["Like for Like", "Service request fee", "Storage Capacity", "Wipe my Phone"]
}, Ho = ({
  title: t = Te.title,
  heading: s,
  subheading: n,
  searchTitle: a,
  keywords: r = Te.keywords,
  images: i,
  doAnimate: l = !1,
  expertGroupImage: c,
  ...o
}) => /* @__PURE__ */ e.jsx(
  y,
  {
    id: "myasurion-customer-support-footer",
    w: "100%",
    h: { base: "409", md: "190px" },
    m: "0",
    minW: "320px",
    p: 0,
    bg: "#F0F0F5",
    zIndex: 15,
    ...o,
    children: /* @__PURE__ */ e.jsxs(
      y,
      {
        id: "footer-container",
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
        w: "100%",
        children: [
          /* @__PURE__ */ e.jsx(
            Ra,
            {
              title: t,
              heading: s,
              subheading: n,
              searchTitle: a,
              keywords: r,
              images: i,
              doAnimate: l,
              expertGroupImage: c,
              ...o
            }
          ),
          /* @__PURE__ */ e.jsx(
            Pa,
            {
              title: t,
              heading: s,
              subheading: n,
              searchTitle: a,
              keywords: r,
              images: i,
              doAnimate: l,
              expertGroupImage: c,
              ...o
            }
          )
        ]
      }
    )
  }
), Ua = rn`
    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
`, Pa = ({
  heading: t,
  subheading: s,
  images: n,
  onSendQuestion: a
}) => {
  const [r, i] = R(""), [l] = Cs("al", ""), c = "CustomerSupportFooter", o = "Global";
  Z();
  const h = (f) => {
    f.code === "Enter" && r.trim().length > 0 && (a == null || a(r), i(""));
  }, x = () => {
    r && (a == null || a(r), i(""));
  };
  return /* @__PURE__ */ e.jsx(ns, { children: /* @__PURE__ */ e.jsx(ge, { w: "full", children: /* @__PURE__ */ e.jsxs(
    He,
    {
      h: "full",
      maxW: "800px",
      w: "full",
      justifyContent: "center",
      gap: "20px",
      mt: "47px",
      children: [
        /* @__PURE__ */ e.jsx(y, { w: "96px", h: "96px", display: "flex", alignItems: "center", children: n == null ? void 0 : n.map((f, b) => f.view === "desktop" ? /* @__PURE__ */ e.jsx(
          dt,
          {
            src: f.url,
            alt: "expert img",
            w: "96px",
            h: "96px"
          },
          `img-desktop-footer-${b}`
        ) : /* @__PURE__ */ e.jsx(e.Fragment, {})) }),
        /* @__PURE__ */ e.jsxs(y, { w: "300px", children: [
          /* @__PURE__ */ e.jsx(I, { fontWeight: 400, fontSize: "2xl", color: "black", m: 0, children: /* @__PURE__ */ e.jsx(
            X,
            {
              text: t || Te.heading,
              translationKey: `${o}/${c}_heading`
            }
          ) }),
          /* @__PURE__ */ e.jsx(I, { fontWeight: 700, fontSize: "lg", color: "black", m: 0, children: /* @__PURE__ */ e.jsx(
            X,
            {
              text: s || Te.subheading,
              translationKey: `${o}/${c}_subheading`
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(y, { w: "430px", children: /* @__PURE__ */ e.jsxs(Yt, { children: [
          /* @__PURE__ */ e.jsx(
            bt,
            {
              className: "onboarding__chat",
              placeholder: (
                // hardcode this for now hopefully just now
                l === "zh-Hant-TW" ? "我想知道…" : l === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
              ),
              outline: "2px solid transparent",
              w: "100%",
              h: "56px",
              "outline-offset": "2px",
              pos: "relative",
              appearance: "none",
              backgroundColor: "#fff",
              border: "1px solid #000",
              color: "rgb(26, 32, 44)",
              cursor: "text",
              boxSizing: "border-box",
              padding: "0 40px 0 16px",
              borderRadius: "6px",
              fontSize: "16px",
              value: r,
              onChange: ({ target: f }) => i(f.value),
              onKeyDown: h
            }
          ),
          /* @__PURE__ */ e.jsx(js, { cursor: "pointer", w: "40px", h: "40px", zIndex: "2", children: /* @__PURE__ */ e.jsx(
            Ts,
            {
              stroke: "black",
              fill: "black",
              color: "black",
              onClick: x
            }
          ) })
        ] }) })
      ]
    }
  ) }) });
}, Ra = ({
  title: t = Te.title,
  heading: s,
  subheading: n,
  searchTitle: a,
  keywords: r = Te.keywords,
  images: i,
  doAnimate: l = !1,
  expertGroupImage: c,
  onSendQuestion: o,
  onClickKeyword: h
}) => {
  const [x, f] = R(""), b = pr("portal", "stnFooterKeywords"), C = "CustomerSupportFooter", v = "Global", { language: M } = Tt(), g = (w) => {
    w.code === "Enter" && x.trim().length > 0 && (o == null || o(x), f(""));
  }, j = () => {
    x && (o == null || o(x), f(""));
  }, S = jt(), k = Z();
  return /* @__PURE__ */ e.jsx(qt, { children: /* @__PURE__ */ e.jsxs(
    L,
    {
      id: "experts-chat-container",
      padding: "24px 16px",
      flexFlow: "column nowrap",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
      background: "#F0F0F5",
      children: [
        /* @__PURE__ */ e.jsx(
          L,
          {
            id: "footer-title",
            alignItems: "flex-start",
            gap: "8px",
            alignSelf: "stretch",
            height: "32px",
            children: /* @__PURE__ */ e.jsx(vs, { as: "h2", fontSize: "2xl", fontWeight: "normal", lineHeight: "8", m: 0, children: /* @__PURE__ */ e.jsx(I, { color: "black", m: 0, children: /* @__PURE__ */ e.jsx(
              X,
              {
                text: t || Te.title || "Need help?",
                translationKey: `${v}/${C}_title`
              }
            ) }) })
          }
        ),
        /* @__PURE__ */ e.jsxs(
          L,
          {
            id: "footer-expert-search",
            flexFlow: "column nowrap",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
            children: [
              /* @__PURE__ */ e.jsxs(
                y,
                {
                  id: "footer-expert-search-expert-container",
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    /* @__PURE__ */ e.jsx(
                      y,
                      {
                        id: "expert-images",
                        display: "flex",
                        flexFlow: "column nowrap",
                        alignItems: "center",
                        alignSelf: "stretch",
                        children: /* @__PURE__ */ e.jsx(
                          y,
                          {
                            id: "expert-images-content",
                            display: "flex",
                            padding: "0px 16px",
                            flexFlow: "column nowrap",
                            alignItems: "flex-start",
                            gap: "16px",
                            children: /* @__PURE__ */ e.jsx(qt, { children: /* @__PURE__ */ e.jsx(y, { id: "expert-images-group", children: /* @__PURE__ */ e.jsx(
                              L,
                              {
                                flexFlow: "row nowrap",
                                position: "relative",
                                gap: "42px",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "96px",
                                children: i && !c ? i.map((w) => {
                                  if (w.view === "mobile")
                                    return /* @__PURE__ */ e.jsx(
                                      za,
                                      {
                                        img: w.url,
                                        position: w.position,
                                        doAnimate: l
                                      },
                                      w.position
                                    );
                                }) : /* @__PURE__ */ e.jsx(
                                  dt,
                                  {
                                    src: c ?? `${S === "repair" ? "/portal" : ""}${Da}`,
                                    alt: "expert group"
                                  }
                                )
                              }
                            ) }) })
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(L, { flexFlow: "column", children: [
                      /* @__PURE__ */ e.jsx(
                        I,
                        {
                          align: "center",
                          fontWeight: "light",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ e.jsx(
                            X,
                            {
                              text: s || Te.heading,
                              translationKey: `${v}/${C}_heading`
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        I,
                        {
                          align: "center",
                          fontWeight: "bold",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ e.jsx(
                            X,
                            {
                              text: n || Te.subheading,
                              translationKey: `${v}/${C}_subheading`
                            }
                          )
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ e.jsxs(Yt, { children: [
                /* @__PURE__ */ e.jsx(
                  bt,
                  {
                    className: "onboarding__chat",
                    placeholder: (
                      // hardcode this for now hopefully just now
                      M === "zh-Hant-TW" ? "我想知道…" : M === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
                    ),
                    outline: "2px solid transparent",
                    w: "100%",
                    "outline-offset": "2px",
                    pos: "relative",
                    appearance: "none",
                    backgroundColor: "#fff",
                    borderColor: "inherit",
                    border: "2px solid #A5AAAF",
                    color: "rgb(26, 32, 44)",
                    cursor: "text",
                    boxSizing: "border-box",
                    padding: "0 40px 0 16px",
                    height: "40px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    value: x,
                    onChange: ({ target: w }) => f(w.value),
                    onKeyDown: g
                  }
                ),
                /* @__PURE__ */ e.jsx(js, { w: "40px", h: "40px", zIndex: "2", cursor: "pointer", children: /* @__PURE__ */ e.jsx(
                  Ts,
                  {
                    stroke: "black",
                    fill: "black",
                    color: "black",
                    onClick: j
                  }
                ) })
              ] }),
              !b && /* @__PURE__ */ e.jsxs(
                y,
                {
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    k !== "starhub" && /* @__PURE__ */ e.jsx(
                      L,
                      {
                        id: "keywords-title",
                        alignItems: "flex-start",
                        alignSelf: "stretch",
                        children: /* @__PURE__ */ e.jsx(
                          I,
                          {
                            color: "#111111",
                            fontSize: "md",
                            fontWeight: "bold",
                            lineHeight: "124%",
                            children: /* @__PURE__ */ e.jsx(
                              X,
                              {
                                text: a || Te.searchTitle,
                                translationKey: `${v}/${C}_searchTitle`
                              }
                            )
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ e.jsx(L, { id: "keywords", flexFlow: "row wrap", gap: "16px", children: r.map((w) => /* @__PURE__ */ e.jsx(
                      I,
                      {
                        fontSize: "md",
                        fontWeight: "normal",
                        textDecorationLine: "underline",
                        lineHeight: "124%",
                        textAlign: "center",
                        cursor: "pointer",
                        m: 0,
                        color: "#000",
                        onClick: () => h == null ? void 0 : h(w),
                        children: /* @__PURE__ */ e.jsx(
                          X,
                          {
                            text: w,
                            translationKey: `${v}/${C}_keyword-${w}`
                          }
                        )
                      },
                      w
                    )) })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, za = ({
  img: t,
  position: s,
  doAnimate: n
}) => /* @__PURE__ */ e.jsx(
  L,
  {
    width: s === "middle" ? "96px" : "64px",
    height: s === "middle" ? "96px" : "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    position: s === "middle" ? "absolute" : "initial",
    zIndex: s === "middle" ? 2 : 1,
    borderRadius: "50%",
    children: /* @__PURE__ */ e.jsxs(y, { pos: "relative", children: [
      s === "middle" && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        n && /* @__PURE__ */ e.jsx(
          y,
          {
            border: "3px solid #008662",
            h: "25px",
            w: "25px",
            pos: "absolute",
            borderRadius: "30px",
            left: "8px",
            top: "0px",
            opacity: "0.0",
            animation: `${Ua} 1s ease-out infinite`,
            as: Wn.div,
            zIndex: "2"
          }
        ),
        /* @__PURE__ */ e.jsx(
          gt,
          {
            backgroundColor: "#008662",
            pos: "absolute",
            size: "15px",
            top: "5px",
            left: "13px",
            zIndex: "2"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs(gt, { size: s === "middle" ? "96px" : "64px", pos: "relative", children: [
        /* @__PURE__ */ e.jsx(
          dt,
          {
            src: t,
            alt: "expert img",
            borderRadius: "64px",
            width: s === "middle" ? "96px" : "64px",
            height: s === "middle" ? "96px" : "64px",
            flexShrink: "0"
          }
        ),
        s === "middle" && /* @__PURE__ */ e.jsx(
          gt,
          {
            size: "88px",
            pos: "absolute",
            "aria-roledescription": "circular border for middle expert",
            border: "4px solid white",
            zIndex: "1"
          }
        )
      ] })
    ] })
  }
), qo = async (t, s, n) => {
  var a;
  try {
    const r = +/* @__PURE__ */ new Date(), i = vt.SHA256(r.toString()).toString(), l = await t.get(
      `/content/strings?moduleId=${n}&language=${s}`,
      {
        headers: {
          Authorization: Xt(
            {
              httpPath: "/api/v1/content/strings",
              method: "GET",
              token: i
            },
            ((a = Hn.env) == null ? void 0 : a.hmacKey) ?? {}.VITE_MYASURION_API_AUTH_HMAC_KEY
          ),
          token: i,
          t: r
        }
      }
    ), { data: c } = l;
    return c;
  } catch (r) {
    return console.log(r), null;
  }
}, Bo = async (t, s, n, a, r) => {
  try {
    const i = +/* @__PURE__ */ new Date(), l = await t.put(
      "/content/strings",
      JSON.stringify({
        entryId: n,
        value: a,
        language: r
      }),
      {
        method: "PUT",
        headers: {
          authorization: s.authorization,
          token: s.token,
          t: i
        }
      }
    ), { data: c } = l;
    return c;
  } catch (i) {
    throw console.log(i), i;
  }
}, Fa = async (t, s, n, a, r, i) => {
  try {
    const l = +/* @__PURE__ */ new Date();
    if (!s.authorization && !s.token)
      throw "No headers to create";
    const c = await t.post(
      "/content/strings",
      JSON.stringify({
        moduleId: i || module,
        sectionId: r,
        pathId: n,
        value: a,
        usage: "static",
        autoPublish: "true"
      }),
      {
        method: "POST",
        headers: {
          authorization: s.authorization,
          token: s.token,
          t: l
        }
      }
    ), { data: o } = c;
    return console.log("create..."), o;
  } catch (l) {
    console.log(l);
  }
}, _s = Fe({
  translationComponents: [],
  registerComponent: () => {
  },
  unregisterComponent: () => {
  }
}), Go = ({ children: t }) => {
  const [s, n] = R([]), { translationAPI: a } = Nt(), { entries: r } = Nt(), i = async (o, h, x) => {
    var f;
    try {
      if (!a.api)
        throw "No api found for translation";
      if (!r)
        throw "No entries for translation";
      const b = r;
      if (!b || b.length === 0)
        throw "No fetched string data found";
      const C = (f = b.find((v) => v.id === x.section)) == null ? void 0 : f.text.findIndex((v) => v.path === x.path);
      (C === void 0 || C && C < 0) && Fa(
        a.api,
        { authorization: a.authorization, token: a.token },
        x.path,
        h,
        x.section,
        x.module
      ), n((v) => {
        let M = 0;
        const g = v.find((S, k) => (M = k, S.meta.path === x.path));
        if (g) {
          const S = [...v];
          return S[M] = { ...g, text: h, s: "active" }, S;
        }
        const j = v.reduce((S, k) => k.i > S ? k.i : S, 0);
        return [
          ...v,
          {
            FC: o,
            text: h,
            meta: x,
            i: j !== void 0 ? j + 1 : 0,
            s: "active"
          }
        ];
      });
    } catch (b) {
      console.log(b);
    }
  }, { localeLanguage: l } = Nt(), c = (o, h) => {
    n(
      (x) => x.map((f) => f.meta.path === h ? { ...f, s: "inactive" } : f)
    );
  };
  return le(() => {
    n((o) => o);
  }, [l]), /* @__PURE__ */ e.jsx(
    _s.Provider,
    {
      value: { translationComponents: s, registerComponent: i, unregisterComponent: c },
      children: t
    }
  );
}, Vo = () => Ne(_s), B = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), Yo = ({
  title: t = "Your request is submitted.",
  heading: s = "Your request ID:",
  requestId: n = "",
  text1: a = "",
  subheading1: r = "What happens next?",
  subheadingcontent1: i = "",
  DateTime: l = "",
  subheadingcontent2: c = "",
  subheading2: o = "",
  subheading2content1: h = "",
  subheading2content2: x = "",
  subheading3: f = "",
  subheading3content1: b = "",
  info1: C = "",
  info1content: v = "",
  info2: M = "",
  info2content: g = "",
  info3: j = "",
  info3content: S = "",
  searchTitle: k = "",
  lblhowtofind: w = "",
  lblrate: d = "",
  lblclose: D = "Close this page",
  rateButtonProps: U,
  closeButtonProps: _,
  howToFindButtonProps: P,
  IncidentType: A,
  doAnimate: W = !1,
  Date: se,
  expertGroupImage: de,
  serviceRequestdetails: $ = "",
  paymentBreakdown: ee = "",
  serviceRequestFee: ye = "",
  serviceRequestFeeAmount: J = "",
  dataTransferFeesVal: H = "",
  dataTransferFeesLBL: Se = "",
  nightDelivery: be = "",
  nightDeliveryAmount: ve = "",
  subTotal: G = "",
  subTotalAmount: ne = "",
  Discount: V = "",
  DiscountAmount: he = "",
  TotalAfterDiscount: oe = "",
  TotalAmountAfterDiscount: re = "",
  RequestedServicelbl: pe = "",
  Summarylbl: st = "",
  RequestedServicevalue: p = "",
  IMEIlbl: u = "",
  IMEIvalue: T = "",
  RequestTypelbl: m = "",
  RequestTypevalue: E = "",
  DeliveryAddresslbl: O = "",
  Deliveryaddressvalue: z = "",
  DeliveryDateTimelbl: F = "",
  DeliveryDateTimevalue: Y = "",
  returnAddrsLBL: ae,
  returnAddrsVal: je,
  returnDateTimeLBL: De,
  returnDateTimeVal: qe,
  LFLStock: Ce,
  isWarranty: ue = !1,
  isWalkin: _e = !1,
  make: At,
  showSurvey: Ks = !0,
  alternativeContactNumber: rs = "",
  warrantyReturn: Be = !1,
  ...as
}) => {
  const te = "ConfirmationAfterSubmission", { data: Ws } = ce(), { theme: Hs } = Ws, { colors: qs } = Hs, { accent: Bs } = qs;
  return console.log("props", as), console.log("incidentType", A), /* @__PURE__ */ e.jsxs(y, { children: [
    /* @__PURE__ */ e.jsxs(
      y,
      {
        p: "16px , 16px",
        ...as,
        w: { base: "full", lg: "60%" },
        margin: { base: "0", lg: "auto" },
        pb: { base: "0", lg: "100px" },
        children: [
          /* @__PURE__ */ e.jsx(I, { fontSize: "3xl", mb: "8px", children: /* @__PURE__ */ e.jsx(B, { text: t, translationKey: `${te}/title` }) }),
          /* @__PURE__ */ e.jsxs(L, { children: [
            /* @__PURE__ */ e.jsx(I, { fontSize: "lg", mr: 1, children: /* @__PURE__ */ e.jsx(B, { text: s, translationKey: `${te}/heading` }) }),
            /* @__PURE__ */ e.jsx(I, { as: "b", fontSize: "lg", children: n })
          ] }),
          Ce && /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(y, { mb: "34px", pt: "8px", children: /* @__PURE__ */ e.jsxs(
            L,
            {
              direction: { base: "column", lg: "row" },
              justifyContent: { base: "start", lg: "space-between" },
              children: [
                /* @__PURE__ */ e.jsxs(
                  y,
                  {
                    w: { base: "full", lg: "50%" },
                    border: { base: "none", lg: "1px" },
                    padding: { base: "0", lg: "10px 16px" },
                    borderRadius: { base: "none", lg: "16px" },
                    borderColor: { base: "none", lg: "#adaaaa" },
                    children: [
                      /* @__PURE__ */ e.jsx(I, { fontSize: "2xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
                        B,
                        {
                          text: $,
                          translationKey: `${te}/serviceRequestdetails`
                        }
                      ) }),
                      pe && /* @__PURE__ */ e.jsx(y, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        B,
                        {
                          text: pe,
                          translationKey: "Global/RequestedService"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: p }) }),
                      u && /* @__PURE__ */ e.jsx(y, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        B,
                        {
                          text: u,
                          translationKey: `${te}/lblIMEI`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: T }) }),
                      m && /* @__PURE__ */ e.jsx(y, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        B,
                        {
                          text: m,
                          translationKey: "Global/RequestType"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: E }) }),
                      rs && /* @__PURE__ */ e.jsx(y, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                        B,
                        {
                          text: "Alternate Contact Number",
                          translationKey: "Global/AlternativeContactNumber"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: rs }) }),
                      O && /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { fontWeight: 700, mt: 2, children: O }) }),
                      /* @__PURE__ */ e.jsx(y, { children: z }),
                      F && /* @__PURE__ */ e.jsx(y, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(I, { children: F }) }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: Y }) }),
                      /* @__PURE__ */ e.jsx(y, { mt: 2, fontWeight: 700, children: ae }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: je }) }),
                      /* @__PURE__ */ e.jsx(y, { mt: 2, fontWeight: 700, children: De }),
                      /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(I, { children: qe }) })
                    ]
                  }
                ),
                " ",
                (Be || !ue) && // warrantyreturn will be false for all other cases
                /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx(y, { display: { base: "none", lg: "block" }, children: /* @__PURE__ */ e.jsx("hr", { style: { marginTop: "8px" } }) }),
                  /* @__PURE__ */ e.jsx(y, { mt: "16px", mb: "16px", children: /* @__PURE__ */ e.jsx(
                    "hr",
                    {
                      style: {
                        border: "none",
                        borderTop: "2px solid #adaaaa"
                      }
                    }
                  ) }),
                  /* @__PURE__ */ e.jsxs(y, { w: { base: "full", lg: "45%" }, children: [
                    ee && /* @__PURE__ */ e.jsx(I, { my: 3, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: ee,
                        translationKey: `${te}/lblPaymentBreakdown`
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(
                      L,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: ye && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                          /* @__PURE__ */ e.jsx(I, { children: ye }),
                          /* @__PURE__ */ e.jsx(I, { children: J })
                        ] })
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      L,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          Se && /* @__PURE__ */ e.jsx(I, { children: /* @__PURE__ */ e.jsx(
                            B,
                            {
                              text: Se,
                              translationKey: `${te}/lblDataTransferFees`
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(I, { children: H })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      L,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          be && /* @__PURE__ */ e.jsx(I, { children: /* @__PURE__ */ e.jsx(
                            B,
                            {
                              text: be,
                              translationKey: `${te}/lblNightDelivery`
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(I, { children: ve })
                        ]
                      }
                    ),
                    !ue && /* @__PURE__ */ e.jsx(
                      "hr",
                      {
                        style: {
                          border: "none",
                          borderTop: "2px dotted #adaaaa"
                        }
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      L,
                      {
                        my: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          G && /* @__PURE__ */ e.jsx(I, { children: /* @__PURE__ */ e.jsx(
                            B,
                            {
                              text: G,
                              translationKey: "Global/Subtotal"
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(I, { children: ne })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      L,
                      {
                        mb: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          /* @__PURE__ */ e.jsx(I, { children: V }),
                          /* @__PURE__ */ e.jsx(I, { children: he })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      L,
                      {
                        mb: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          oe && /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                            B,
                            {
                              text: oe,
                              translationKey: "Global/Total"
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: re })
                        ]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e.jsx(y, { mt: "16px", mb: "16px", children: /* @__PURE__ */ e.jsx(
                    "hr",
                    {
                      style: {
                        border: "none",
                        borderTop: "2px solid #adaaaa"
                      }
                    }
                  ) })
                ] })
              ]
            }
          ) }) }),
          a && /* @__PURE__ */ e.jsx(I, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "36px", children: a }),
          /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            r && /* @__PURE__ */ e.jsx(
              I,
              {
                fontFamily: "Apercu Pro",
                fontWeight: "light",
                fontSize: "2xl",
                mb: "8px",
                children: /* @__PURE__ */ e.jsx(
                  B,
                  {
                    text: r,
                    translationKey: `${te}/lblSubheading1`
                  }
                )
              }
            ),
            i && /* @__PURE__ */ e.jsx(L, { children: /* @__PURE__ */ e.jsxs(
              I,
              {
                fontWeight: "light",
                fontSize: "lg",
                mb: "36px",
                children: [
                  i,
                  " ",
                  /* @__PURE__ */ e.jsx("b", { children: l })
                ]
              }
            ) })
          ] }),
          c && /* @__PURE__ */ e.jsx(
            I,
            {
              fontWeight: "light",
              fontSize: "lg",
              mb: "24px",
              children: c
            }
          ),
          o && /* @__PURE__ */ e.jsx(
            I,
            {
              fontWeight: "light",
              fontSize: "2xl",
              mb: "8px",
              children: /* @__PURE__ */ e.jsx(
                B,
                {
                  text: o,
                  translationKey: `${te}/lblSubheading2`
                }
              )
            }
          ),
          x && /* @__PURE__ */ e.jsx(I, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "8px", children: /* @__PURE__ */ e.jsx(
            B,
            {
              text: x,
              translationKey: `${te}/lblSubheading2Content2`
            }
          ) }),
          h && /* @__PURE__ */ e.jsx(I, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "8px", children: /* @__PURE__ */ e.jsx(
            B,
            {
              text: h,
              translationKey: `${te}/lblSubheading2Content1`
            }
          ) }),
          !Be && At && (A == null ? void 0 : A.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsx(St, { mb: "24px", p: "0px , 16px", children: /* @__PURE__ */ e.jsx(
            ie,
            {
              paddingY: "12px",
              colorScheme: "black",
              justifyContent: "flex-start",
              minWidth: "343px",
              fontWeight: "400",
              onClick: () => {
                var Ue;
                return (Ue = P == null ? void 0 : P.onClick) == null ? void 0 : Ue.call(P);
              },
              variant: "link",
              as: "u",
              children: w && /* @__PURE__ */ e.jsx(
                B,
                {
                  text: w,
                  translationKey: `${te}/lblHowToFind`
                }
              )
            }
          ) }),
          !Be && f && /* @__PURE__ */ e.jsx(I, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "2xl", mb: "8px", children: /* @__PURE__ */ e.jsx(
            B,
            {
              text: f,
              translationKey: `${te}/lblSubHeading3`
            }
          ) }),
          !Be && b && /* @__PURE__ */ e.jsx(
            I,
            {
              fontFamily: "Apercu Pro",
              fontWeight: "light",
              fontSize: "lg",
              mb: "24px",
              whiteSpace: "pre-line",
              children: /* @__PURE__ */ e.jsx(
                B,
                {
                  text: b,
                  translationKey: `${te}/lblSubheading3Content1`
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsxs(y, { children: [
            !Be && At && (A == null ? void 0 : A.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsxs(L, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                Bn,
                {
                  marginTop: "6px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(L, { direction: "column", children: [
                C && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: C,
                        translationKey: `${te}/lblInfo11`
                      }
                    )
                  }
                ),
                v && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: v,
                        translationKey: `${te}/lblInfo1Content`
                      }
                    )
                  }
                )
              ] })
            ] }),
            !Be && At && (A == null ? void 0 : A.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsxs(L, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                Gn,
                {
                  marginTop: "6px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(L, { direction: "column", children: [
                M && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: M,
                        translationKey: `${te}/lblInfo2`
                      }
                    )
                  }
                ),
                g && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: g,
                        translationKey: `${te}/lblInfo2Content`
                      }
                    )
                  }
                )
              ] })
            ] }),
            (A == null ? void 0 : A.toUpperCase()) === "SWAP" && /* @__PURE__ */ e.jsxs(L, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                Vn,
                {
                  marginTop: "4px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(L, { direction: "column", children: [
                j && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: j,
                        translationKey: `${te}/lblInfo3`
                      }
                    )
                  }
                ),
                S && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      B,
                      {
                        text: S,
                        translationKey: `${te}/lblInfo3content`
                      }
                    )
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      y,
      {
        position: { base: "relative", lg: "fixed" },
        bottom: "0",
        w: "full",
        mt: "36px",
        pb: "10px",
        bgColor: { base: "", lg: "#faf9f5" },
        display: Ks ? "block" : "none",
        children: [
          /* @__PURE__ */ e.jsx(y, { display: { base: "none", lg: "block" }, children: /* @__PURE__ */ e.jsx(
            "hr",
            {
              style: {
                border: "none",
                borderTop: "2px solid #adaaaa"
              }
            }
          ) }),
          /* @__PURE__ */ e.jsxs(L, { direction: { base: "column", lg: "row-reverse" }, align: "center", py: "10px", children: [
            /* @__PURE__ */ e.jsx(
              ie,
              {
                paddingX: "16px",
                paddingY: "12px",
                colorScheme: "primary",
                w: { base: "full", lg: "13%" },
                margin: "auto",
                onClick: () => {
                  var Ue;
                  return (Ue = U == null ? void 0 : U.onClick) == null ? void 0 : Ue.call(U);
                },
                children: d && /* @__PURE__ */ e.jsx(B, { text: d, translationKey: `${te}/lblRate` })
              }
            ),
            /* @__PURE__ */ e.jsx(
              ie,
              {
                paddingX: "16px",
                paddingY: "12px",
                color: Bs,
                w: { base: "full", lg: "5%" },
                margin: "auto",
                onClick: () => {
                  var Ue;
                  return (Ue = _ == null ? void 0 : _.onClick) == null ? void 0 : Ue.call(_);
                },
                cursor: "pointer",
                variant: "link",
                as: "u",
                children: D && /* @__PURE__ */ e.jsx(B, { text: D, translationKey: "Global/CloseThisPage" })
              }
            )
          ] })
        ]
      }
    )
  ] });
}, Ve = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), at = q(() => import("./TextInput-b86fef07.js").then((t) => ({ default: t.TextInput }))), Qo = ({
  newAddressQuestion: t,
  unitNumber: s,
  buildingName: n,
  blkNo: a,
  streetName: r,
  postalCode: i,
  isInvalidUnitNumber: l,
  isInvalidBuildingName: c,
  isInvalidBlkNo: o,
  isInvalidStreetName: h,
  isInvalidPostalCode: x,
  handleInputUnitNumber: f,
  handleInputBuildingName: b,
  handleInputBlkNo: C,
  handleInputStreetName: v,
  handleInpuPostalCode: M,
  ...g
}) => {
  const [j, S] = R(""), [k, w] = R(""), [d, D] = R(""), [U, _] = R(""), [P, A] = R(""), W = "NewAddress", se = async () => {
    de(), $(), ee(), ye(), J();
  };
  le(() => {
    se();
  }, []);
  const de = async () => {
    const H = await Qe(`${W}/unitNoPlaceholder`, "Unit Number");
    S(H);
  }, $ = async () => {
    const H = await Qe(
      `${W}/buildingNamePlaceholder`,
      "Building Name (optional)"
    );
    w(H);
  }, ee = async () => {
    const H = await Qe(`${W}/blkNoPlaceholder`, "Blk No.");
    D(H);
  }, ye = async () => {
    const H = await Qe(
      `${W}/streetNamePlaceholder`,
      "Street Name"
    );
    _(H);
  }, J = async () => {
    const H = await Qe(
      `${W}/postalCodePlaceholder`,
      "Postal Code"
    );
    A(H);
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(xe, { mx: 4, mt: 6, fontFamily: "Apercu Pro", children: [
    /* @__PURE__ */ e.jsx(Le, { fontSize: "md", fontWeight: 700, mb: 4, children: /* @__PURE__ */ e.jsx(
      Ve,
      {
        text: t,
        translationKey: `${W}/newAddressQuestion`
      }
    ) }),
    /* @__PURE__ */ e.jsxs(
      Je,
      {
        direction: { base: "column", lg: "row" },
        wrap: "wrap",
        justifyContent: { base: "start", lg: "space-between" },
        children: [
          /* @__PURE__ */ e.jsxs(
            Re,
            {
              isRequired: !0,
              isInvalid: l,
              w: { base: "full", lg: "48%" },
              mb: 4,
              children: [
                /* @__PURE__ */ e.jsx(
                  at,
                  {
                    type: "text",
                    showIcon: !1,
                    borderColor: "#A5AAAF",
                    placeholder: j || "",
                    value: s,
                    maxLength: 40,
                    onChange: (H) => {
                      f(H.value);
                    }
                  }
                ),
                l && /* @__PURE__ */ e.jsx(ze, { children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    text: "*Invalid unit number",
                    translationKey: `${W}/unitNoErrorMsg`
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs(
            Re,
            {
              w: { base: "full", lg: "48%" },
              isRequired: !1,
              isInvalid: c,
              mb: 4,
              children: [
                /* @__PURE__ */ e.jsx(
                  at,
                  {
                    type: "text",
                    showIcon: !1,
                    borderColor: "#A5AAAF",
                    placeholder: k || "",
                    value: n,
                    maxLength: 40,
                    onChange: (H) => {
                      b(H.value);
                    }
                  }
                ),
                c && /* @__PURE__ */ e.jsx(ze, { children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    text: "*Invalid building name",
                    translationKey: `${W}/buildingNameErrorMsg`
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs(
            Re,
            {
              w: { base: "full", lg: "48%" },
              isRequired: !0,
              isInvalid: o,
              mb: 4,
              children: [
                /* @__PURE__ */ e.jsx(
                  at,
                  {
                    type: "text",
                    showIcon: !1,
                    borderColor: "#A5AAAF",
                    placeholder: d || "",
                    value: a,
                    maxLength: 40,
                    onChange: (H) => {
                      C(H.value);
                    }
                  }
                ),
                o && /* @__PURE__ */ e.jsx(ze, { children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    text: "*Invalid block number",
                    translationKey: `${W}/blockNoErrorMsg`
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs(
            Re,
            {
              w: { base: "full", lg: "48%" },
              isRequired: !0,
              isInvalid: h,
              mb: 4,
              children: [
                /* @__PURE__ */ e.jsx(
                  at,
                  {
                    type: "text",
                    showIcon: !1,
                    borderColor: "#A5AAAF",
                    placeholder: U || "",
                    value: r,
                    maxLength: 40,
                    onChange: (H) => {
                      v(H.value);
                    }
                  }
                ),
                h && /* @__PURE__ */ e.jsx(ze, { children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    text: "*Invalid street name",
                    translationKey: `${W}/streetNameErrorMsg`
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs(
            Re,
            {
              w: { base: "full", lg: "48%" },
              isRequired: !0,
              isInvalid: x,
              mb: 4,
              children: [
                /* @__PURE__ */ e.jsx(
                  at,
                  {
                    maxLength: 6,
                    type: "text",
                    showIcon: !1,
                    borderColor: "#A5AAAF",
                    placeholder: P || "",
                    value: i,
                    onChange: (H) => {
                      M(H.value);
                    }
                  }
                ),
                x && /* @__PURE__ */ e.jsx(ze, { children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    text: "*Please enter valid 6 digit postal code",
                    translationKey: `${W}/postalCodeErrorMsg`
                  }
                ) })
              ]
            }
          )
        ]
      }
    )
  ] }) });
}, { useState: _a, useEffect: Oa } = Ae, $a = ({
  src: t = "",
  showPlayer: s = !0,
  minHeight: n = "70vh",
  width: a = "full"
}) => {
  const [r, i] = _a(window.matchMedia("(min-width: 1024px)").matches);
  return Oa(() => {
    window.matchMedia("(min-width: 1024px)").addEventListener("change", (l) => i(l.matches));
  }, []), /* @__PURE__ */ e.jsx(y, { display: `${s ? "block" : "none"}`, children: /* @__PURE__ */ e.jsx(
    "video",
    {
      style: {
        minHeight: r ? "320px" : n,
        objectFit: "cover",
        margin: "auto",
        width: r ? "full" : a
      },
      controls: !0,
      autoPlay: !1,
      src: t,
      playsInline: !0,
      preload: "none"
    }
  ) });
}, La = (t) => {
  const s = /* @__PURE__ */ new Date();
  if (t <= s)
    return "00:00";
  let n = Math.round(t.getSeconds() - s.getSeconds()), a = Math.round(t.getMinutes() - s.getMinutes());
  return n < 0 && (n = 60 + n, a = a - 1), a < 0 && (a = 60 + a), `${a.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}`;
}, Ka = ({ timer: t, parentCallback: s }) => {
  const [n, a] = R("02:00");
  return le(() => {
    if (t >= /* @__PURE__ */ new Date()) {
      const r = setInterval(() => {
        const i = La(t);
        a(i), s(i);
      }, 1e3);
      return () => clearInterval(r);
    }
  }, [t, n]), /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("span", { children: n }) });
}, Wa = /constructor/i.test(window.HTMLElement) || function(t) {
  return t.toString() === "[object SafariRemoteNotification]";
}(
  !window.safari || window.safari.pushNotification
), Os = !!document.documentMode, Ha = !Os && !!window.StyleMedia, $s = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime), qa = $s && navigator.userAgent.indexOf("Edg") != -1, Ba = {
  isSafari: Wa,
  isIE: Os,
  isEdge: Ha,
  isChrome: $s,
  isEdgeChromium: qa
}, Ga = () => {
  let t = window.navigator.userAgent, s = window.navigator.platform || navigator.userAgentData.platform, n = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"], a = ["Win32", "Win64", "Windows", "WinCE"], r = ["iPhone", "iPad", "iPod"], i = "";
  return n.indexOf(s) !== -1 ? i = "MACOS" : r.indexOf(s) !== -1 ? i = "IOS" : a.indexOf(s) !== -1 ? i = "WINDOWS" : /Android/.test(t) ? i = "ANDROID" : !i && /Linux/.test(s) && (i = "LINUX"), i;
}, Ye = () => {
  const t = Ga();
  return console.log("OS:", t), ["MACOS"].includes(t) && !Ba.isSafari ? "video/webm" : ["MACOS", "IOS"].includes(t) ? "video/mp4" : "video/webm";
};
(function() {
  typeof window > "u" || (navigator.mediaDevices === void 0 && (navigator.mediaDevices = {}), navigator.mediaDevices.getUserMedia === void 0 && (navigator.mediaDevices.getUserMedia = function(s) {
    const n = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    return n ? new Promise(function(a, r) {
      n.call(navigator, s, a, r);
    }) : (console.log("getUserMedia is not implemented in this browser"), Promise.reject(new Error("getUserMedia is not implemented in this browser")));
  }));
})();
function gs() {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}
var We;
let Va = (We = class extends Ae.Component {
  constructor(n) {
    super(n);
    N(this, "canvas", null);
    N(this, "ctx", null);
    N(this, "requestUserMediaId", 0);
    N(this, "unmounted", !1);
    N(this, "stream", null);
    N(this, "video", null);
    this.state = {
      hasUserMedia: !1
    };
  }
  componentDidMount() {
    const { state: n, props: a } = this;
    if (this.unmounted = !1, console.log("componentDidMount"), !gs()) {
      a.onUserMediaError("getUserMedia not supported"), console.log("componentDidMount : getUserMedia not supported");
      return;
    }
    n.hasUserMedia || this.requestUserMedia(), a.children && typeof a.children != "function" && (console.warn("children must be a function"), console.log("componentDidMount : children must be a function"));
  }
  componentDidUpdate(n) {
    const { props: a } = this;
    if (console.log("componentDidUpdate"), !gs()) {
      a.onUserMediaError("getUserMedia not supported"), console.log("getUserMedia not supported");
      return;
    }
    const r = JSON.stringify(n.audioConstraints) !== JSON.stringify(a.audioConstraints), i = JSON.stringify(n.videoConstraints) !== JSON.stringify(a.videoConstraints), l = n.minScreenshotWidth !== a.minScreenshotWidth, c = n.minScreenshotHeight !== a.minScreenshotHeight;
    (i || l || c) && (this.canvas = null, this.ctx = null), (r || i) && (console.log("stopAndCleanup from componentDidUpdate"), this.stopAndCleanup(), this.requestUserMedia());
  }
  componentWillUnmount() {
    console.log("componentWillUnmount"), console.log("stopAndCleanup from componentWillUnmount"), this.unmounted = !0, this.stopAndCleanup();
  }
  static stopMediaStream(n) {
    console.log("stopMediaStream"), console.log(" stream at stopMediaStream", n), n && (console.log("inside stream"), console.log(
      "inside stream stream.getVideoTracks ?? stream.getVideoTracks ??",
      n.getVideoTracks,
      n.getAudioTracks
    ), n.getVideoTracks && n.getAudioTracks ? (console.log("stream has audio video tracks"), n.getVideoTracks().map((a) => {
      console.log("video track", a), n.removeTrack(a), a.stop();
    }), n.getAudioTracks().map((a) => {
      console.log("audio track", a), n.removeTrack(a), a.stop();
    })) : (console.log("calling stream.stop function"), n.stop()));
  }
  stopAndCleanup() {
    const { state: n } = this;
    console.log("stopAndCleanup"), console.log("hasUserMedia ", n.hasUserMedia), n.hasUserMedia && (We.stopMediaStream(this.stream), n.src && window.URL.revokeObjectURL(n.src));
  }
  getScreenshot(n) {
    const { state: a, props: r } = this;
    if (!a.hasUserMedia)
      return null;
    const i = this.getCanvas(n);
    return i && i.toDataURL(r.screenshotFormat, r.screenshotQuality);
  }
  getCanvas(n) {
    const { state: a, props: r } = this;
    if (!this.video)
      return console.log("getCanvas this.video", !this.video), null;
    if (!a.hasUserMedia || !this.video.videoHeight)
      return console.log(
        "getCanvas !state.hasUserMedia || !this.video.videoHeight",
        !a.hasUserMedia + "  |  " + !this.video.videoHeight
      ), null;
    if (!this.ctx) {
      let c = this.video.videoWidth, o = this.video.videoHeight;
      if (!this.props.forceScreenshotSourceSize) {
        const h = c / o;
        c = r.minScreenshotWidth || this.video.clientWidth, o = c / h, r.minScreenshotHeight && o < r.minScreenshotHeight && (o = r.minScreenshotHeight, c = o * h);
      }
      this.canvas = document.createElement("canvas"), this.canvas.width = (n == null ? void 0 : n.width) || c, this.canvas.height = (n == null ? void 0 : n.height) || o, this.ctx = this.canvas.getContext("2d");
    }
    const { ctx: i, canvas: l } = this;
    return i && l && (r.mirrored && (i.translate(l.width, 0), i.scale(-1, 1)), i.imageSmoothingEnabled = r.imageSmoothing, i.drawImage(
      this.video,
      0,
      0,
      (n == null ? void 0 : n.width) || l.width,
      (n == null ? void 0 : n.height) || l.height
    ), r.mirrored && (i.scale(-1, 1), i.translate(-l.width, 0))), console.log("getCanvas return canvas", l), l;
  }
  requestUserMedia() {
    (() => {
      this.requestUserMediaId++;
      const a = this.requestUserMediaId;
      navigator.mediaDevices.getUserMedia({
        video: !0,
        audio: !0
      }).then((r) => {
        console.log("streams are", r), this.unmounted || a !== this.requestUserMediaId ? We.stopMediaStream(r) : this.handleUserMedia(null, r);
      }).catch((r) => {
        console.log("error before handle user media", r), this.handleUserMedia(r);
      });
    })();
  }
  handleUserMedia(n, a) {
    const { props: r } = this;
    if (console.log("handleUserMedia"), n || !a) {
      this.setState({ hasUserMedia: !1 }), r.onUserMediaError(n);
      return;
    }
    this.stream = a, console.log("has Video", this.video);
    try {
      this.video && (this.video.srcObject = a), console.log("setting handleUserMedia True"), this.setState({ hasUserMedia: !0 });
    } catch (i) {
      console.log("handleUserMedia catch", i), this.setState({
        hasUserMedia: !0,
        src: window.URL.createObjectURL(a)
      });
    }
    console.log("handleUserMedia before onUserMedia", a), r.onUserMedia(a);
  }
  render() {
    const { state: n, props: a } = this, {
      audio: r,
      muted: i,
      forceScreenshotSourceSize: l,
      onUserMedia: c,
      onUserMediaError: o,
      screenshotFormat: h,
      screenshotQuality: x,
      minScreenshotWidth: f,
      minScreenshotHeight: b,
      audioConstraints: C,
      videoConstraints: v,
      imageSmoothing: M,
      mirrored: g,
      style: j = {},
      children: S,
      ...k
    } = a;
    return g && { ...j, transform: `${j.transform || ""}` }, this.getScreenshot.bind(this), /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
      "video",
      {
        autoPlay: !0,
        src: n.src,
        muted: i,
        playsInline: !0,
        ref: (w) => {
          this.video = w;
        },
        style: {
          minHeight: "53vh",
          objectFit: "cover",
          margin: "auto",
          width: "full"
        }
      }
    ) });
  }
}, N(We, "defaultProps", {
  audio: !1,
  muted: !1,
  forceScreenshotSourceSize: !1,
  imageSmoothing: !0,
  mirrored: !0,
  onUserMedia: () => {
  },
  onUserMediaError: () => {
  },
  screenshotFormat: "image/webp",
  screenshotQuality: 0.92
}), We);
const { useState: Dt, useEffect: Ut, useCallback: Pt, useRef: ms } = Ae, Ya = ({
  showWebcam: t,
  capture: s,
  setSrc: n,
  setBlob: a,
  setCapturing: r
}) => {
  const i = /* @__PURE__ */ new Date(), [l, c] = Dt(i), o = ms({}), h = ms({}), [x, f] = Dt([]), [b, C] = Dt(window.matchMedia("(min-width: 768px)").matches);
  Ut(() => {
    window.matchMedia("(min-width: 768px)").addEventListener("change", (d) => C(d.matches));
  }, []);
  const v = (d) => {
    d === "00:00" && r("STOP");
  }, M = Pt(() => {
    console.log("mimeType:", Ye()), console.log("isMediaSupported:", MediaRecorder.isTypeSupported(Ye())), console.log("webcamRef is", o), console.log("webcamRef stream is", o.current.stream), h.current = new MediaRecorder(o.current.stream, {
      mimeType: MediaRecorder.isTypeSupported(Ye()) === !0 ? Ye() : "video/webm"
    }), h.current.addEventListener("dataavailable", j), h.current.addEventListener("stop", w), h.current.start(1e3);
  }, [o, r, h]), g = Pt(() => {
    if (h.current.state === "inactive")
      return h.current.stop();
    c(/* @__PURE__ */ new Date("02:00"));
  }, [h, o, r]), j = Pt(
    (d) => {
      console.log("handleDataAvailable", "Called", d), console.log("handleDataAvailable data", d == null ? void 0 : d.data), console.log("handleDataAvailable data size", d == null ? void 0 : d.data.size), (d == null ? void 0 : d.data.size) > 0 && f((D) => D.concat(d == null ? void 0 : d.data));
    },
    [f]
  ), S = () => {
    console.log("handleStartCaptureClick"), M(), i.setMinutes(i.getMinutes() + 2), c(i);
  }, k = (d) => {
    console.log("onUserMediaError", d);
  };
  Ut(() => {
    if (x.length) {
      const d = new Blob(x, {
        type: MediaRecorder.isTypeSupported(Ye()) === !0 ? Ye() : "video/webm"
      });
      console.log("BLOB is", d), a(d);
      const D = URL.createObjectURL(d);
      console.log("URL is", D), n(D);
    }
  }, [x]), Ut(() => {
    s === "STOP" ? g() : s === "START" && f([]);
  }, [s]);
  const w = (d) => {
    console.log("data available after MediaRecorder.stop() called."), console.log("data available after MediaRecorder.stop() called.", d), console.log("recorder stopped");
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: t && /* @__PURE__ */ e.jsxs("div", { className: "text-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: b ? "" : "webcam-container", children: /* @__PURE__ */ e.jsx(
      Va,
      {
        audio: !0,
        muted: !0,
        autoPlay: !0,
        ref: o,
        onUserMedia: S,
        onUserMediaError: k,
        mirrored: !0
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        style: { display: "flex", justifyContent: "end" },
        className: b ? "" : "timer-overlay",
        children: /* @__PURE__ */ e.jsx(
          "div",
          {
            style: {
              background: "black",
              color: "white",
              display: "inline-block",
              paddingInline: "5px"
            },
            children: /* @__PURE__ */ e.jsx(
              Ka,
              {
                parentCallback: (d) => v(d),
                timer: l
              }
            )
          }
        )
      }
    )
  ] }) });
}, $e = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), Jo = ({
  handleSubmit: t,
  CarouselbtnLable: s,
  carouselContent: n,
  uploadStatus: a,
  handleNextClick: r
}) => {
  const [i, l] = R(""), [c, o] = R(new Blob([""])), [h, x] = R("START"), f = "VideoDeclaration", { data: b } = ce(), { theme: C } = b, { colors: v } = C, M = (d) => {
    o(d);
  }, g = (d) => {
    l(d);
  }, j = (d) => {
    x(d);
  }, S = () => {
    x("START");
  }, k = () => {
    x("STOP");
  }, w = (d) => d == null ? void 0 : d.map((D) => /* @__PURE__ */ e.jsxs(y, { pb: "2rem", children: [
    /* @__PURE__ */ e.jsx(I, { textAlign: "justify", children: D.headerText }),
    /* @__PURE__ */ e.jsx(
      I,
      {
        textColor: "#008662",
        paddingTop: "0.5rem",
        textAlign: "left",
        fontSize: "18px",
        children: D.bodyText
      }
    )
  ] }));
  return /* @__PURE__ */ e.jsxs("div", { style: { position: "relative", minHeight: "100vh" }, children: [
    /* @__PURE__ */ e.jsx(
      Ya,
      {
        capture: h,
        showWebcam: h === "START",
        setSrc: g,
        setBlob: M,
        setCapturing: j
      }
    ),
    /* @__PURE__ */ e.jsx($a, { showPlayer: h === "STOP", src: i }),
    /* @__PURE__ */ e.jsxs(
      y,
      {
        style: {
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%"
        },
        children: [
          h === "START" && a === "NONE" && /* @__PURE__ */ e.jsxs(
            y,
            {
              bg: "white",
              maxHeight: "285px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ e.jsx(
                  Yn.Carousel,
                  {
                    showArrows: !1,
                    showStatus: !1,
                    autoPlay: !0,
                    interval: 1e4,
                    children: w(n)
                  }
                ),
                /* @__PURE__ */ e.jsx(y, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ e.jsx(
                  ie,
                  {
                    variant: "outline",
                    onClick: () => {
                      k();
                    },
                    bg: v == null ? void 0 : v.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mb: "0.5rem",
                    children: /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        text: s,
                        translationKey: `${f}/CarouselbtnLable`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          h !== "START" && a === "NONE" && /* @__PURE__ */ e.jsxs(
            y,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: "Press play to review your video" }),
                /* @__PURE__ */ e.jsx(y, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ e.jsx(
                  ie,
                  {
                    variant: "outline",
                    onClick: () => {
                      t(c);
                    },
                    bg: v == null ? void 0 : v.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        text: "Submit video declaration",
                        translationKey: `${f}/btnSubmit`
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ e.jsx(
                  ot,
                  {
                    color: v == null ? void 0 : v.accent,
                    marginTop: "20px",
                    textDecoration: "underline",
                    onClick: () => S(),
                    fontWeight: 700,
                    children: /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        text: "Re-take video",
                        translationKey: `${f}/btnRetake`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          a === "INPROGRESS" && /* @__PURE__ */ e.jsxs(
            y,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                  $e,
                  {
                    text: "Please wait while we upload your video...",
                    translationKey: `${f}/labelPleaseWait`
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ e.jsx(
                  ie,
                  {
                    isLoading: !0,
                    loadingText: "Uploading video...",
                    colorScheme: "primary",
                    variant: "outline",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        text: "Uploading video...",
                        translationKey: `${f}/labelUploadingVideo`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          a === "COMPLETED" && /* @__PURE__ */ e.jsxs(
            y,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                  $e,
                  {
                    text: "Your video declaration is submitted!",
                    translationKey: `${f}/labelVideoSubmitted`
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ e.jsx(
                  ie,
                  {
                    variant: "outline",
                    onClick: () => {
                      r();
                    },
                    bg: v == null ? void 0 : v.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        text: "Next",
                        translationKey: `${f}/nextButtonText`
                      }
                    )
                  }
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
}, Qa = sr(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDsAOsB0BLCAbMAxAGICiAKgMIASA2gAwC6ioqA9rFgC5avLMgAPRAEYAbMIwBmaZICssuqIBMADnGyAnABoQATxFKA7BgAshpUroLZS4So0BfBzrSYAZmE4BjABZZkUADKAK4ATgBuYLoEELxg2MjhrADW8a4YHt5+ASERUQj+SV4Ahty89AwV-GwcZXxIgogmoipSdLZKspImJnQmGmI6+gjCPaYaExqSwhoqsqJ0hpJOLugZnr7+QWGR0WChoayhGKi4pW5HALYY6ZmbOTv5hawldRVVDTVcPPWgQgjNVqSdrCTrdXr9QZ6RAqEwYQwKOh0OSiQx0YR0WYrEDpWBgfBeTiBLxHQiBEgAGRIFDIAH1AhQAPIAJRIHxY7G+vH4-zUEjkJlsshMNgmnSGIhMElEMtEwsFJkkSimSiczhxrAgcH4rmqnLqPMQAFpRBKECaMEirdbraNsekcPg9bUfoaAUozaDjBpzJYNIqlNJhHZ7Ws7tltnlhhyXdyGv8jJIMBoWoZRBpZMJJCplRnPX0MKJs2purNRWnQ5hYI9dABVZDFcLFLBnABGTs++td8cQRe9Zg0qlR2dUkjNKgkYhlaLT4lhshUlYweIJRJJoTAzq5v0aCFRomT-pUwPasjRUs9gowU9RMx69hUiyXK7AhOZYGKsDjMe3boxkg0UwxBnVQrDBS8lGvWVDDvEwHzVBwgA */
    id: "nps",
    predictableActionArguments: !0,
    tsTypes: {},
    schema: {
      context: {},
      events: {},
      services: {}
    },
    on: {
      SET_SURVEY_ID: {
        actions: ["setSurveyId"]
      },
      SET_CLIENT_ID: {
        actions: ["setClientId"]
      },
      SET_MDN: {
        actions: ["setMdn"]
      },
      SET_SCORE_QUESTION_ID: {
        actions: ["setScoreQuestionId"]
      }
    },
    context: {
      surveyId: "",
      clientId: "",
      mdn: "",
      reasons: {
        PROMOTER: {
          questionId: "",
          description: "",
          reasons: []
        },
        PASSIVE: {
          questionId: "",
          description: "",
          reasons: []
        },
        DETRACTOR: {
          questionId: "",
          description: "",
          reasons: []
        }
      },
      scoreQuestionId: "",
      score: null,
      customerCategory: null,
      selectedReasons: [],
      surveyResult: null,
      errors: null
    },
    initial: "idle",
    states: {
      idle: {
        on: {
          FETCH: { target: "fetchingSurvey" }
        }
      },
      fetchingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "getSurvey",
          onDone: { target: "selectScore", actions: ["setReasonsPerCategory"] },
          onError: {
            target: "surveyUnavailable"
          }
        }
      },
      surveyUnavailable: {
        type: "final"
      },
      selectScore: {
        on: {
          SET_SCORE: {
            actions: ["setScore", "setCustomerCategory"]
          },
          SUBMIT_SCORE: {
            target: "selectReason"
          }
        }
      },
      selectReason: {
        on: {
          UPDATE_REASONS: {
            actions: ["setReasons"]
          },
          SUBMIT_NPS: "submittingSurvey"
        }
      },
      submittingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "submitSurvey",
          onDone: {
            target: "surveySubmitted",
            actions: "setSurveyResult"
          },
          onError: {
            target: "selectReason",
            actions: "setError"
          }
        }
      },
      surveySubmitted: {
        type: "final"
      }
    }
  },
  {
    actions: {
      setSurveyId: Ie({
        surveyId: (t, s) => s.id
      }),
      setClientId: Ie({
        clientId: (t, s) => s.id
      }),
      setMdn: Ie({
        mdn: (t, s) => s.mdn
      }),
      setScoreQuestionId: Ie({
        scoreQuestionId: (t, s) => s.id
      }),
      setReasonsPerCategory: Ie({
        reasons: (t, s) => s.data
      }),
      setCustomerCategory: Ie({
        customerCategory: (t, { score: s }) => s > 8 ? "PROMOTER" : s > 6 ? "PASSIVE" : s !== null ? "DETRACTOR" : null
      }),
      setScore: Ie({
        score: (t, s) => s.score
      }),
      setReasons: Ie({
        selectedReasons: (t, s) => s.selectedReasons
      }),
      setSurveyResult: Ie({
        surveyResult: (t, s) => s.data
      }),
      setError: Ie({
        errors: (t, s) => s.data.message || s.data.response.data || "Unknown error occured"
      })
    }
  }
), Rt = {
  DETRACTOR: [
    "Takes a long time to do what I want",
    "Portal was difficult to use",
    "SmartSupport was not able to address my issue",
    "Unsatisfied with service request processing",
    "Inflexible delivery arrangement"
    // 'Agent was not helpful in handling my request / query',
  ],
  PASSIVE: [
    "Time spent on getting what I want",
    "Ease of getting what I want",
    "Usefulness of SmartSupport to address my issue",
    "Satisfaction with service request processing",
    "Flexibility with delivery arrangement",
    "Satisfaction with customer service"
  ],
  PROMOTER: [
    "Minimal time spent to do what I want",
    "Portal was easy to use",
    "SmartSupport was able to address my concern",
    "Satisfied with service request processing",
    "Flexible delivery arrangement"
    // 'Agent was friendly and helpful in handling my request / query',
  ]
}, zt = (t) => {
  switch (t) {
    case "starhub":
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Portal was difficult to use",
          "SmartSupport was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of SmartSupport to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Portal was easy to use",
          "SmartSupport was able to address my concern",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
    case "asurion_techcare":
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Site was difficult to use",
          "Service was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of service to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Site is easy to use",
          "Handle errors well and help available",
          "Able to address my issues",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
    default:
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Site was difficult to use",
          "Service was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of service to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Site is easy to use",
          "Handle errors well and help available",
          "Able to address my issues",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
  }
}, Ja = Ae.lazy(() => import("./Completed-efa4b7d4.js").then((t) => ({ default: t.Completed }))), Za = Ae.lazy(() => import("./NPSReasons-164ff607.js").then((t) => ({ default: t.NPSReasons }))), Xa = Ae.lazy(() => import("./NPSSlider-1271fee7.js").then((t) => ({ default: t.NPSSlider }))), { useEffect: Ft } = Ae, ei = "SR_Creation", ti = "NPS", Zo = ({
  clientId: t,
  triggerPoint: s = ei,
  surveyType: n = ti,
  serviceRequestId: a = "",
  customerCaseNumber: r = "",
  sessionId: i = "",
  language: l = "en-US",
  mdn: c = "",
  config: o,
  onSubmit: h = ds.noop,
  onError: x = ds.noop,
  defaultScore: f = 10,
  useBrandStyle: b = !1,
  InteractionLineId: C = "",
  MobileNumber: v = "",
  retailerName: M,
  sliderDetails: g = { min: 1, max: 10, step: 1, ratings: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
}) => {
  const [j, S] = nr(Qa, {
    devTools: !1,
    services: {
      async getSurvey() {
        var D, U, _, P, A, W, se, de;
        const { data: w } = await Q({
          baseURL: o.baseUrl,
          url: o.actions.getSurvey.path,
          headers: o.headers,
          method: o.actions.getSurvey.method,
          data: {
            GetSurveyQuestions: {
              ClientId: t,
              TriggerPoint: s,
              SurveyType: n,
              ServiceRequestId: a,
              Language: l,
              SessionId: i,
              ...M && { RetailerName: M }
            }
          }
        }), d = Qn(
          (w == null ? void 0 : w.SurveyQuestions) || ((D = w.GetSurveyQuestionsResponse) == null ? void 0 : D.SurveyQuestions),
          [($) => parseInt($.DisplayOrder)]
        );
        return S("SET_CLIENT_ID", { id: t }), S("SET_SURVEY_ID", { id: d[0].SurveyId }), S("SET_SCORE_QUESTION_ID", {
          id: (U = Oe(d, { QuestionType: "NPS", QuestionOptions: "slider" })) == null ? void 0 : U.QuestionId
        }), S("SET_MDN", { mdn: c }), {
          PROMOTER: {
            questionId: (_ = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : _.QuestionId,
            description: (P = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : P.QuestionDescription,
            reasons: zt(k).PROMOTER ?? Rt.PROMOTER
          },
          PASSIVE: {
            questionId: (A = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : A.QuestionId,
            description: (W = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : W.QuestionDescription,
            reasons: zt(k).PASSIVE ?? Rt.PASSIVE
          },
          DETRACTOR: {
            questionId: (se = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : se.QuestionId,
            description: (de = Oe(
              d,
              ($) => $.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : de.QuestionDescription,
            reasons: zt(k).DETRACTOR ?? Rt.DETRACTOR
          }
        };
      },
      async submitSurvey(w) {
        let d = [];
        return w.customerCategory !== null && w.score !== null && (d = [
          {
            QuestionId: w.scoreQuestionId,
            Answer: w.score.toString()
          },
          {
            QuestionId: w.reasons[w.customerCategory].questionId,
            Answer: w.selectedReasons.join(",")
          }
        ]), (await Q({
          baseURL: o.baseUrl,
          url: o.actions.submitSurvey.path,
          headers: o.headers,
          method: o.actions.submitSurvey.method,
          data: {
            SubmitSurveyAnswers: {
              SurveyId: w.surveyId,
              ClientId: w.clientId,
              // engagementId: '',
              mobileNumber: v,
              InteractionLineId: C,
              Results: d,
              // CacheId: '',
              CustomerCaseNumber: r,
              ServiceRequestId: a
            }
          }
        })).data;
      }
    }
  }), k = Z();
  return Ft(() => {
    t && S("FETCH");
  }, [t]), Ft(() => {
    j.context.surveyResult && (h == null || h(j.context.surveyResult));
  }, [j.context.surveyResult]), Ft(() => {
    j.context.errors && (x == null || x(j.context.errors));
  }, [j.context.errors]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    j.matches("fetchingSurvey") && j.hasTag("loading") && /* @__PURE__ */ e.jsx(pn, { alignSelf: "center", justifySelf: "center" }),
    j.matches("surveyUnavailable") && /* @__PURE__ */ e.jsx(e.Fragment, { children: "Survey not available" }),
    j.matches("selectScore") && /* @__PURE__ */ e.jsx(
      Xa,
      {
        defaultScore: f,
        onSubmit: (w) => {
          S("SET_SCORE", { score: w }), S("SUBMIT_SCORE");
        },
        useBrandStyle: b,
        sliderDetails: g
      }
    ),
    (j.matches("selectReason") || j.matches("submittingSurvey")) && /* @__PURE__ */ e.jsx(
      Za,
      {
        category: j.context.customerCategory,
        loading: j.hasTag("loading"),
        description: j.context.customerCategory === null ? "" : j.context.reasons[j.context.customerCategory].description,
        reasons: j.context.customerCategory === null ? [] : j.context.reasons[j.context.customerCategory].reasons,
        onSubmit: (w) => {
          S("UPDATE_REASONS", { selectedReasons: w }), S("SUBMIT_NPS");
        }
      }
    ),
    j.matches("surveySubmitted") && /* @__PURE__ */ e.jsx(Ja, {})
  ] });
}, si = "data:image/webp;base64,UklGRpADAABXRUJQVlA4IIQDAADwFQCdASpOAEsAPnk0lUekoyIhOtbcAJAPCWwAxCF42v6WZqeSPyZ4M5Ig69g71beKH0tfMf+0HrAei30AP8B1DXoAdLv+4HpOtIreOhAt/nh7WXysJD9LZWhUMd7e21ROOpR2hhFSTvWGcht61F7jen/GgPysmfEs4w51EIdjys1e/HvulBxKU7JA04jo3G/lSmN3uSwBBnofWPz65v9Oh9aXOVg4cttvLNfL+y7iKJrz/mF7VM7AAP7+7ARD78xgCrlR/J54xegGbNZaFdRyGk6oJ1mb3uCnNLsZKNIkgCy6Aa/ZysHWnZg5KGdvekIV8HZwmjsGRgHQrXWnDbAWIjv6rshbgFiCNuxeGZcbngl3EUFHZ41oYmBQBYKKclMzxwoOXZS+HUcqzAyllRg2fGJvwJ9o8u70W/zj8nMnHpf3fs+8j9dyFF82IfhQiAkICM4UY+JTQakiAkUYz2PDKRMz68BlxA6b17tppBZSw1gdKeYqpPfx/wFvh3z1ceaxTKxv/chDP+5wDjmTy2eW/HPtwYG6ugcHGsFY7B0u6o1XQ/5M7xJSMjHBInZseqC2rXJt2l4liVK+y/gfd0Yi3BGmFQpoYp3fPFuKtGrZU4SmN73vMgqBYzyfWFaqgEEqSsxpROR0jQhBehJfdgXxSqhy3g5ojz3oUTan8unlnlaN+snpKVz27OwDsatUL22nBWqN5f5xw7N4VVx1x4Br6FYdBKOL8ZByKIoKqjrtgubaBD70Su6JA+Tz+DFOdxM+cVy/TC1BGE3zqvC7XEkQtFHA7Fu0mxvLRUW/sE0+zpIAvcm24cCzqpwWRQLLEHGAU5ncWMaOnClSTT/0KKvGu4d39PzLSA0yUdMFtL7yVKYxJM62G17/LiaQcsAQSot8epkC1BNJ5a6rCRtPqAUy4578juwC/1+7VWNdZrRLFhTahCW/b+WQG1NEqsyaw9mkYSxTv++o5p/9Q9BD//GtQmWOHjkRBlFTOxa2J+yArfFtHTVOjv53VabcS4hpUlWJ6KZk/vCRNjga9R5cWeynbIBTf6v8MJiUNBXwUvqb9ddiyNI7McR7S+lmiEyNozifjBA8lJAogj6StrBna6/Wf4gWEIBlTesPTy6F+xf1WLI+ym/thO8qnh1P2jIm/js1b+QD/l/KU59VynmITbQkYW8B+pvVCOgTJbP8ZRaAA9JAAAA=", ni = "data:image/webp;base64,UklGRuYDAABXRUJQVlA4INoDAAAwFACdASpOAEsAPnkykkekoyGhPBdKqJAPCWwAvKHvWJ5pfjPyA9pC2PgNzTh6YV/il9KvzMeeB6J/QA/vHUO7zF+6XozKCFBKbzPW+s3Ppw0czuLcVkIDx/3QaYpGN8e7BzIvPTjrdfO5wp7a2NNTUPdIAztnO1oSnKtCZkoTOybir7rX9Pq4ZbmcNDSuvpihrw4LNCujeEciElMjhv+i+6v6De/JwxCoQAD+/xIEW4tsdyOno8AnJrW6x0e7FcKRymb2nYSeslRe8wv7FJ9w2bpFHxLv4vhkbsARmLfmeX9HZAHD6hhvVdM7wbtXLezWc8hfHvCup6IqTORmK/JtgrFDyumTpk4t/3QxzW5/2nyerX3YzFVKlL2UYqjiOW0mPbFxqskynKFlfh5uX0/wVoyJ1+bRZoXZl4zEISTNbsRAkYXnX6VghHTAX58B7o/nFUbpm2Qyq+70TnI3o9FK7mbN0CdTfuR1ZqWTSg6t3Z+CGWZPY9/ozFL9dV45a2kE/9z6envXqYfQbMuAubnlmGbdGD7m0arHiIHpvjLr3kIzidSt1cLAJSx1Uy5UaSesgXX7albveY0WMb4LJvSPSm2RfvM/9mKmfEN8myG1g1fVMGSF33zCC0p2vWENh+pJJSUch9jtIRGubw61gSpAAV3pgd7AoE5e4tifWq8/M+QrYTPoFj+LZZK/fYT839/sQKpaCuOffGie8EwgMWdDD3SEgMXoVdtjU2rXMzn81dvbip1atjGGV3srB4SGMaIwo9cemtJA5PjCLhYJn8mtNR25FS9Iv4hjhEcg49cAueJk6RJaZj4hML5KDka4R0+KhqVT+7EGm+acQvsUj24mUl+X7toYVW4lmcNs5fzAoicyTSaJUgA9mDKbPL/8hG+tOsFqNSeV10iWmmde8agtylGcNIu7garXEOb3TX44eHkTOzR8TFgtbpNJSCrZWEvT2Y22vpObaYdUQ4d/0/oj4R/XqwrX/oM9MSJmFjRFr1wqhVTPvSm7BDv4QasaAJP6Iic20K/ZXvjVgeFuQPgEiD5H4ANMGloOAlvQjZY8t3k0B2I6dkIxFKZc+RMqKSQ4u9w54FWeg6rkAf21FM18pqhRGjfk7tLS4B9SSbuxOOMMchzZ+SA+0LCe04EqNdorU0Qk63zh3Om18jqgGyMthJ66VXgiXYzchSRD/ezWbnuwxWs8hrL29BJ4B8T8sqI3/Pbcl5VjV/lBp4mnUE2tOKc6H3VgBlGuJHzcSWaqeQ7Wcr/c3ekS1NwhfYV+jkIv96Cgg2Z/eQiS5ax5wFKZfK5ZiAwZAAAAAA==", ri = "data:image/webp;base64,UklGRgQEAABXRUJQVlA4IPgDAAAQFQCdASpOAEsAPoE0lEelIyIhOZTbMKAQCWwAuC3M296X5t+JT2h374/A9kJ3b0eZz9mfWH9GX+T9QD+79RX6AHSp/uZ6YBgYppnknfAMM0SZaeZw2T4S4c/LxrD912Eur7d5156ltIOBkpHEUDoyF5OZjzGpuXhEd7YswLvKwfyI/8TJYTC3XHHk0uTs5E5jFztUQrZjQqxFJWOESduotA2Z2ZOe+vCeyasISXgXHAAA/v7sBUcn7PcgRn2OXeeK3O0ZMevUqa0TVwlvvnJ5AUz1GqQklHT4UbFBzKFwDUgyOXmbktJxPUdkEXS4s6+p75nb5AeB3k30XGDq4H1COHlS+YMrDdgR1947Lnlb4OJQtR1tmNq6PvlVvbhGtHAshGJvstedsqfFLH/bleHj/ayDQy1PCMJHL8nhUudOzB74jqhds6Lebc+TywRC0G989NrnhGw6fBkD/17D9zyF6JxI40f+PdWscsp8091m8Suv9MJUux/H+E9kE+8LKANzVXBc7Aw3/RawCL3bYQxfr/P+Yrn0GRIzNwBKTXcGWeXtLPoHAqe3HsyWxo9d5qLof4oHRJ8CZcWeHXYxNNEKvtJuaciWxMBv5b2NC/36nPdCSrgFzOMLwdj3ufSALdHTLQ/9wrgSdewHh5+ApQZKNUG0OqlpT2wrXkLpWyMUo292YM6YM3lcvei/B7F/yaP6ybZI6wiKfNudUL9dj9HqBjv59jWPAXd0LISLC0mt7b24OYtlS+ULbpJBW+4DCuy2k+fmjFyuXHI15FYyWGArrFH6AAwZpwAjDQlWUQ576/TvaToQcixUlGn7AV0f8MmFKJ/dOESjkxtXmP7H+f01uq2fFc7Yhv/6XIMkIgmvOc55mFLG/BfXCxDnN/+Jpf+UAf0tGjY/u1pwqRXc89dQ1VY2yMxGcNZF1jPFLXzLsIptdciXXFO5eIcl5qMYGXtqRkiK7UyB6RB4YQGBlM5ZTDcP2TAGHl5Of/7OO1XskqMrj48i9j2zZjHS5/l3Z6Gkd5NMbX4AOpphCUlleK0Y3xNeD4LuvuZEgNj5pkWDlWAWRG416l0yBocHRvRKgCH/SPYuReG9lZdLyr0XeycODKCtY7hYY4VBl1bx1QqhsS1myg7YcsJWmqYR+4xzeaaSt/qSRY98C37ZBwv6xkps0JQKxO4Njmb8l3Z7MA/opWXPbCK4R3SRDWq+tqxE2MoBMxjDmyxBceFwetS9aorCqsgcgc6d5Kblo3PxOCBMybE7NTz8dZHNgtusUfvP6F0BD5ROMcZQtW5dlq6J+dII4zcvHMhxlHdiC7nagrcQaImMpdVnMecuN891G5j1TbpKgRZPj0AAAA==", ai = "data:image/webp;base64,UklGRoAEAABXRUJQVlA4IHQEAABwFQCdASpOAEsAPok4l0elI6IhMLO+qKARCWwAwRA5h9SQK+/it0eNP2h4+fVhtr/NL+1X6ze+P6MfQO/uXUI+gB0uPkuNIBevdxJpSoHvYxCrEb0DaD+GLCXTuuX64hheaLTMqOpVPUctmHsY7/vT/yW6Dilp04WHNJzT1yZp3YJ/DPo7ogH7M3+yy5wdD5Y2ujhi6TK0W2X5WZKhmthfmHRVaZ2PBxasxe3wCqjK+6rd2OAA/v7CBbVOww9K4rnB5mkT+D7Ou7vEfnT1VV75wbktUSPcTGmUgrcW1pAwKRLmRXDinTNyi+CfwGh0SZjRy83qlTdjkEGuV/IuQh31ih//vS/CN9gPIJvXQmT7EXDUJxMnHCM0pqNp2s5cMc86mqDm632rg8Vqkpr/vpFCxFcPtor+4yECjb2F7iBcx69221v//GXaBUChrrWBEuBuZ70ICH3+hdKrGfWFyN5eTKM4g+rLB3C8RdSk4C59ja1IWBKcGH3mh3NOP8ztqnONS39aNXcTm/Koz5DK2zrNRAtmZEWPM/9TBl8rz7RKYp36rw9RmWNAuw5uPquYQBy02cYODkHaNqEZf91d3eifU5dMInwgBtGSjr0R8OqPfd/tQMg0N8t5cej+9HcLcefVBgCTOzqZU9MRoMZNkixBDjuvhQd0mQSFim8BDETRjA8G+ZCB1MuUJvoA8PcjJWz9W24i3gpVczVH7RHV8FKfz/hwX29TrK/bFQkOiiqeypNRhHRrtlcmPxUQIePkS08pi3yZavp1tN8eAjBJxuEZMgi92SYXmr/APOo3GEN8ofqThktLqUY85unEa9JFxSKgTsB+lHEn8ElB8KEb0Fbg1ma2Jc6FJSHzRmC15O/T4D+/58YZk+0BZAVDW1ABAstnFBK5B7xHIcloNFeJnSVuWElsuZPRTugSDKdSLhhX3kw3FDPCU37bRrkPNCtZqxqVr1vVSox1Wiaod3p+4t/kOPvYJY2JLYIf6/zVChvKQY38JDzr/84NxpFZCqwVGbyEUc3j6muEtySzNaEu9bl3UICMhumxs39SjCEveuL/KAwRsVj1yzPVpMkZOvGdIyv/h4vU6Ef5ngiLZb9JNCD7YV9hlzcf9+cwYG0hzJHPSYs9OP0Fy5HK72wnFN+BHTtI/tFkIYWaIKeoKBO8iIStt5DtjQDLE9f9qD1nCIgzstyyToCkAk1f00Cyfha2Z09ePwdKVbfYF5gjFRNvRcAjHjiuMZGEgek7nSuKSlmYoSc8xnHF5td1yk66U2BfqWdmfJYZ1ejGO0+IhH2P5z+v/Dvo/bOxqafZkLxCzxl+njSk1K6A7ezCeolFMCMUtr3V31Bv5pRlPg5mYsKJrC2effN3MCH/VuRmB1nWCtQVTYg5YpNv56tksFwWq2gPQDN7PDoFyjN8119THaDeQxLLcXLyacaCmogCWK2MNCff4/3g5WS4yPB5j5pSLPtx2aBjYr0/eDofPBPCC0VL1jP9fv9iSsKeO/yDTO0MX8lEBFAAAAA=", ii = "data:image/webp;base64,UklGRsgEAABXRUJQVlA4ILwEAAAQGACdASpOAEsAPn00k0ekoyGhOFedUJAPiWwAtKnvW/6O/h/N8tf98/BnJznIhMeKR+nnWj8xHne+jD/X+oB/Seol9ADy4vZj/dmbmDSxfe828ItJrNN8nvLR8wCnrgH+eiVS+c7LU0N8l21mKbpEuCcchZ6X2pbBNCcQLpulzWfcV/sE9xX0ZZC9HQPKP5haNVT40bvkJzCtnBRKimUw1dP9nO+LUpctednZURxKJFSmyx3mGw6wj4nE967nAz+XfceHi2wepYAA/v8SCu4bPOPut8welOe97ZDj3rxOAraIwmTTGRTayPxdWf1V4OJZ3nT9MAoe7ZjAVyAI1kvJGB6O3SjKq+MLdOvsXexx0NGKUu5Img17eMfM7tXCxBN+IGFqgVYLyxlYesFXFT2un5TzE1mjdJ7fn3xvkrQPTQTLzMyV2NxRIxpp9PzNF/w0dKLN6PCsFGPH5RC2f289636TM5t2mpW5UteiMMoh6Ldr8MSmrQP8Qxxa3x0pkVW3FJ/33iQ98eH487FvmB9clmU/VVLk6V8DX3Q7WHz5WVFezVW9syqFFXeYSTYQ0AgBC4rO65UvaDMkcSc62rMpCMfx/h723rs8bII2d8ntuKqPEe0l/dTnwI9zqpH7GW1/PuePE5AztFqo9Wd5VdepscOlIJt07BXIlW17KYGu7J416RS3Kgz+D+6PuhCJM9izQPExr5h4DGHMNnrI+6mK5IHfryrXlCJmjwXWwK7niwvrO2QgmkvHpAjg4u4FxhalgTJTjT90BIgx2cvgXdo6h3ef6Kx3xKBFz9oxX4MDJnLN/uCx0rfvDBxbiwKXsvWdHMU5/NhAXa5HaeuxsX9cB1jFR8zUT9VMsuVFFpi+YRCoAPLMP5hIZy3cqBgonff4Pfi5cUPDo6Q4RX76f05fKQXGM4CER9WnsMakKJwxyB3Y/X7T++jZxqbknyWTX+beBa2+XwbKYPsBORSLAFNOQtao6Et08kyyRc+48S9ayNpmv6AdVaMVtDT/82N1p0sP/2X/bksiU01ZrMZTQnLUIvzwTr5dM9amwFWwh1wKLFyGePNE/33CvMQBcVZhfTjzCikGGDmuc9IFZqHqLrOFppVQFqAWuDmXlIhL8tK5GE4zfj10RdDxpbxjF2tiLTox8r2pPfJ6gUUu32TGZwZxaMQyVgXYC1X6MHpn8OjovoAhLEMWVBnCALfq0fs0YzWmSCacpkbFjpoJ6bCb5WRQHFQwExfq0tlW9Nokz6XaFekH0EVI+7ZwSmYvkr2gl4bT5J475lZPaqXjk43t9UA4dU6EGWf3+PG3Ko/ec8lhx4xoiXbW9aHsYNw1nmilbHtD+7wbBOEp4Vtpj/xzR2ZSnBHXEAEAzysbPLRbjqyxaPZA/YZ44OI54t12KgaHC8gx1amV7WZ9dRCVw5kImh8GXbjY9ueFm10qLVEiEbGlfUvY7RyH+no+c/bmAOafRLI69d698r8uZu42X5rct4cTyYozj5OoOsre+gal50t0I0S9U7F+8/Bl5+k/neBQse+2jefPJWzVMeSNnlGhTgN2PLiynt12Mp9oDTjGBwslA6uwERpIagWNyjuVmsY7WeshrllghFTnWD8u4AA=", pt = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), oi = q(() => import("./TextArea-d4522d6d.js").then((t) => ({ default: t.TextArea }))), it = {
  header: "Your feedback is important to us",
  suggestion: "What could we do better? Please let us know your feedback or suggestions.",
  feedback: "Great! What did you like in particular?",
  feedbackOptions: [
    "Smooth problem-free experience",
    "Super quick device assessment",
    "Step-by-step instructions",
    "Easy to follow voice instructions"
  ],
  ratings: [
    {
      icon: ii,
      label: "Very unsatisfied",
      score: 1
    },
    {
      icon: ri,
      label: "Unsatisfied",
      score: 2
    },
    {
      icon: si,
      label: "Neutral",
      score: 3
    },
    {
      icon: ni,
      label: "Satisfied",
      score: 4
    },
    {
      icon: ai,
      label: "Very Satisfied",
      score: 5
    }
  ]
}, Xo = ({ question: t, onSubmit: s }) => {
  const [n, a] = R(), [r, i] = R(""), [l, c] = R(""), [o, h] = R(0), { data: x } = ce(), { theme: f } = x, {
    components: { chat: b }
  } = f, C = ls("colors.brand.neutral", "deep"), v = ls("colors.brand.neutral", "bright"), M = "CSAT";
  return /* @__PURE__ */ e.jsxs(Je, { flexFlow: "column nowrap", align: "left", justify: "space-between", children: [
    /* @__PURE__ */ e.jsxs(Je, { flexFlow: "column nowrap", gap: 6, children: [
      /* @__PURE__ */ e.jsxs(xe, { children: [
        /* @__PURE__ */ e.jsx(
          Le,
          {
            fontSize: "32px",
            fontWeight: "light",
            letterSpacing: "-0.352px",
            lineHeight: "39.68px",
            pb: 2,
            children: /* @__PURE__ */ e.jsx(
              pt,
              {
                text: it.header,
                translationKey: `${M}/headerCSATDefaultInfo`
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Le, { fontSize: "lg", lineHeight: "22.32px", fontWeight: "light", children: t }),
        /* @__PURE__ */ e.jsx(xe, { h: "25px", mt: 4, mb: 2, children: /* @__PURE__ */ e.jsx(
          Le,
          {
            fontSize: "xl",
            color: b.btnTxtColor,
            textAlign: "center",
            fontWeight: "bold",
            children: n == null ? void 0 : n.label
          }
        ) }),
        /* @__PURE__ */ e.jsx(Je, { flexFlow: "row nowrap", align: "center", justify: "center", gap: 2, children: it.ratings.map((g) => {
          const j = g.score === (n == null ? void 0 : n.score);
          return /* @__PURE__ */ e.jsx(
            xe,
            {
              cursor: "pointer",
              border: `1px solid ${j ? "black" : C}`,
              borderRadius: 8,
              p: 4,
              _hover: {
                border: "1px solid black"
              },
              onClick: () => a(g),
              children: /* @__PURE__ */ e.jsx(xn, { src: g.icon })
            },
            `rating-${g.score}`
          );
        }) })
      ] }),
      n ? n.score < 3 ? /* @__PURE__ */ e.jsxs(xe, { children: [
        /* @__PURE__ */ e.jsxs(xe, { children: [
          /* @__PURE__ */ e.jsx(Le, { fontSize: "lg", fontWeight: "light", lineHeight: "23.76px", pb: 2, children: /* @__PURE__ */ e.jsx(
            pt,
            {
              text: it.suggestion,
              translationKey: `${M}/suggestionCSAT`
            }
          ) }),
          /* @__PURE__ */ e.jsx(
            oi,
            {
              placeholder: "Add your feedback here",
              onChange: (g) => {
                h(g.target.value.length), c(g.target.value);
              },
              maxLength: 250
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs(Le, { textAlign: "right", fontSize: "sm", color: C, children: [
          o,
          "/250"
        ] })
      ] }) : /* @__PURE__ */ e.jsxs(xe, { children: [
        /* @__PURE__ */ e.jsx(Le, { fontSize: "2xl", fontWeight: "light", lineHeight: "31.68px", pb: 2, children: /* @__PURE__ */ e.jsx(
          pt,
          {
            text: it.feedback,
            translationKey: `${M}/feedbackCSAT`
          }
        ) }),
        /* @__PURE__ */ e.jsx(gn, { columns: 2, spacing: 2, children: it.feedbackOptions.map(
          (g, j) => {
            const S = g === r;
            return /* @__PURE__ */ e.jsx(
              xe,
              {
                cursor: "pointer",
                border: `1px solid ${S ? "black" : C}`,
                borderRadius: 8,
                p: 4,
                _hover: {
                  border: "1px solid black"
                },
                onClick: () => i(g),
                children: g
              },
              `option-${j}`
            );
          }
        ) })
      ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {})
    ] }),
    /* @__PURE__ */ e.jsx(xe, { py: 6, px: 4, boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)", children: /* @__PURE__ */ e.jsx(
      mn,
      {
        w: "full",
        colorScheme: "primary",
        fontWeight: "bold",
        borderRadius: 8,
        isDisabled: !n,
        _disabled: {
          bg: v,
          color: C
        },
        _hover: {
          _disabled: {
            bg: v,
            cursor: "not-allowed"
          }
        },
        onClick: (g) => {
          g.preventDefault();
          const j = {
            rating: (n == null ? void 0 : n.score) ?? 0,
            ...r && { feedback: r },
            ...l && { suggestion: l }
          };
          s(j);
        },
        children: /* @__PURE__ */ e.jsx(pt, { text: "Next", translationKey: `${M}/nextButtonText` })
      }
    ) })
  ] });
}, xt = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), el = (t) => {
  const {
    pageTitle: s,
    title: n,
    heading: a,
    doNotRenewText: r,
    renewOptions: i,
    handleOptionChange: l,
    isDisabled: c,
    btnSubmitLBL: o,
    onClickSubmit: h,
    selectedOption: x,
    handleDonotRenew: f,
    ...b
  } = t, C = "Renewal", { data: v } = ce(), { theme: M } = v, { colors: g } = M, { bodyTextColor: j } = g;
  return /* @__PURE__ */ e.jsxs(y, { position: "relative", h: "85vh", w: "full", children: [
    /* @__PURE__ */ e.jsxs(
      y,
      {
        ...b,
        p: 2,
        alignItems: "center",
        w: { base: "full", lg: "70%" },
        margin: { base: "0", lg: "auto" },
        pb: { base: "0", lg: "20px" },
        children: [
          /* @__PURE__ */ e.jsx(y, { my: 1, children: n && /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(xt, { text: n, translationKey: `${C}/title` }) }) }),
          /* @__PURE__ */ e.jsx(
            an,
            {
              value: x,
              my: "5",
              w: { base: "full", lg: "50%" },
              mx: "auto",
              children: /* @__PURE__ */ e.jsx(St, { children: i == null ? void 0 : i.map((S, k) => /* @__PURE__ */ e.jsx(
                y,
                {
                  borderWidth: "1px",
                  borderRadius: "md",
                  borderColor: S == x ? j : "#A5AAAF",
                  border: S == x ? "2px" : "",
                  p: 4,
                  mb: 4,
                  onChange: () => {
                    l(S);
                  },
                  children: /* @__PURE__ */ e.jsxs(
                    on,
                    {
                      fontSize: "20px",
                      size: "lg",
                      value: S,
                      colorScheme: "primary",
                      children: [
                        /* @__PURE__ */ e.jsx(I, { children: /* @__PURE__ */ e.jsx(
                          xt,
                          {
                            text: S == null ? void 0 : S.name,
                            translationKey: `${C}/renewalOption${k + 1}`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(I, { fontSize: "14px", children: S == null ? void 0 : S.discount })
                      ]
                    },
                    S
                  )
                },
                S
              )) })
            }
          ),
          /* @__PURE__ */ e.jsx(L, { justify: "center", children: /* @__PURE__ */ e.jsx(
            ie,
            {
              variant: "link",
              colorScheme: g.primary,
              color: g.primary,
              onClick: () => f(),
              textAlign: "center",
              textDecoration: "underline",
              children: /* @__PURE__ */ e.jsx(I, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                xt,
                {
                  text: r,
                  translationKey: `${C}/doNotRenewText`
                }
              ) })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(L, { w: "full", position: "absolute", bottom: "0px", m: "auto", children: /* @__PURE__ */ e.jsx(
      ie,
      {
        w: { base: "full", lg: "30%" },
        m: "auto",
        color: "white",
        colorScheme: "primary",
        bg: c ? "gray.200" : g.primary,
        cursor: c ? "not-allowed" : "pointer",
        disabled: c,
        onClick: () => c ? void 0 : h && h(),
        children: o && /* @__PURE__ */ e.jsx(xt, { text: o, translationKey: "Global/Submit" })
      }
    ) })
  ] });
}, Me = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), tl = (t) => {
  const {
    heading: s,
    plan: n,
    priceLBL: a,
    mdn: r,
    priceValue: i,
    prevPriceValue: l,
    nextBillingDateLBL: c,
    nextBillingDateValue: o,
    showSwitchSection: h,
    switchToSaveText: x,
    switchText: f,
    handleSwitchClick: b,
    paymentMethodLBL: C,
    cardNumber: v,
    cardImage: M,
    changeText: g,
    handleChange: j,
    btnConfirmLBL: S,
    // isDisabled,
    onClickSubmit: k,
    ...w
  } = t, d = "RenewalConfirmation", { data: D } = ce(), { theme: U } = D, { colors: _ } = U;
  return R(), /* @__PURE__ */ e.jsx(y, { h: "85vh", children: /* @__PURE__ */ e.jsxs(
    y,
    {
      ...w,
      p: 2,
      alignItems: "center",
      w: "full",
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(y, { my: 1, children: s && /* @__PURE__ */ e.jsx(I, { fontSize: "24px", children: /* @__PURE__ */ e.jsx(Me, { text: s, translationKey: `${d}/heading` }) }) }),
        /* @__PURE__ */ e.jsx(y, { my: 1, children: n && /* @__PURE__ */ e.jsx(I, { fontSize: "18px", children: /* @__PURE__ */ e.jsx(Me, { text: n, translationKey: `Global/${n}` }) }) }),
        /* @__PURE__ */ e.jsx(y, { fontWeight: "700", my: 1, fontSize: "32px", children: /* @__PURE__ */ e.jsx(I, { children: r }) }),
        /* @__PURE__ */ e.jsxs(L, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(L, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(I, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(Me, { text: a, translationKey: `${d}/priceLBL` }) }),
            l && /* @__PURE__ */ e.jsx(I, { fontSize: "18px", children: /* @__PURE__ */ e.jsx("del", { children: l }) }),
            /* @__PURE__ */ e.jsx(I, { fontSize: "18px", children: i })
          ] }),
          /* @__PURE__ */ e.jsxs(L, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(I, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(
              Me,
              {
                text: c,
                translationKey: `${d}/nextBillingDateLBL`
              }
            ) }),
            /* @__PURE__ */ e.jsx(I, { fontSize: "18px", children: o })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          "hr",
          {
            style: {
              margin: "8px -8px 12px -8px",
              border: "none",
              borderTop: "1px solid #adaaaa"
            }
          }
        ),
        h && /* @__PURE__ */ e.jsxs(
          L,
          {
            direction: "row",
            justify: "space-between",
            p: "3",
            bg: "#F0F0F5",
            borderRadius: "10px",
            align: "center",
            children: [
              /* @__PURE__ */ e.jsx(I, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(
                Me,
                {
                  text: x,
                  translationKey: `${d}/switchToSaveText`
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                y,
                {
                  py: "1",
                  px: "3",
                  border: `1px solid ${_.primary}`,
                  borderRadius: "10px",
                  onClick: () => b(),
                  cursor: "pointer",
                  h: "auto",
                  children: /* @__PURE__ */ e.jsx(I, { fontWeight: "700", color: _.primary, children: /* @__PURE__ */ e.jsx(
                    Me,
                    {
                      text: f,
                      translationKey: `${d}/switchText`
                    }
                  ) })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(y, { mt: "4", mb: 2, children: C && /* @__PURE__ */ e.jsx(I, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(
          Me,
          {
            text: C,
            translationKey: `${d}/paymentMethodLBL`
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(y, { my: 1, children: /* @__PURE__ */ e.jsxs(L, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(L, { direction: "row", children: [
            /* @__PURE__ */ e.jsx(I, { fontSize: "18px", children: v }),
            M && M
          ] }),
          /* @__PURE__ */ e.jsx(
            I,
            {
              fontWeight: "700",
              fontSize: "18px",
              textDecorationLine: "underline",
              color: _.primary,
              cursor: "pointer",
              onClick: (P) => j(P),
              children: /* @__PURE__ */ e.jsx(
                Me,
                {
                  text: g,
                  translationKey: `${d}/changeText`
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(
          y,
          {
            w: { base: "90%", lg: "75%" },
            style: {
              position: "absolute",
              bottom: "0px",
              // width: `calc(100% - 50px)`,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ e.jsx(
              ie,
              {
                color: "white",
                colorScheme: "primary",
                onClick: () => k(),
                w: { base: "full", lg: "30%" },
                children: S && /* @__PURE__ */ e.jsx(Me, { text: S, translationKey: "Global/Confirm" })
              }
            )
          }
        )
      ]
    }
  ) });
}, _t = q(() => import("./myasurion-shared.components.es.js").then((t) => ({ default: t.TextScript }))), sl = ({ highfive: t, onCancelClick: s, pageName: n = "ConfirmDeviceRegistration" }) => (ce(), /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsx(y, { w: { base: "full", lg: "80%" }, margin: "auto", pt: "50px", children: /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsxs(
  y,
  {
    id: "myasurion-profile-avatar",
    w: { base: "full", lg: "80%" },
    margin: "0 auto",
    h: "auto",
    p: "1rem",
    textAlign: "center",
    children: [
      /* @__PURE__ */ e.jsx(dt, { marginX: "auto", src: t, alt: "your model" }),
      /* @__PURE__ */ e.jsx(I, { mt: "5", fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(
        _t,
        {
          text: "Thank you for registering",
          translationKey: `${n}/header`
        }
      ) }),
      /* @__PURE__ */ e.jsx(I, { mt: "5", whiteSpace: "pre-line", children: /* @__PURE__ */ e.jsx(
        _t,
        {
          text: "Please follow the instructions to complete your personal and all device info registering. After registered, you can check main page for the coverage check or service track.",
          translationKey: `${n}/subHeader`
        }
      ) }),
      /* @__PURE__ */ e.jsx(
        y,
        {
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          width: "full",
          bg: "white",
          p: 4,
          style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" },
          children: /* @__PURE__ */ e.jsx(
            ie,
            {
              my: "5",
              textAlign: "center",
              colorScheme: "primary",
              variant: "link",
              cursor: "pointer",
              onClick: s,
              textDecoration: "underline",
              children: /* @__PURE__ */ e.jsx(
                _t,
                {
                  text: "Go back to home",
                  translationKey: `${n}/goBackBtn`
                }
              )
            }
          )
        }
      )
    ]
  }
) }) }) })), Bt = ({ children: t }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: t ?? /* @__PURE__ */ e.jsxs(is, { children: [
  /* @__PURE__ */ e.jsx(Ge, { children: /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
    X,
    {
      text: "At least 10 characters long",
      translationKey: "ChangePassword/password-requirements-rule-1"
    }
  ) }) }),
  /* @__PURE__ */ e.jsxs(Ge, { children: [
    /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
      X,
      {
        text: "Must contain a combination of 4 out of 4 of the following attributes:",
        translationKey: "ChangePassword/password-requirements-rule-header"
      }
    ) }),
    /* @__PURE__ */ e.jsxs(is, { children: [
      /* @__PURE__ */ e.jsx(Ge, { children: /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
        X,
        {
          text: "At least one uppercase letter (A-Z)",
          translationKey: "ChangePassword/password-requirements-rule-2"
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(Ge, { children: /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
        X,
        {
          text: "At least one lowercase letter (a-z)",
          translationKey: "ChangePassword/password-requirements-rule-3"
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(Ge, { children: /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
        X,
        {
          text: "At least one special character (!@#$%&*)",
          translationKey: "ChangePassword/password-requirements-rule-4"
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(Ge, { children: /* @__PURE__ */ e.jsx(y, { fontSize: "md", children: /* @__PURE__ */ e.jsx(
        X,
        {
          text: "At least one numeric character (0-9)",
          translationKey: "ChangePassword/password-requirements-rule-5"
        }
      ) }) })
    ] })
  ] })
] }) }), { useEffect: li } = Ae, ci = ({ onChange: t = Qt }) => {
  const { values: s, errors: n } = rr();
  return li(() => {
    t == null || t(s, n);
  }, [s, n]), null;
}, di = ln(ar), ui = ({
  id: t,
  submitLabel: s = "Submit",
  onChange: n = Qt,
  hasDefaultControls: a = !0,
  sx: r,
  children: i
}) => {
  const [l] = zs(i, {
    buttons: Wt
  });
  return /* @__PURE__ */ e.jsxs(
    di,
    {
      id: t,
      display: "flex",
      flexDirection: "column",
      h: "full",
      justifyContent: "space-between",
      sx: r,
      children: [
        mt.Children.toArray(i).filter(
          (c) => {
            var o;
            return mt.isValidElement(c) && c.type !== ((o = l.buttons) == null ? void 0 : o.type);
          }
        ),
        /* @__PURE__ */ e.jsx(ci, { onChange: n }),
        a && (l.buttons ?? /* @__PURE__ */ e.jsx(Wt, { type: "submit", w: "full", children: s }))
      ]
    }
  );
}, hi = Object.assign(ui, {
  Button: Wt
}), Ls = {
  oldPassword: Et().required("Please kindly use the password you have registered"),
  newPassword: Et().required("No password provided").min(10, "The password entered is not long enough").test({
    name: "has-cap",
    exclusive: !0,
    message: "Password must have an uppercase letter",
    test: (t) => /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]/.test(t)
  }).test({
    name: "has-lower",
    exclusive: !0,
    message: "The password does not have a lowercase letter",
    test: (t) => /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]/.test(t)
  }).test({
    name: "has-integer",
    exclusive: !0,
    message: "The password does not have integer",
    test: (t) => /^(?=.*\d+)[A-Za-z\d!@#$%&*]/.test(t)
  }).test({
    name: "has-special",
    exclusive: !0,
    message: "Password should have (and be limited to) these special characters: !@#$%&*",
    test: (t) => Jn(Zn([
      /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[!@#$%&*]+)^[A-Za-z\d!@#$%&*]{10,}$/
    ], (a) => a.test(t))) === 4
  }),
  // .test({
  //     name: 'is-valid-pattern',
  //     exclusive: true,
  //     message:
  //         'Password must contain at least one uppercase letter, one lowercase letter, one numeric character and one special character',
  //     test: (value: string) => {
  //         const patterns = [
  //             /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[!@#$%&*]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //         ];
  //         const matched = sum(map(patterns, (pattern) => pattern.test(value)));
  //         return matched >= 3;
  //     },
  // }),
  confirmNewPassword: Et().when("newPassword", (t, s) => t ? s.required("Confirm Password is required") : s).oneOf([or("newPassword"), ""], "Your passwords do not match")
}, fs = Es(Ls), pi = Es(Xn(Ls, "oldPassword"));
var xi = /* @__PURE__ */ ((t) => (t.CHANGE = "change", t.RESET = "reset", t.NEW = "new", t))(xi || {});
const gi = {
  new: pi,
  change: fs,
  reset: fs
}, Ot = ({ placeholder: t, border: s, ...n }) => {
  const [a, r] = R(), i = Ss(null), l = () => r(!0), c = () => r(!1);
  return yt("focus", l, i), yt("blur", c, i), /* @__PURE__ */ e.jsxs(y, { position: "relative", children: [
    a && /* @__PURE__ */ e.jsx(
      y,
      {
        pos: "absolute",
        top: "2px",
        left: "10px",
        fontSize: "sm",
        fontWeight: 400,
        color: "gray.500",
        children: t
      }
    ),
    /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx(
      bt,
      {
        type: "password",
        p: a ? "8px 12px" : "12px",
        minH: "56px",
        border: s || void 0,
        placeholder: a ? "" : t,
        ref: i,
        onFocus: l,
        onBlur: c,
        ...n
      }
    ) })
  ] });
}, mi = ({
  title: t,
  isLoading: s = !1,
  mode: n = "new",
  apiErrors: a = {},
  initialValues: r = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  },
  initialErrors: i = {},
  schema: l,
  onSubmit: c = cs,
  onChange: o = cs,
  hashingFn: h = wn,
  hashingFnParams: x = [""],
  formId: f = tr("form-password-reset-"),
  sx: b,
  children: C
}) => {
  const [v] = zs(C, {
    helperText: Bt
  });
  l = l ?? gi[n];
  const M = (S) => S.preventDefault(), [g, j] = R(!1);
  return /* @__PURE__ */ e.jsx(
    ir,
    {
      initialValues: r,
      enableReinitialize: !0,
      initialErrors: i,
      validationSchema: l,
      onSubmit: (S) => {
        j(!0), er(() => {
          const k = h.apply(null, [
            S.oldPassword ?? "",
            ...x
          ]), w = h.apply(null, [
            S.newPassword ?? "",
            ...x
          ]);
          c({
            ...S,
            oldPassword: k,
            newPassword: w
          }), j(!1);
        }, 1e3);
      },
      children: ({ isValid: S, dirty: k }) => /* @__PURE__ */ e.jsx(hi, { id: f, onChange: o, sx: b, hasDefaultControls: !1, children: /* @__PURE__ */ e.jsxs(Ke, { w: "full", h: "full", justifyContent: "space-between", children: [
        /* @__PURE__ */ e.jsxs(Ke, { gap: 4, w: "full", children: [
          /* @__PURE__ */ e.jsx(
            vs,
            {
              w: "full",
              letterSpacing: -0.352,
              fontWeight: "light",
              lineHeight: "shorter",
              fontSize: "2rem",
              children: t || "Change password"
            }
          ),
          n === "change" && /* @__PURE__ */ e.jsx(kt, { name: "oldPassword", children: ({ field: w, form: d }) => /* @__PURE__ */ e.jsxs(
            Re,
            {
              isInvalid: d.errors.oldPassword && d.touched.oldPassword || a && a.oldPassword && a.oldPassword.length > 0,
              children: [
                /* @__PURE__ */ e.jsx(
                  Ot,
                  {
                    placeholder: "Current password",
                    isDisabled: s || g,
                    onPaste: M,
                    ...w
                  }
                ),
                /* @__PURE__ */ e.jsx(ze, { children: d.errors.oldPassword || a.oldPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { fontWeight: "light", lineHeight: "shorter", fontSize: "xl", children: /* @__PURE__ */ e.jsx(
            X,
            {
              text: "Your password must meet the following requirements:",
              translationKey: "ChangePassword/password-requirements-header"
            }
          ) }),
          v.helperText ?? /* @__PURE__ */ e.jsx(Bt, {}),
          /* @__PURE__ */ e.jsx(kt, { name: "newPassword", children: ({ field: w, form: d }) => /* @__PURE__ */ e.jsxs(
            Re,
            {
              isInvalid: d.errors.newPassword && d.touched.newPassword || a && a.newPassword && a.newPassword.length > 0,
              children: [
                /* @__PURE__ */ e.jsx(
                  Ot,
                  {
                    placeholder: "New password",
                    isDisabled: s || g,
                    border: S && k ? "2px solid green" : "1px solid black",
                    onPaste: M,
                    ...w
                  }
                ),
                /* @__PURE__ */ e.jsx(ze, { children: d.errors.newPassword || a.newPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ e.jsx(kt, { name: "confirmNewPassword", children: ({ field: w, form: d }) => /* @__PURE__ */ e.jsxs(
            Re,
            {
              isInvalid: d.errors.confirmNewPassword && d.touched.confirmNewPassword || a && a.confirmNewPassword && a.confirmNewPassword.length > 0,
              children: [
                /* @__PURE__ */ e.jsx(
                  Ot,
                  {
                    placeholder: "Confirm New password",
                    isDisabled: s || g,
                    border: S && k ? "2px solid green" : "1px solid black",
                    isValid: S,
                    onPaste: M,
                    ...w
                  }
                ),
                /* @__PURE__ */ e.jsx(ze, { children: d.errors.confirmNewPassword || a.confirmNewPassword })
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            w: "full",
            type: "submit",
            isLoading: s || g,
            isDisabled: !k || !S,
            bgColor: { base: "primary.500", md: "black" },
            children: "Proceed"
          }
        )
      ] }) })
    }
  );
}, nl = Object.assign(mi, { HelperText: Bt });
export {
  Lo as $,
  mo as A,
  fo as B,
  Ho as C,
  ns as D,
  _r as E,
  us as F,
  yo as G,
  Na as H,
  So as I,
  vo as J,
  No as K,
  Ia as L,
  xs as M,
  Qo as N,
  bo as O,
  nl as P,
  Co as Q,
  el as R,
  Aa as S,
  X as T,
  To as U,
  Jo as V,
  Oo as W,
  wo as X,
  jo as Y,
  Mo as Z,
  ss as _,
  Ca as a,
  Eo as a0,
  ko as a1,
  Ao as a2,
  Uo as a3,
  Po as a4,
  Ro as a5,
  Ko as a6,
  zo as a7,
  Io as a8,
  Fo as a9,
  $o as aa,
  Vr as ab,
  Do as ac,
  zt as ad,
  Rt as ae,
  Ds as af,
  ca as ag,
  rt as ah,
  Jr as ai,
  _o as aj,
  Br as ak,
  Go as al,
  xo as am,
  Bo as an,
  dr as ao,
  pr as ap,
  yr as aq,
  zs as ar,
  Gr as as,
  Wo as at,
  Wr as au,
  K as av,
  go as aw,
  qt as b,
  Yo as c,
  $a as d,
  Zo as e,
  Xo as f,
  Qe as g,
  tl as h,
  sl as i,
  pi as j,
  fs as k,
  xi as l,
  co as m,
  Nt as n,
  Vo as o,
  qo as p,
  uo as q,
  ho as r,
  po as s,
  Fs as t,
  ce as u,
  Rs as v,
  Fr as w,
  Dr as x,
  Rr as y,
  Tt as z
};
